import { Language } from '../types'

export const translations: Record<string, Record<Language, string>> = {
  // --- NAVIGATION ---
  'nav.home': {
    en: 'Home',
    id: 'Beranda',
    ms: 'Laman Utama',
    th: 'หน้าแรก',
    vi: 'Trang chủ',
    fil: 'Tahanan',
    km: 'ទំព័រដើម',
    lo: 'ໜ້າຫຼັກ',
    my: 'ပင်မစာမျက်နှာ',
  },
  'nav.checkScam': {
    en: 'Check Scam',
    id: 'Cek Penipuan',
    ms: 'Semak Penipuan',
    th: 'ตรวจสอบการหลอกลวง',
    vi: 'Kiểm tra lừa đảo',
    fil: 'Suriin ang Scam',
    km: 'ពិនិត្យការបោកប្រាស់',
    lo: 'ກວດສອບການຫຼອກລວງ',
    my: 'လိမ်လည်မှုစစ်ဆေးရန်',
  },
  'nav.emergency': {
    en: 'Emergency Protocol',
    id: 'Protokol Darurat',
    ms: 'Protokol Kecemasan',
    th: 'โปรโตคอลฉุกเฉิน',
    vi: 'Giao thức khẩn cấp',
    fil: 'Protokol sa Emergency',
    km: 'ពិធីសារសង្គ្រោះបន្ទាន់',
    lo: 'ມາດຕະການສຸກເສີນ',
    my: 'အရေးပေါပ်လုပ်ထုံးလုပ်နည်း',
  },
  'nav.protocols': {
    en: 'Protocols',
    id: 'Protokol',
    ms: 'Protokol',
    th: 'โปรโตคอล',
    vi: 'Giao thức',
    fil: 'Mga Protokol',
    km: 'ពិធីសារ',
    lo: 'ມາດຕະການ',
    my: 'လုပ်ထုံးလုပ်နည်းများ',
  },
  'nav.report': {
    en: 'Where to Report',
    id: 'Tempat Melapor',
    ms: 'Di Mana Nak Lapor',
    th: 'แจ้งเหตุที่ไหน',
    vi: 'Báo cáo ở đâu',
    fil: 'Saan Mag-report',
    km: 'កន្លែងរាយការណ៍',
    lo: 'ບ່ອນແຈ້ງຄວາມ',
    my: 'တိုင်ကြားရန်နေရာ',
  },
  'nav.education': {
    en: 'Education',
    id: 'Edukasi',
    ms: 'Pendidikan',
    th: 'การศึกษา',
    vi: 'Giáo dục',
    fil: 'Edukasyon',
    km: 'ការអប់រំ',
    lo: 'ການສຶກສາ',
    my: 'ပညာရေး',
  },
  'nav.about': {
    en: 'About',
    id: 'Tentang',
    ms: 'Mengenai',
    th: 'เกี่ยวกับ',
    vi: 'Giới thiệu',
    fil: 'Tungkol',
    km: 'អំពី',
    lo: 'ກ່ຽວກັບ',
    my: 'အကြောင်း',
  },
  'nav.evidenceSafety': {
    en: 'Evidence & Safety',
    id: 'Bukti & Keamanan',
    ms: 'Bukti & Keselamatan',
    th: 'หลักฐานและความปลอดภัย',
    vi: 'Bằng chứng & An toàn',
    fil: 'Ebidensya at Kaligtasan',
    km: 'ភស្តុតាង និងសុវត្ថិភាព',
    lo: 'ຫຼັກຖານ ແລະ ຄວາມປອດໄພ',
    my: 'သက်သေနှင့် ဘေးကင်းရေး',
  },
  'nav.reportTemplate': {
    en: 'Report Template',
    id: 'Templat Laporan',
    ms: 'Templat Laporan',
    th: 'เทมเพลตรายงาน',
    vi: 'Mẫu báo cáo',
    fil: 'Template ng Ulat',
    km: 'គំរូរបាយការណ៍',
    lo: 'ແບບຟອມລາຍງານ',
    my: 'တိုင်ကြားစာ ပုံစံ',
  },
  'nav.whereToReport': {
    en: 'Reporting Channels',
    id: 'Saluran Pelaporan',
    ms: 'Saluran Pelaporan',
    th: 'ช่องทางการรายงาน',
    vi: 'Kênh báo cáo',
    fil: 'Mga Channel ng Pag-uulat',
    km: 'ឆានែលរាយការណ៍',
    lo: 'ຊ່ອງທາງການລາຍງານ',
    my: 'တိုင်ကြားရန် လမ်းကြောင်းများ',
  },
  'nav.educationCenter': {
    en: 'Education Center',
    id: 'Pusat Edukasi',
    ms: 'Pusat Pendidikan',
    th: 'ศูนย์การศึกษา',
    vi: 'Trung tâm Giáo dục',
    fil: 'Sentro ng Edukasyon',
    km: 'មជ្ឈមណ្ឌលអប់រំ',
    lo: 'ສູນການສຶກສາ',
    my: 'ပညာပေး စင်တာ',
  },
  'nav.internationalFramework': {
    en: 'International Framework',
    id: 'Kerangka Internasional',
    ms: 'Rangka Kerja Antarabangsa',
    th: 'กรอบการทำงานระหว่างประเทศ',
    vi: 'Khung quốc tế',
    fil: 'Internasyonal na Balangkas',
    km: 'ក្របខ័ណ្ឌអន្តរជាតិ',
    lo: 'ກອບສາກົນ',
    my: 'နိုင်ငံတကာ မူဘောင်',
  },
  'nav.cyberQuiz': {
    en: 'Cyber Quiz',
    id: 'Kuis Siber',
    ms: 'Kuiz Siber',
    th: 'แบบทดสอบไซเบอร์',
    vi: 'Câu đố mạng',
    fil: 'Cyber Quiz',
    km: 'សំណួរតាមអ៊ីនធឺណិត',
    lo: 'ແບບທົດສອບໄຊເບີ',
    my: 'ဆိုက်ဘာ ပဟေဠီ',
  },
  'nav.events': {
    en: 'Events',
    id: 'Acara',
    ms: 'Acara',
    th: 'กิจกรรม',
    vi: 'Sự kiện',
    fil: 'Mga Kaganapan',
    km: 'ព្រឹត្តិការណ៍',
    lo: 'ກິດຈະກຳ',
    my: 'ပွဲများ',
  },
  'nav.tools': {
    en: 'Tools',
    id: 'Alat',
    ms: 'Alat',
    th: 'เครื่องมือ',
    vi: 'Công cụ',
    fil: 'Mga Tool',
    km: 'ឧបករណ៍',
    lo: 'ເຄື່ອງມື',
    my: 'ကိရိယာများ',
  },
  'nav.resources': {
    en: 'Resources',
    id: 'Sumber Daya',
    ms: 'Sumber',
    th: 'แหล่งข้อมูล',
    vi: 'Tài nguyên',
    fil: 'Mga Mapagkukunan',
    km: 'ធនធាន',
    lo: 'ຊັບພະຍາກອນ',
    my: 'အရင်းအမြစ်များ',
  },

  // --- SEO METADATA ---
  'seo.home.title': {
    en: 'ASEAN Scam Prevention & Reporting Hub',
    id: 'Pusat Pencegahan & Pelaporan Penipuan ASEAN',
    ms: 'Pusat Pencegahan & Pelaporan Penipuan ASEAN',
    th: 'ศูนย์ป้องกันและรายงานการหลอกลวงอาเซียน',
    vi: 'Trung tâm Phòng chống & Báo cáo Lừa đảo ASEAN',
    fil: 'Sentro ng Pag-iwas at Pag-uulat ng Scam sa ASEAN',
    km: 'មជ្ឈមណ្ឌលបង្ការ និងរាយការណ៍ការបោកប្រាស់អាស៊ីអាគ្នេយ៍',
    lo: 'ສູນປ້ອງກັນ ແລະ ການລາຍງານການຫຼອກລວງອາຊຽນ',
    my: 'အာဆီယံ လိမ်လည်းမှုကာကွယ်ရေးနှင့် တိုင်ကြားမှု ဗဟိုဌာန',
  },
  'seo.home.desc': {
    en: 'Official resource for scam prevention, emergency protocols, and reporting across Southeast Asia. Protect yourself from digital fraud.',
    id: 'Sumber resmi untuk pencegahan penipuan, protokol darurat, dan pelaporan di seluruh Asia Tenggara. Lindungi diri Anda dari penipuan digital.',
    ms: 'Sumber rasmi untuk pencegahan penipuan, protokol kecemasan, dan pelaporan di seluruh Asia Tenggara. Lindungi diri anda daripada penipuan digital.',
    th: 'แหล่งข้อมูลอย่างเป็นทางการสำหรับการป้องกันการหลอกลวง โปรโตคอลฉุกเฉิน และการรายงานทั่วเอเชียตะวันออกเฉียงใต้ ปกป้องตัวคุณเองจากการฉ้อโกงทางดิจิทัล',
    vi: 'Nguồn chính thức về phòng chống lừa đảo, giao thức khẩn cấp và báo cáo trên khắp Đông Nam Á. Bảo vệ bản thân khỏi gian lận kỹ thuật số.',
    fil: 'Opisyal na mapagkukunan para sa pag-iwas sa scam, mga protocol ng emergency, at pag-uulat sa buong Southeast Asia. Protektahan ang iyong sarili mula sa digital fraud.',
    km: 'ធនធានផ្លូវការសម្រាប់ការបង្ការការបោកប្រាស, ពិធីសារសង្គ្រោះបន្ទាន់ និងការរាយការណ៍នៅទូទាំងអាស៊ីអាគ្នេយ៍។ ការពារខ្លួនអ្នកពីការបោកប្រាស់តាមប្រព័ន្ធដីជីថល។',
    lo: 'ແຫຼ່ງຂໍ້ມູນທາງການສຳລັບການປ້ອງກັນການຫຼອກລວງ, ມາດຕະການສຸກເສີນ, ແລະ ການລາຍງານທົ່ວອາຊີຕາເວັນອອກສຽງໃຕ້. ປົກປ້ອງຕົວເອງຈາກການໂກງທາງດິຈິຕອນ.',
    my: 'အရှေ့တောင်အာရှတစ်ဝှမ်း လိမ်လည်းမှုကာကွယ်ရေး၊ အရေးပေါ်လုပ်ထုံးလုပ်နည်းများနှင့် တိုင်ကြားမှုများအတွက် တရားဝင်အရင်းအမြစ်။ ဗဟိုဌာန ဥပဒေရေးအတွက် ဖုံးကာ။',
  },
  'seo.about.title': {
    en: 'About genZAFE - Our Mission',
    id: 'Tentang genZAFE - Misi Kami',
    ms: 'Mengenai genZAFE - Misi Kami',
    th: 'เกี่ยวกับ genZAFE - ภารกิจของเรา',
    vi: 'Về genZAFE - Sứ mệnh của chúng tôi',
    fil: 'Tungkol sa genZAFE - Ang Aming Misyon',
    km: 'អំពី genZAFE - បេសកកម្មរបស់យើង',
    lo: 'ກ່ຽວກັບ genZAFE - ພາລະກິດຂອງພວກເຮົາ',
    my: 'genZAFE အကြောင်း - ကျွန်ုပ်တို့၏ ရည်မှန်းချက်',
  },
  'seo.about.desc': {
    en: "Learn about genZAFE's mission to create a fraud-free ASEAN region through education, prevention, and cross-border cooperation.",
    id: 'Pelajari misi genZAFE untuk menciptakan kawasan ASEAN yang bebas penipuan melalui pendidikan, pencegahan, dan kerja sama lintas batas.',
    ms: 'Ketahui misi genZAFE untuk mewujudkan rantau ASEAN bebas penipuan melalui pendidikan, pencegahan, dan kerjasama rentas sempadan.',
    th: 'เรียนรู้เกี่ยวกับภารกิจของ genZAFE เพื่อสร้างภูมิภาคอาเซียนที่ปลอดการฉ้อโกงผ่านการศึกษา การป้องกัน และความร่วมมือข้ามพรมแดน',
    vi: 'Tìm hiểu về sứ mệnh của genZAFE nhằm tạo ra một khu vực ASEAN không có gian lận thông qua giáo dục, phòng ngừa và hợp tác xuyên biên giới.',
    fil: 'Alamin ang tungkol sa mga misyon ng genZAFE na lumikha ng isang rehiyong ASEAN na walang pandaraya sa pamamagitan ng edukasyon, pag-iwas, at pakikipagtulungan sa cross-border.',
    km: 'ស្វែងយល់អំពីបេសកកម្មរបស់ genZAFE ដើម្បីបង្កើតតំបន់អាស៊ីអាគ្នេយ៍ដែលគ្មានការបោកប្រាស់ តាមរយៈការអប់រំ ការបង្ការ និងកិច្ចសហប្រតិបត្តិការក្រោយព្រំដែន។',
    lo: 'ຮຽນຮູ້ກ່ຽວກັບພາລະກິດຂອງ genZAFE ເພື່ອສ້າງພາກພື້ນອາຊຽນທີ່ປອດຈາກການໂກງຜ່ານການສຶກສາ, ການປ້ອງກັນ, ແລະ ການຮ່ວມມືຂ້າມຊາຍແດນ.',
    my: 'ပညာပေးခြင်း၊ ကာကွယ်ခြင်းနှင့် နယ်စပ်ဖြတ်ကျော် ပူးပေါင်းဆောင်နိုင်ရန် genZAFE ၏ ရည်မှန်းချက်အကြောင်း လေ့လာပါ။',
  },
  'seo.education.title': {
    en: 'Scam Education Center',
    id: 'Pusat Edukasi Penipuan',
    ms: 'Pusat Pendidikan Penipuan',
    th: 'ศูนย์การศึกษาเรื่องการหลอกลวง',
    vi: 'Trung tâm Giáo dục Lừa đảo',
    fil: 'Sentro ng Edukasyon sa Scam',
    km: 'មជ្ឈមណ្ឌលអប់រំអំពីការបោកប្រាស់',
    lo: 'ສູນການສຶກສາເລື່ອງການຫຼອກລວງ',
    my: 'လိမ်လည်မှု ပညာပေး စင်တာ',
  },
  'seo.education.desc': {
    en: 'Learn about common scam tactics including social engineering, investment fraud, and romance scams. Knowledge is your best defense.',
    id: 'Pelajari taktik penipuan umum termasuk rekayasa sosial, penipuan investasi, dan penipuan asmara. Pengetahuan adalah pertahanan terbaik Anda.',
    ms: 'Ketahui taktik penipuan biasa termasuk kejuruteraan sosial, penipuan pelaburan, dan penipuan percintaan. Pengetahuan adalah pertahanan terbaik anda.',
    th: 'เรียนรู้เกี่ยวกับกลยุทธ์การหลอกลวงทั่วไป รวมถึงวิศวกรรมสังคม การฉ้อโกงการลงทุน และการหลอกลวงทางความรัก ความรู้คือการป้องกันที่ดีที่สุดของคุณ',
    vi: 'Tìm hiểu về các chiến thuật lừa đảo phổ biến bao gồm kỹ thuật xã hội, gian lận đầu tư và lừa đảo tình cảm. Kiến thức là sự bảo vệ tốt nhất của bạn.',
    fil: 'Alamin ang tungkol sa mga karaniwang taktika ng scam kabilang ang social engineering, investment fraud, at romance scams. Ang kaalaman ang iyong pinakamahusay na depensa.',
    km: 'ស្វែងយល់អំពីយុទ្ធសាស្ត្របោកប្រាស់ទូទៅ រួមទាំងវិស្វកម្មសង្គម ការបោកប្រាស់ការវិនិយោគ និងការបោកប្រាស់ស្នេហា។ ចំណេះដឹងគឺជាការការពារដ៏ល្អបំផុតរបស់អ្នក។',
    lo: 'ຮຽນຮູ້ກ່ຽວກັບກົນລະຍຸດການຫຼອກລວງທົ່ວໄປ ລວມທັງວິສະວະກຳສັງຄົມ, ການໂກງການລົງທຶນ, ແລະ ການຫຼອກລວງທາງຄວາມຮັກ. ຄວາມຮູ້ແມ່ນການປ້ອງກັນທີ່ດີທີ່ສຸດຂອງທ່ານ.',
    my: 'လူမှုအင်ဂျင်နီယာ၊ ရင်းနှီးမြှုပ်နှံမှု လိမ်းလည်ခြင်းနှင့် အချစ်ရေး လိမ်းလည်မှုများ အပါအဝင် အဖြစ်များသော လိမ်းလည်မှု နည်းဗျူဟာများအကြောင်း လေ့လာပါ။ အသိပညာသည် သင်၏ အကောင်းဆုံး ကာကွယ်မှု ဖြစ်သည်။',
  },
  'seo.emergency.title': {
    en: 'Emergency Response Protocol',
    id: 'Protokol Respons Darurat',
    ms: 'Protokol Tindak Balas Kecemasan',
    th: 'โปรโตคอลการตอบสนองฉุกเฉิน',
    vi: 'Giao thức Phản ứng Khẩn cấp',
    fil: 'Protocol ng Pagtugon sa Emergency',
    km: 'ពិធីសារឆ្លើយតបសង្គ្រោះបន្ទាន់',
    lo: 'ມາດຕະການຕອບສະໜອງສຸກເສີນ',
    my: 'အရေးပေါ် တုံ့ပြန်မှု လုပ်ထုံးလုပ်နည်း',
  },
  'seo.emergency.desc': {
    en: "Immediate steps to take if you've been scammed. Stop financial loss, secure your accounts, and report to authorities.",
    id: 'Langkah segera yang harus diambil jika Anda tertipu. Hentikan kerugian finansial, amankan akun Anda, dan lapor ke pihak berwenang.',
    ms: 'Langkah segera yang perlu diambil jika anda telah ditipu. Hentikan kerugian kewangan, amankan akaun anda, dan lapor kepada pihak berkuasa.',
    th: 'ขั้นตอนที่ต้องทำทันทีหากคุณถูกหลอกลวง หยุดการสูญเสียทางการเงิน รักษาความปลอดภัยบัญชีของคุณ และรายงานต่อเจ้าหน้าที่',
    vi: 'Các bước cần thực hiện ngay nếu bạn bị lừa đảo. Ngăn chặn tổn thất tài chính, bảo vệ tài khoản của bạn và báo cáo cho cơ quan chức năng.',
    fil: 'Mga agarang hakbang na dapat gawin kung ikaw ay na-scam. Itigil ang pagkawala ng pera, i-secure ang iyong mga account, at mag-report sa mga awtoridad.',
    km: 'ជំហានបន្ទាន់ដែលត្រូវធ្វើប្រសិនបើអ្នកត្រូវបានគេបោកប្រាស់។ បញ្ឈប់ការខាតបង់ហិរញ្ញវត្ថុ ការពារគណនីរបស់អ្នក និងរាយការណ៍ទៅអាណត្តិ។',
    lo: 'ຂັ້ນຕອນທີ່ຕ້ອງເຮັດທັນທີຖ້າທ່ານຖືກຫຼອກລວງ. ຢຸດການສູນເສຍທາງການເງິນ, ປົກປ້ອງບັນຊີຂອງທ່ານ, ແລະ ລາຍງານຕໍ່ເຈົ້າໜ້າທີ່.',
    my: 'သင် လိမ်လည်ခံရပါက ချက်ချင်းလုပ်ဆောင်ရမည့် အဆင့်များ။ ငွေကြေးဆုံးရှုံးမှုကို ရပ်တန့်ပါ၊ သင့်အကောင့်များကို လုံခြုံအောင်ထားပါ၊ အာဏာပိုင်များထံ တိုင်ကြားပါ။',
  },
  'seo.report.title': {
    en: 'Where to Report Scams',
    id: 'Tempat Melapor Penipuan',
    ms: 'Di Mana Nak Lapor Penipuan',
    th: 'แจ้งเหตุการหลอกลวงที่ไหน',
    vi: 'Nơi báo cáo lừa đảo',
    fil: 'Saan Mag-report ng mga Scam',
    km: 'កន្លែងរាយការណ៍ការបោកប្រាស',
    lo: 'ບ່ອນແຈ້ງຄວາມເລື່ອງການຫຼອກລວງ',
    my: 'လိမ်လည်မှုများကို မည့်နေရာတွင် တိုင်ကြားရမည်နည်း',
  },
  'seo.report.desc': {
    en: 'Directory of official reporting channels for cybercrime and fraud across all 10 ASEAN member states.',
    id: 'Direktori saluran pelaporan resmi untuk kejahatan dunia maya dan penipuan di seluruh 10 negara anggota ASEAN.',
    ms: 'Direktori saluran pelaporan rasmi untuk jenayah siber dan penipuan di semua 10 negara anggota ASEAN.',
    th: 'สารบบช่องทางการรายงานอย่างเป็นทางการสำหรับอาชญากรรมไซเบอร์และการฉ้อโกงทั่วทั้ง 10 ประเทศสมาชิกอาเซียน',
    vi: 'Danh bạ các kênh báo cáo chính thức về tội phạm mạng và gian lận trên tất cả 10 quốc gia thành viên ASEAN.',
    fil: 'Direktoryo ng mga opisyal na channel ng pag-uulat para sa cybercrime at pandaraya sa lahat ng 10 miyembrong estado ng ASEAN.',
    km: 'បញ្ជីឈ្មោះឆានែលរាយការណ៍ផ្លូវការសម្រាប់ឧក្រិដ្ឋកម្មតាមអ៊ីនធឺណិត និងការបោកប្រាស់នៅទូទាំងរដ្ឋសមាជិកអាស៊ីអាគ្នេយ៍ទាំង ១០។',
    lo: 'ປຶ້ມລາຍຊື່ຊ່ອງທາງການລາຍງານຢ່າງເປັນທາງການ, ເຊັ່ນ: ສື່ສັງຄົມ, ຕະຫຼາດ)',
    my: 'အာဆီယံ အဖွဲ့ဝင်နိုင်ငံ ၁၀ နိုင်ငံလုံးရှိ ဆိုက်ဘာရာဇဝတ်မှုနှင့် လိမ်လည်မှုများအတွက် တရားဝင်တိုင်ကြားရန် လမ်းညွှန်။',
  },
  'seo.checkScam.desc': {
    en: 'Use our interactive tool to assess if a situation is likely a scam based on common red flags and warning signs.',
    id: 'Gunakan alat interaktif kami untuk menilai apakah suatu situasi kemungkinan penipuan berdasarkan tanda bahaya umum.',
    ms: 'Gunakan alat interaktif kami untuk menilai jika sesuatu situasi mungkin penipuan berdasarkan tanda amaran biasa.',
    th: 'ใช้เครื่องมือโต้ตอบของเราเพื่อประเมินว่าสถานการณ์มีแนวโน้มจะเป็นการหลอกลวงหรือไม่ โดยพิจารณาจากสัญญาณเตือนทั่วไป',
    vi: 'Sử dụng công cụ tương tác của chúng tôi để đánh giá xem một tình huống có khả năng là lừa đảo hay không dựa trên các dấu hiệu cảnh báo phổ biến.',
    fil: 'Gamitin ang aming interactive tool upang suriin kung ang isang sitwasyon ay malamang na scam batay sa mga karaniwang red flag.',
    km: 'ប្រើឧបករណ៍អន្តរកម្មរបស់យើងដើម្បីវាយតម្លៃថាតើស្ថានភាពមួយទំនងជាការបោកប្រាស់ដែរឬទេ ដោយផ្អែកលើសញ្ញាព្រមានទូទៅ។',
    lo: 'ໃຊ້ເຄື່ອງມືໂຕ້ຕອບຂອງພວກເຮົາເພື່ອປະເມີນວ່າມີຄວາມເປັນໄປໄດ້ທີ່ຈະເປັນການຫຼອກລວງບໍ່ ໂດງໃສ່ສັນຍານເຕືອນທົ່ວໄປ.',
    my: 'အဖြစ်များသော သတိပေးလက္ခဏာများကို အခြေအနေတစ်ခုသည် လိမ်လည်မှု ဖြစ်နိုင်ခြေရှိမရှိ ဆန်းစစ်ရန် ကျွန်ုပ်တို့၏ အပြန်အလှန်တုံ့ပြန်မှု ကိရိယာကို အသုံးပြုပါ။',
  },
  'seo.checkScam.title': {
    en: "Check If It's a Scam - Risk Assessment Tool",
    id: 'Cek Apakah Ini Penipuan - Alat Penilaian Risiko',
    ms: 'Semak Jika Ini Penipuan - Alat Penilaian Risiko',
    th: 'ตรวจสอบว่าเป็นการหลอกลวงหรือไม่ - เครื่องมือประเมินความเสี่ยง',
    vi: 'Kiểm tra xem có phải lừa đảo không - Công cụ Đánh giá Rủi ro',
    fil: 'Suriin kung Ito ay Scam - Tool sa Pagsusuri ng Panganib',
    km: 'ពិនិត្យមើលថាតើវាជាការបោកប្រាស់ដែរឬទេ - ឧបករណ៍វាយតម្លៃហានិភ័យ',
    lo: 'ກວດເບິ່ງວ່າມັນແມ່ນການຫຼອກລວງບໍ່ - ເຄື່ອງມືປະເມີນຄວາມສ່ຽງ',
    my: 'လိမ်လည်မှုဟုတ်မဟုတ် စစ်ဆေးပါ - အန္တရာယ်ဆန်းစစ်ရေး ကိရိယာ',
  },
  'seo.disclaimer.title': {
    en: 'Disclaimer & Terms of Use',
    id: 'Penafian & Ketentuan Penggunaan',
    ms: 'Penafian & Syarat Penggunaan',
    th: 'ข้อปฏิเสธความรับผิด & เงื่อนไขการใช้งาน',
    vi: 'Tuyên bố từ chối trách nhiệm & Điều khoản sử dụng',
    fil: 'Pagtatanggi at Mga Tuntunin ng Paggamit',
    km: 'ការបដិសេធ & លក្ខខណ្ឌនៃការប្រើប្រាស់',
    lo: 'ການປະຕິເສດຄວາມຮັບຜິດຊອບ & ເງື່ອນໄຂການນຳໃຊ້',
    my: 'ငြင်းဆိုချက်နှင့် အသုံးပြုမှု ဆည်းခံများ',
  },
  'seo.disclaimer.desc': {
    en: 'Important legal information regarding the use of the genZAFE platform and the nature of our services.',
    id: 'Informasi hukum penting mengenai penggunaan platform genZAFE dan sifat layanan kami.',
    ms: 'Maklumat undang-undang penting mengenai penggunaan platform genZAFE dan sifat perkhidmatan kami.',
    th: 'ข้อมูลทางกฎหมายที่สำคัญเกี่ยวกับการใช้แพลตฟอร์ม genZAFE และลักษณะของบริการของเรา',
    vi: 'Thông tin pháp lý quan trọng liên quan đến việc sử dụng nền tảng genZAFE và bản chất dịch vụ của chúng tôi.',
    fil: 'Mahalagang impormasyong legal tungkol sa paggamit ng platform ng genZAFE at ang kalikasan ng aming mga serbisyo.',
    km: 'ព័ត៌មានផ្លូវច្បាប់សំខាន់ៗទាក់ទងនឹងការប្រើប្រាស់វេទិកា genZAFE និងលក្ខណៈនៃសេវាកម្មរបស់យើង។',
    lo: 'ຂໍ້ມູນທາງກົດໝາຍທີ່ສຳຄັນກ່ຽວກັບການນຳໃຊ້ເວທີນີ້ແມ່ນສຳລັບຈຸດປະສົງການສຶກສາ ແລະ ການແນະນຳເທົ່ານັ້ນ. ບໍ່ຄວນຖືວ່າເປັນຄຳແນະນຳທາງກົດໝາຍ, ຄຳແນະນຳທາງການເງິນ, ຫຼື ນະໂຍບາຍທາງການ.',
    my: 'genZAFE ပလက်ဖောင်း အသုံးပြုမှုနှင့် ကျွန်ုပ်တို့၏ ဝန်ဆောင်မှုသဘောသဘာဝဆိုင်ရာ အရေးကြီးသော ဥပဒေရေးရာ အချက်အလက်များ။',
  },
  'seo.template.title': {
    en: 'Scam Report Template Generator',
    id: 'Generator Templat Laporan Penipuan',
    ms: 'Penjana Templat Laporan Penipuan',
    th: 'เครื่องมือสร้างเทมเพลตรายงานการหลอกลวง',
    vi: 'Trình tạo mẫu báo cáo lừa đảo',
    fil: 'Generator ng Template ng Ulat ng Scam',
    km: 'ម៉ាស៊ីនបង្កើតគំរូរបាយការណ៍ការបោកប្រាស',
    lo: 'ເຄື່ອງມືສ້າງແບບຟອມລາຍງານ',
    my: 'လိမ်လည်မှု တိုင်ကြားစာ ပုံစံခွက် ထုတ်လုပ်စက်',
  },
  'seo.template.desc': {
    en: 'Generate a professional scam report to submit to banks or police. Organize your evidence and details effectively.',
    id: 'Buat laporan penipuan profesional untuk diserahkan ke bank atau polisi.',
    ms: 'Hasilkan laporan penipuan profesional untuk diserahkan kepada bank atau polis.',
    th: 'สร้างรายงานการหลอกลวงอย่างมืออาชีพเพื่อส่งไปยังธนาคารหรือตำรวจ จัดระเบียบหลักฐานและรายละเอียดของคุณอย่างมีประสิทธิภาพ',
    vi: 'Tạo báo cáo lừa đảo chuyên nghiệp để gửi cho ngân hàng hoặc cảnh sát. Sắp xếp bằng chứng và chi tiết của bạn một cách hiệu quả.',
    fil: 'Gumawa ng propesyonal na ulat ng scam upang isumite sa mga bangko o pulisya. Ayusin ang iyong ebidensya at mga detalye nang epektibo.',
    km: 'បង្កើតរបាយការណ៍ការបោកប្រាសប្រកបដោយវិជ្ជាជីវៈដើម្បីផ្ញេើទៅធនាគារ ឬ ប៉ូលីស. រៀបចំភស្តុតាងនិងព័ត៌មានលម្អិតរបស់អ្នកឱ្យមានប្រសិទ្ធភាព។',
    lo: 'ສ້າງລາຍງານການຫຼອກລວງແບບມືອາຊີບເພື່ອສົ່ງໃຫ້ທະນາຄານ ຫຼື ຕຳຫຼວດ. ໃຊ້ການຈັດລະບຽບຫຼັກຖານ ແລະ ລາຍລະອຽດຂອງທ່ານຢ່າງມີປະສິດທິຜົນ.',
    my: 'ဘဏ်များ သို့မဟုတ် ရဲတပ်ဖွဲ့ထံ တင်သွင်းရန် ပရော်ဖက်ရှင်နယ် လိမ်လည်မှု တိုင်ကြားစာကို ထုတ်လုပ်ပါ။ သင့်သက်သေအထောက်အထားများနှင့် အသေးစိတ်အချက်အလက်များကို ထိရောက်စွာ စုစည်းပါ။',
  },
  'seo.evidence.title': {
    en: 'Digital Evidence & Safety Guide',
    id: 'Panduan Bukti Digital & Keamanan',
    ms: 'Panduan Bukti Digital & Keselamatan',
    th: 'คู่มือหลักฐานดิจิทัลและความปลอดภัย',
    vi: 'Hướng dẫn An toàn & Bằng chứng Kỹ thuật số',
    fil: 'Gabay sa Digital na Ebidensya at Kaligtasan',
    km: 'ការណែនាំអំពីភស្តុតាងឌីជីតល និងសុវត្ថិភាព',
    lo: 'ຄູ່ມືຫຼັກຖານດິຈິຕອນ ແລະ ຄວາມປອດໄພ',
    my: 'ဒစ်ဂျစ်တယ် သက်သေအထောက်အထားနှင့် ဘေးကင်းရေး လမ်းညွှန်',
  },
  'seo.evidence.desc': {
    en: 'Learn how to collect and preserve digital evidence of scams safely without compromising your security.',
    id: 'Pelajari cara mengumpulkan dan menyimpan bukti digital penipuan dengan aman tanpa mengorbankan keamanan Anda.',
    ms: 'Ketahui cara mengumpul dan memelihara bukti digital penipuan dengan selamat tanpa menjejaskan keselamatan anda.',
    th: 'เรียนรู้วิธีรวบรวมและรักษาหลักฐานดิจิทัลของการหลอกลวงอย่างปลอดภัยโดยไม่กระทบต่อความปลอดภัยของคุณ',
    vi: 'Tìm hiểu cách thu thập và bảo quản bằng chứng kỹ thuật số về lừa đảo một cách an toàn mà không ảnh hưởng đến bảo mật của bạn.',
    fil: 'Alamin kung paano wastong mangolekta at mag-ingat ng ebidensya para sa pag-uulat ng mga scam nang ligtas nang hindi nakokompromiso ang iyong seguridad.',
    km: 'ស្វែងយល់ពីរបៀបប្រមូលនិងរក្សាទុកភស្តុតាងឌីជីតលនៃការបោកប្រាស់ដោយសុវត្ថិភាពដោយមិនប៉ះពាល់ដល់សុវត្ថិភាពរបស់អ្នក។',
    lo: 'ຮຽນຮູ້ວິທີການເກັບກຳ ແລະ ຮັກສາຫຼັກຖານດິຈິຕອນ ຂອງການຫຼອກລວງຢ່າງປອດໄພໂດຍບໍ່ມີຜົນກະທົບຕໍ່ຄວາມປອດໄພຂອງທ່ານ.',
    my: 'သင့်လုံခြုံရေးကို မထိခိုက်စေဘဲ လိမ်လည်မှုများ၏ ဒစ်ဂျစ်တယ် သက်သေအထောက်အထားများကို ဘေးကင်းစွာ စုဆောင်းပြီး ထိန်းသိမ်းနည်းကို လေ့လာပါ။',
  },
  'seo.framework.title': {
    en: 'International Anti-Scam Frameworks',
    id: 'Kerangka Anti-Penipuan Internasional',
    ms: 'Rangka Kerja Anti-Penipuan Antarabangsa',
    th: 'กรอบการทำงานต่อต้านการหลอกลวงระหว่างประเทศ',
    vi: 'Khung chống lừa đảo quốc tế',
    fil: 'Mga International Anti-Scam Framework',
    km: 'ក្របខ័ណ្ឌប្រឆាំងការបោកប្រាស់អន្តរជាតិ',
    lo: 'ກອບການເຮັດວຽກຕ້ານການຫຼອກລວງສາກົນ',
    my: 'နိုင်ငံတကာ လိမ်လည္မှုတိုက်ဖျက်ရေး မူဘောင်များ',
  },
  'seo.framework.desc': {
    en: 'Overview of international laws, agreements, and frameworks governing cross-border digital fraud and cybercrime.',
    id: 'Tinjauan hukum, perjanjian, dan kerangka kerja internasional yang mengatur penipuan digital lintas batas dan kejahatan dunia maya.',
    ms: 'Gambaran keseluruhan undang-undang, perjanjian, dan rangka kerja antarabangsa yang mengawal penipuan digital rentas sempadan dan jenayah siber.',
    th: 'ภาพรวมของกฎหมาย ข้อตกลง และกรอบการทำงานระหว่างประเทศที่ควบคุมการฉ้อโกงทางดิจิทัลข้ามพรมแดนและอาชญากรรมทางไซเบอร์',
    vi: 'Tổng quan về luật pháp, hiệp định và khung quốc tế điều chỉnh gian lận kỹ thuật số xuyên biên giới và tội phạm mạng.',
    fil: 'Pangkalahatang-ideya ng mga internasyonal na batas, kasunduan, at balangkas na namamahala sa cross-border digital fraud at cybercrime.',
    km: 'ទិដ្ឋភាពទូទៅនៃច្បាប់អន្តរជាតិ កិច្ចព្រមព្រៀង និងក្របខ័ណ្ឌដែលគ្រប់គ្រងការបោកប្រាស់តាមប្រព័ន្ធដីជីនេះហាំង និងឧក្រិដ្ឋកម្មតាមអ៊ីនធឺណិត។',
    lo: 'ພາບລວມຂອງກົດໝາຍ, ຂໍ້ຕົກລົງ, ແລະ ກອບການເຮັດວຽກສາກົນທີ່ຄວາມສົມບູນກັບການໂກງທາງດິຈິຕອນຂ້າມຊາຍແດນ ແລະ ອາຊະຍາກຳທາງໄຊເບີ.',
    my: 'နယ်စပ်ထပ်တလဲလယ် ဒစ်ဂျစ်တယ်လိမ်လည်မှုနှင့် ဆိုက်ဘာရာဇဝတ်များကို ထိန်းချုပ်သည့် နိုင်ငံတကာဥပဒေများ၊ သဘောတူညီချက်များနှင့် မူဘောင်များကို ချုံ့ငုံသုံးသပ်ချက်။',
  },
  'seo.chat.title': {
    en: 'Interactive Scam Assessment Chat',
    id: 'Chat Penilaian Penipuan Interaktif',
    ms: 'Chat Penilaian Penipuan Interaktif',
    th: 'แชทประเมินการหลอกลวงแบบโต้ตอบ',
    vi: 'Chat Đánh giá Lừa đảo Tương tác',
    fil: 'Interactive Scam Assessment Chat',
    km: 'ការជជែកវាយតម្លៃការបោកប្រាស់អន្តរកម្ម',
    lo: 'ແຊັດປະເມີນການຫຼອກລວງແບບໂຕ້ຕອບ',
    my: 'အပြန်အလှန်တုံ့ပြန်မှု လိမ်လည်မှုဆန်းစစ်ခြင်း ချက်တင်',
  },
  'seo.chat.desc': {
    en: 'Chat with our AI assistant to assess your situation and get personalized guidance on potential scams.',
    id: 'Ngobrol dengan asisten AI kami untuk menilai situasi Anda dan mendapatkan panduan personal tentang potensi penipuan.',
    ms: 'Berbual dengan pembantu AI kami untuk menilai situasi anda dan mendapatkan panduan peribadi tentang potensi penipuan.',
    th: 'แชทกับผู้ช่วย AI ของเราเพื่อประเมินสถานการณ์ของคุณและรับคำแนะนำส่วนบุคคลเกี่ยวกับการหลอกลวงที่อาจเกิดขึ้น',
    vi: 'Trò chuyện với trợ lý AI của chúng tôi để đánh giá tình huống của bạn và nhận hướng dẫn cá nhân hóa về các vụ lừa đảo tiềm ẩn.',
    fil: 'Makipag-chat sa aming AI assistant upang suriin ang iyong sitwasyon at makakuha ng personalized na gabay sa mga potensyal na scam.',
    km: 'ជជែកជាមួយជំនួយការ AI របស់យើងដើម្បីវាយតម្លៃស្ថានភាពរបស់អ្នក និងទទួលបានការណែនាំផ្ទាល់ខ្លួនអំពីការបោកប្រាស់ដែលអាចកើតមាន។',
    lo: 'ສົນທະນາກັບຜູ້ຊ່ວຍ AI ຂອງພວກເຮົາເພື່ອປະເມີນສະຖານະການຂອງທ່ານ ແລະ ໄດ້ຮັບຄຳແນະນຳສ່ວນບຸກຄົນກ່ຽວກັບການຫຼອກລວງທີ່ອາດເກີດຂຶ້ນ.',
    my: 'သင့်အခြေအနေကို ဆန်းစစ်ရန်နှင့် ဖြစ်နိုင်ခြေရှိသော လိမ်လည်မှုများအကြောင်း ကိုယ်ပိုင်လမ်းညွှန်ချက်များ ရယူရန် ကျွန်ုပ်တို့၏ AI လက်ထောက်နှင့် ချက်တင်ပြုလုပ်ပါ။',
  },
  'seo.cyberQuiz.title': {
    en: 'Cybersecurity Quiz - Test Your Scam Detection Skills',
    id: 'Kuis Keamanan Siber - Uji Kemampuan Deteksi Penipuanmu',
    ms: 'Kuiz Keselamatan Siber - Uji Kemahiran Pengesanan Penipuan Anda',
    th: 'แบบทดสอบความปลอดภัยทางไซเบอร์ - ทดสอบทักษะการตรวจจับการหลอกลวงของคุณ',
    vi: 'Câu đố An ninh mạng - Kiểm tra Kỹ năng Phát hiện Lừa đảo của Bạn',
    fil: 'Cybersecurity Quiz - Subukan ang Iyong Kasanayan sa Pagtuklas ng Scam',
    km: 'កម្រងសំណួរសុវកិច្ចតាមអ៊ីនធឺណិត - សាកល្បងជំនាញរកឃើញការបោកប្រាស់របស់អ្នក',
    lo: 'ແບບທົດສອບຄວາມປອດໄພທາງໄຊເບີ - ທົດສອບທັກສະການກວດຈັບການຫຼອກລວງຂອງທ່ານ',
    my: 'ဆိုက်ဘာလုံခြုံရေး ပဟေဠီ - သင့်လိမ်လည်မှု ရှာဖွေရန် ကျွန်ုပ်တို့၏ အပြန်အလှန်တုံ့ပြန်မှု ပဟေဠီကို ဖြေဆိုပါ',
  },
  'seo.cyberQuiz.desc': {
    en: 'Take our interactive quiz to discover your cybersecurity level. Find out if you are a Digital Noob or a Firewall Legend!',
    id: 'Ikuti kuis interaktif kami untuk mengetahui level keamanan sibermu. Cari tahu apakah kamu Digital Noob atau Firewall Legend! Kini, waktunya untuk mengetes kemampuan keamanan siber Anda!',
    ms: 'Ambil kuiz interaktif kami untuk mengetahui tahap keselamatan digital anda. Adakah anda "Digital Noob" atau "Firewall Legend"? Cari tahu sekarang!',
    th: 'ทำแบบทดสอบไซเบอร์ของเราเพื่อค้นพบระดับความปลอดภัยดิจิทัลของคุณ คุณเป็น "Digital Noob" หรือ "Firewall Legend"? ค้นหาตอนนี้!',
    vi: 'Làm bài kiểm tra mạng nhanh của chúng tôi để khám phá mức độ bảo mật kỹ thuật số của bạn. Bạn là "Digital Noob" hay "Firewall Legend"? Tìm hiểu ngay!',
    fil: 'Kumuha ng aming mabilis na cyber quiz upang malaman ang iyong antas ng digital security. Ikaw ba ay "Digital Noob" o "Firewall Legend"? Alamin ngayon!',
    km: 'ធ្វើកម្រងសំណួរសុវកិច្ចតាមអ៊ីនធឺណិតរហ័សរបស់យើងដើម្បីស្វែងយល់ពីកម្រិតសុវត្ថិភាពឌីជីតលរបស់អ្នក។ តើអ្នកជា "Digital Noob" ឬ "Firewall Legend"? ស្វែងយល់ឥឡូវនេះ!',
    lo: 'ເຮັດແບບທົດສອບໂຕ້ຕອບຂອງພວກເຮົາເພື່ອຄົ້ນພົບລະດັບຄວາມປອດໄພທາງໄຊເບີຂອງທ່ານ. ຊອກຫາວ່າທ່ານເປັນ Digital Noob ຫຼື Firewall Legend!',
    my: 'သင့်ဆိုက်ဘာလုံခြုံရေးအဆင့်ကို ရှာဖွေရန် ကျွန်ုပ်တို့၏ အပြန်အလှန်တုံ့ပြန်မှု ပဟေဠီကို ဖြေဆိုပါ။ သင်သည် Digital Noob ဟုတ်မဟုတ် Firewall Legend ဟုတ်မဟုတ် ရှာဖွေပါ!',
  },
  'seo.events.title': {
    en: 'Events & Training - genZAFE',
    id: 'Acara & Pelatihan - genZAFE',
    ms: 'Acara & Latihan - genZAFE',
    th: 'กิจกรรมและการฝึกอบรม - genZAFE',
    vi: 'Sự kiện & Đào tạo - genZAFE',
    fil: 'Mga Kaganapan at Pagsasanay - genZAFE',
    km: 'ព្រឹត្តិការណ៍ & ការបណ្តុះបណ្តាល - genZAFE',
    lo: 'ກິດຈະກຳ ແລະ ການຝຶກອົບຮົມ - genZAFE',
    my: 'ပွဲများနှင့် သင်တန်းများ - genZAFE',
  },
  'seo.events.desc': {
    en: 'List of latest cybersecurity events, webinars, and training.',
    id: 'Daftar acara, webinar, dan pelatihan keamanan siber terbaru.',
    ms: 'Senarai acara, webinar, dan latihan keselamatan siber terkini.',
    th: 'รายการกิจกรรม เว็บสัมมนา และการฝึกอบรมความปลอดภัยทางไซเบอร์ล่าสุด',
    vi: 'Danh sách các sự kiện, hội thảo trên web và đào tạo an ninh mạng mới nhất.',
    fil: 'Listahan ng mga pinakabagong kaganapan sa cybersecurity, webinar, at pagsasanay.',
    km: 'បញ្ជីព្រឹត្តិការណ៍សុវត្ថិភាពតាមអ៊ីនធឺណិត សិក្ខាសាលាតាមអ៊ីនធឺណិត និងការបណ្តុះបណ្តាលចុងក្រោយ។',
    lo: 'ລາຍການກິດຈະກຳຄວາມປອດໄພທາງໄຊເບີ, ເວັບບິນາ, ແລະ ການຝຶກອົບຮົມຫຼ້າສຸດ.',
    my: 'နောက်ဆုံးပေါ် ဆိုက်ဘာလုံခြုံရေး ပွဲများ၊ ဝက်ဘ်ဆွေးနွေးပွဲများနှင့် သင်တန်းများ စာရင်း။',
  },

  // --- HERO SECTION ---
  'hero.title': {
    en: 'genZAFE',
    id: 'genZAFE',
    ms: 'genZAFE',
    th: 'genZAFE',
    vi: 'genZAFE',
    fil: 'genZAFE',
    km: 'genZAFE',
    lo: 'genZAFE',
    my: 'genZAFE',
  },
  'hero.subtitle': {
    en: 'Generation Zero-risk ASEAN Fraud Empowerment',
    id: 'Generation Zero-risk ASEAN Fraud Empowerment',
    ms: 'Generation Zero-risk ASEAN Fraud Empowerment',
    th: 'Generation Zero-risk ASEAN Fraud Empowerment',
    vi: 'Generation Zero-risk ASEAN Fraud Empowerment',
    fil: 'Generation Zero-risk ASEAN Fraud Empowerment',
    km: 'Generation Zero-risk ASEAN Fraud Empowerment',
    lo: 'Generation Zero-risk ASEAN Fraud Empowerment',
    my: 'Generation Zero-risk ASEAN Fraud Empowerment',
  },
  'hero.cta.emergency': {
    en: 'Emergency Protocol',
    id: 'Protokol Darurat',
    ms: 'Protokol Kecemasan',
    th: 'โปรโตคอลฉุกเฉิน',
    vi: 'Giao thức khẩn cấp',
    fil: 'Protokol sa Emergency',
    km: 'ពិធីសារសង្គ្រោះបន្ទាន់',
    lo: 'ມາດຕະການສຸກເສີນ',
    my: 'အရေးပေါ် လုပ်ထုံးလုပ်နည်း',
  },
  'hero.cta.check': {
    en: 'Check Scam',
    id: 'Cek Penipuan',
    ms: 'Semak Penipuan',
    th: 'ตรวจสอบการหลอกลวง',
    vi: 'Kiểm tra lừa đảo',
    fil: 'Suriin ang Scam',
    km: 'ពិនិត្យការបោកប្រាស់',
    lo: 'ກວດສອບການຫຼອກລວງ',
    my: 'လိမ်လည်မှုစစ်ဆေးရန်',
  },
  'home.badge': {
    en: 'ASEAN Anti-Scam Initiative',
    id: 'Inisiatif Anti-Penipuan ASEAN',
    ms: 'Inisiatif Anti-Penipuan ASEAN',
    th: 'โครงการต่อต้านการหลอกลวงอาเซียน',
    vi: 'Sáng kiến Chống Lừa đảo ASEAN',
    fil: 'ASEAN Anti-Scam Initiative',
    km: 'គំនិតផ្តូចផ្តៀមប្រឆាំងការបោកប្រាស',
    lo: 'ການລິເລີ່ມຕ້ານການຫຼອກລວງອາຊຽນ',
    my: 'အာဆီယံ လိမ်လည်မှုတိုက်ဖျက်ရေး အစီအစဉ်',
  },
  'home.heroDesc': {
    en: 'Protect yourself and your community from digital fraud with our comprehensive toolkit and reporting system.',
    id: 'Lindungi diri Anda dan komunitas Anda dari penipuan digital dengan perangkat dan sistem pelaporan komprehensif kami.',
    ms: 'Lindungi diri anda dan komuniti anda daripada penipuan digital dengan kit alat dan sistem pelaporan komprehensif kami.',
    th: 'ปกป้องตัวคุณเองและชุมชนของคุณจากการฉ้อโกงทางดิจิทัลด้วยชุดเครื่องมือและระบบการรายงานที่ครอบคลุมของเรา',
    vi: 'Bảo vệ bản thân và cộng đồng của bạn khỏi gian lận kỹ thuật số với bộ công cụ và hệ thống báo cáo toàn diện của chúng tôi.',
    fil: 'Protektahan ang iyong sarili at ang iyong komunidad mula sa digital fraud gamit ang aming komprehensibong toolkit at sistema ng pag-uulat.',
    km: 'ការពារខ្លួនអ្នក និងសហគមន៍របស់អ្នកពីការបោកប្រាស់តាមប្រព័ន្ធឌីជីថល ជាមួយនឹងឧបករណ៍ និងប្រព័ន្ធរាយការណ៍ដ៏ទូលំទូលាយរបស់យើង។',
    lo: 'ປົກປ້ອງຕົວເອງ ແລະ ຊຸມຊົນຂອງທ່ານຈາກການໂກງທາງດິຈິຕອນດ້ວຍຊຸດເຄື່ອງມື ແລະ ລະບົບການລາຍງານທີ່ສົມບູນແບບຂອງພວກເຮົາ.',
    my: 'ကျွန်ုပ်တို့၏ ပြီးပြည့်စုံသော ကိရိယာများနှင့် တိုင်ကြားမှုစနစ်ဖြင့် ဒစ်ဂျစ်တယ်လိမ်လည်မှုမှ သင့်ကိုယ်သင်နှင့် သင့်အသိုင်းအဝိုင်းကို ကာကွယ်ပါ။',
  },
  'home.responseSystem': {
    en: 'Rapid Response System',
    id: 'Sistem Respons Cepat',
    ms: 'Sistem Tindak Balas Pantas',
    th: 'ระบบตอบสนองรวดเร็ว',
    vi: 'Hệ thống Phản ứng Nhanh',
    fil: 'Mabilis na Sistema ng Pagtugon',
    km: 'ប្រព័ន្ធឆ្លើយតបរហ័ស',
    lo: 'ລະບົບຕອບສະໜອງໄວ',
    my: 'လျင်မြန်သော တုံ့ပြန်မှုစနစ်',
  },
  'home.responseSystemDesc': {
    en: 'Access critical tools to identify threats and take immediate action.',
    id: 'Akses alat penting untuk mengidentifikasi ancaman dan mengambil tindakan segera.',
    ms: 'Akses alat penting untuk mengenal pasti ancaman dan mengambil tindakan segera.',
    th: 'เข้าถึงเครื่องมือสำคัญเพื่อระบุภัยคุกคามและดำเนินการทันที',
    vi: 'Truy cập các công cụ quan trọng để xác định các mối đe dọa và hành động ngay lập tức.',
    fil: 'I-access ang mga kritikal na tool upang matukoy ang mga banta at gumawa ng agarang aksyon.',
    km: 'ចូលប្រើឧបករណ៍សំខាន់ៗដើម្បីកំណត់អត្តសញ្ញាណការគំរាមកំហែង និងចាត់វិធានការភ្លាមៗ។',
    lo: 'ເຂົ້າເຖິງເຄື່ອງມືທີ່ສຳຄັນເພື່ອລະບຸໄພຂົ່ມຂູ່ ແລະ ດຳເນີນການທັນທີ.',
    my: 'ခြိမ်းခြောက်မှုများကို ခွဲခြားသတ်မှတ်ပြီး ချက်ချင်းအရေးယူရန် အရေးကြီးသော ကိရိယာများကို ရယူပါ။',
  },
  'home.defenseProtocols': {
    en: 'Scam Defense Protocols',
    id: 'Protokol Pertahanan Penipuan',
    ms: 'Protokol Pertahanan Penipuan',
    th: 'โปรโตคอลป้องกันการหลอกลวง',
    vi: 'Giao thức Phòng thủ Lừa đảo',
    fil: 'Mga Protokol sa Pagtatanggol sa Scam',
    km: 'ពិធីសារការពារការបោកប្រាស់',
    lo: 'ມາດຕະການປ້ອງກັນການຫຼອກລວງ',
    my: 'လိမ်လည်မှု ကာကွယ်ရေး လုပ်ထုံးလုပ်နည်းများ',
  },
  'home.defenseProtocolsDesc': {
    en: 'Specific guides for the most common types of digital fraud in ASEAN.',
    id: 'Panduan khusus untuk jenis penipuan digital paling umum di ASEAN.',
    ms: 'Panduan khusus untuk jenis penipuan digital yang paling biasa di ASEAN.',
    th: 'คู่มือเฉพาะสำหรับประเภทการฉ้อโกงทางดิจิทัลที่พบบ่อยที่สุดในอาเซียน',
    vi: 'Hướng dẫn cụ thể cho các loại gian lận kỹ thuật số phổ biến nhất ở ASEAN.',
    fil: 'Mga partikular na gabay para sa mga pinakakaraniwang uri ng digital fraud sa ASEAN.',
    km: 'ការណែនាំជាក់លាក់សម្រាប់ប្រភេទការបោកប្រាស់តាមប្រព័ន្ធឌីជីថលទូទៅបំផុតនៅក្នុងអាស៊ាន។',
    lo: 'ຄູ່ມືສະເພາະສຳລັບປະເພດການໂກງທາງດິຈິຕອນທີ່ພົບເຫັນຫຼາຍທີ່ສຸດໃນອາຊຽນ.',
    my: 'အာဆီယံတွင် အဖြစ်များဆုံး ဒစ်ဂျစ်တယ်လိမ်လည်မှု အမျိုးအစားများအတွက် သီးခြားလမ်းညွှန်များ။',
  },
  'home.viewAllProtocols': {
    en: 'View All Protocols',
    id: 'Lihat Semua Protokol',
    ms: 'Lihat Semua Protokol',
    th: 'ดูโปรโตคอลทั้งหมด',
    vi: 'Xem tất cả giao thức',
    fil: 'Tingnan ang Lahat ng Protokol',
    km: 'មើលពិធីសារទាំងអស់',
    lo: 'ເບິ່ງມາດຕະການທັງໝົດ',
    my: 'လုပ်ထုံးလုပ်နည်းများ အားလုံးကြည့်ရန်',
  },
  'home.internationalStandards': {
    en: 'International Standards',
    id: 'Standar Internasional',
    ms: 'Standard Antarabangsa',
    th: 'มาตรฐานสากล',
    vi: 'Tiêu chuẩn quốc tế',
    fil: 'Mga Pamantayang Internasyonal',
    km: 'ស្តង់ដារអន្តរជាតិ',
    lo: 'ມາດຕະຖານສາກົນ',
    my: 'နိုင်ငံတကာ စံချိန်စံညွှန်းများ',
  },
  'home.internationalStandardsDesc': {
    en: 'Aligned with global cybersecurity frameworks and ASEAN cooperation strategies.',
    id: 'Selaras dengan kerangka kerja keamanan siber global dan strategi kerja sama ASEAN.',
    ms: 'Selaras dengan rangka kerja keselamatan siber global dan strategi kerjasama ASEAN.',
    th: 'สอดคล้องกับกรอบความปลอดภัยทางไซเบอร์ระดับโลกและยุทธศาสตร์ความร่วมมืออาเซียน',
    vi: 'Phù hợp với các khung an ninh mạng toàn cầu và chiến lược hợp tác ASEAN.',
    fil: 'Nakahanay sa mga global cybersecurity framework at mga diskarte sa pakikipagtulungan ng ASEAN.',
    km: 'តម្រឹមជាមួយក្របខ័ណ្ឌសុវត្ថិភាពតាមអ៊ីនធឺណិតសកល និងយុទ្ធសាស្ត្រសហប្រតិបត្តិការអាស៊ាន។',
    lo: 'ສອດຄ່ອງກັບກອບຄວາມປອດໄພທາງໄຊເບີທົ່ວໂລກ ແລະ ຍຸດທະສາດການຮ່ວມມືອາຊຽນ.',
    my: 'ကမ္ဘာလုံးဆိုင်ရာ ဆိုက်ဘာလုံခြုံရေး မူဘောင်များနှင့် အာဆီယံ ပူးပေါင်းဆောင်ရွက်မှု မဟာဗျူဟာများနှင့် ကိုက်ညီသည်။',
  },
  'home.exploreFramework': {
    en: 'Explore Frameworks',
    id: 'Jelajahi Kerangka Kerja',
    ms: 'Terokai Rangka Kerja',
    th: 'สำรวจกรอบการทำงาน',
    vi: 'Khám phá các khung',
    fil: 'Galugarin ang mga Balangkas',
    km: 'ស្វែងយល់ពីក្របខ័ណ្ឌ',
    lo: 'ສຳຫຼວດກອບການເຮັດວຽກ',
    my: 'မူဘောင်များကို လေ့လာပါ',
  },
  'home.aboutMission': {
    en: 'About Our Mission',
    id: 'Tentang Misi Kami',
    ms: 'Mengenai Misi Kami',
    th: 'เกี่ยวกับภารกิจของเรา',
    vi: 'Về sứ mệnh của chúng tôi',
    fil: 'Tungkol sa Aming Misyon',
    km: 'អំពីបេសកកម្មរបស់យើង',
    lo: 'ກ່ຽວກັບພາລະກິດຂອງພວກເຮົາ',
    my: 'ကျွန်ုပ်တို့၏ ရည်မှန်းချက်အကြောင်း',
  },
  'home.verifiedProtocols': {
    en: 'Verified Protocols',
    id: 'Protokol Terverifikasi',
    ms: 'Protokol Disahkan',
    th: 'โปรโตคอลที่ตรวจสอบแล้ว',
    vi: 'Giao thức đã xác minh',
    fil: 'Na-verify na mga Protokol',
    km: 'ពិធីសារដែលបានផ្ទៀងផ្ទាត់',
    lo: 'ມາດຕະການທີ່ໄດ້ຮັບການຢັ້ງຢືນ',
    my: 'အတည်ပြုပြီးသော လုပ်ထုံးလုပ်နည်းများ',
  },
  'home.securePlatform': {
    en: 'Secure Platform',
    id: 'Platform Aman',
    ms: 'Platform Selamat',
    th: 'แพลตฟอร์มที่ปลอดภัย',
    vi: 'Nền tảng an toàn',
    fil: 'Ligtas na Platform',
    km: 'វេទិកាសុវត្ថិភាព',
    lo: 'ເວທີທີ່ປອດໄພ',
    my: 'လုံခြုံသော ပလက်ဖောင်း',
  },
  'home.aseanCoverage': {
    en: 'ASEAN Coverage',
    id: 'Cakupan ASEAN',
    ms: 'Liputan ASEAN',
    th: 'ความคุ้มครองอาเซียน',
    vi: 'Phạm vi ASEAN',
    fil: 'Saklaw ng ASEAN',
    km: 'ការគ្របដណ្តប់អាស៊ាន',
    lo: 'ການຄຸ້ມຄອງອາຊຽນ',
    my: 'အာဆီယံ လွှမ်းခြုံမှု',
  },
  'home.officialStandards': {
    en: 'Official Standards',
    id: 'Standar Resmi',
    ms: 'Standard Rasmi',
    th: 'มาตรฐานอย่างเป็นทางการ',
    vi: 'Tiêu chuẩn chính thức',
    fil: 'Opisyal na Pamantayan',
    km: 'ស្តង់ដារផ្លូវការ',
    lo: 'ມາດຕະຖານທາງການ',
    my: 'တရားဝင် စံချိန်စံညွှန်းများ',
  },

  // --- QUIZ ---
  'quiz.badge': {
    en: 'Interactive Assessment',
    id: 'Penilaian Interaktif',
    ms: 'Penilaian Interaktif',
    th: 'การประเมินแบบโต้ตอบ',
    vi: 'Đánh giá tương tác',
    fil: 'Interactive na Pagsusuri',
    km: 'ការវាយតម្លៃអន្តរកម្ម',
    lo: 'ການປະເມີນແບບໂຕ້ຕອບ',
    my: 'အပြန်အလှန်တုံ့ပြန်မှု ဆန်းစစ်ခြင်း',
  },
  'quiz.title': {
    en: 'Test Your Cyber Safety IQ',
    id: 'Uji IQ Keamanan Siber Anda',
    ms: 'Uji IQ Keselamatan Siber Anda',
    th: 'ทดสอบ IQ ความปลอดภัยทางไซเบอร์ของคุณ',
    vi: 'Kiểm tra IQ An toàn Mạng của Bạn',
    fil: 'Subukan ang Iyong Cyber Safety IQ',
    km: 'សាកល្បង IQ សុវត្ថិភាពតាមអ៊ីនធឺណិតរបស់អ្នក',
    lo: 'ທົດສອບ IQ ຄວາມປອດໄພທາງໄຊເບີຂອງທ່ານ',
    my: 'သင့် ဆိုက်ဘာလုံခြုံရေး IQ ကို စစ်ဆေးပါ',
  },
  'quiz.description': {
    en: 'Are you a Digital Noob or a Firewall Legend? Take our 2-minute quiz to find out your risk profile.',
    id: 'Apakah Anda Digital Noob atau Firewall Legend? Ikuti kuis 2 menit kami untuk mengetahui profil risiko Anda.',
    ms: 'Adakah anda Digital Noob atau Firewall Legend? Ambil kuiz 2 minit kami untuk mengetahui profil risiko anda.',
    th: 'คุณเป็น Digital Noob หรือ Firewall Legend? ทำแบบทดสอบ 2 นาทีของเราเพื่อค้นหาโปรไฟล์ความเสี่ยงของคุณ',
    vi: 'Bạn là Digital Noob hay Firewall Legend? Hãy làm bài kiểm tra 2 phút của chúng tôi để tìm ra hồ sơ rủi ro của bạn.',
    fil: 'Ikaw ba ay Digital Noob o Firewall Legend? Kumuha ng aming 2-minutong pagsusulit upang malaman ang iyong profile sa panganib.',
    km: 'តើអ្នកជា Digital Noob ឬ Firewall Legend? ធ្វើកម្រងសំណួររយៈពេល 2 នាទីរបស់យើងដើម្បីស្វែងរកទម្រង់ហានិភ័យរបស់អ្នក។',
    lo: 'ເຈົ້າເປັນ Digital Noob ຫຼື Firewall Legend? ເຮັດແບບທົດສອບ 2 ນາທີຂອງພວກເຮົາເພື່ອຊອກຫາໂປຣໄຟລ໌ຄວາມສ່ຽງຂອງທ່ານ.',
    my: 'သင်သည် Digital Noob လား Firewall Legend လား? သင့်အန္တရာယ်ပရိုဖိုင်ကို ရှာဖွေရန် ကျွန်ုပ်တို့၏ ၂ မိနစ်စာ ပဟေဠိကို ဖြေဆိုပါ။',
  },
  'quiz.startBtn': {
    en: 'Start Quiz Now',
    id: 'Mulai Kuis Sekarang',
    ms: 'Mula Kuiz Sekarang',
    th: 'เริ่มแบบทดสอบตอนนี้',
    vi: 'Bắt đầu câu đố ngay',
    fil: 'Simulan ang Pagsusulit Ngayon',
    km: 'ចាប់ផ្តើមកម្រងសំណួរឥឡូវនេះ',
    lo: 'ເລີ່ມແບບທົດສອບດຽວນີ້',
    my: 'ပဟေဠိကို ယခုစတင်ပါ',
  },

  // --- EVENTS PAGE ---
  'events.title': {
    en: 'Events & Training',
    id: 'Acara & Pelatihan',
    ms: 'Acara & Latihan',
    th: 'กิจกรรมและการฝึกอบรม',
    vi: 'Sự kiện & Đào tạo',
    fil: 'Mga Kaganapan at Pagsasanay',
    km: 'ព្រឹត្តិការណ៍ & ការបណ្តុះបណ្តាល',
    lo: 'ກິດຈະກຳ ແລະ ການຝຶກອົບຮົມ',
    my: 'ပွဲများနှင့် သင်တန်းများ',
  },
  'events.subtitle': {
    en: 'Upgrade your digital security skills with experts. Take the profile quiz to register.',
    id: 'Tingkatkan skill keamanan digitalmu bersama para ahli. Ikuti kuis profil untuk mendaftar.',
    ms: 'Tingkatkan kemahiran keselamatan digital anda dengan pakar. Ambil kuiz profil untuk mendaftar.',
    th: 'ยกระดับทักษะความปลอดภัยดิจิทัลของคุณกับผู้เชี่ยวชาญ ทำแบบทดสอบโปรไฟล์เพื่อลงทะเบียน',
    vi: 'Nâng cao kỹ năng bảo mật kỹ thuật số của bạn với các chuyên gia. Làm bài kiểm tra hồ sơ để đăng ký.',
    fil: 'I-upgrade ang iyong mga kasanayan sa digital security kasama ang mga eksperto. Kumuha ng profile quiz upang magparehistro.',
    km: 'បង្កើនជំនាញសុវត្ថិភាពឌីជីថលរបស់អ្នកជាមួយអ្នកជំនាញ។ ធ្វើកម្រងសំណួរទម្រង់ដើម្បីចុះឈ្មោះ។',
    lo: 'ຍົກລະດັບທັກສະຄວາມປອດໄພດິຈິຕອນຂອງທ່ານກັບຜູ້ຊ່ຽວຊານ. ເຮັດແບບທົດສອບໂປຣໄຟລ໌ເພື່ອລົງທະບຽນ.',
    my: 'ကျွမ်းကျင်သူများနှင့်အတူ သင့်ဒစ်ဂျစ်တယ်လုံခြုံရေးစွမ်းရည်များကို မြှင့်တင်ပါ။ စာရင်းပေးသွင်းရန် ပရိုဖိုင်ပဟေဠိကို ဖြေဆိုပါ။',
  },
  'events.featured': {
    en: 'Featured Event',
    id: 'Acara Unggulan',
    ms: 'Acara Pilihan',
    th: 'กิจกรรมแนะนำ',
    vi: 'Sự kiện nổi bật',
    fil: 'Itinatampok na Kaganapan',
    km: 'ព្រឹត្តិការណ៍ពិសេស',
    lo: 'ກິດຈະກຳເດັ່ນ',
    my: 'အထူးပွဲ',
  },
  'events.filter': {
    en: 'Filter:',
    id: 'Filter:',
    ms: 'Tapis:',
    th: 'ตัวกรอง:',
    vi: 'Bộ lọc:',
    fil: 'Salain:',
    km: 'តម្រង:',
    lo: 'ກັ່ນຕອງ:',
    my: 'စစ်ထုတ်ရန်:',
  },
  'events.registerNow': {
    en: 'Register Now',
    id: 'Daftar Sekarang',
    ms: 'Daftar Sekarang',
    th: 'ลงทะเบียนตอนนี้',
    vi: 'Đăng ký ngay',
    fil: 'Magparehistro Ngayon',
    km: 'ចុះឈ្មោះឥឡូវនេះ',
    lo: 'ລົງທະບຽນດຽວນີ້',
    my: 'ယခု စာရင်းသွင်းပါ',
  },
  'events.register': {
    en: 'Register',
    id: 'Daftar',
    ms: 'Daftar',
    th: 'ลงทะเบียน',
    vi: 'Đăng ký',
    fil: 'Magparehistro',
    km: 'ចុះឈ្មោះ',
    lo: 'ລົງທະບຽນ',
    my: 'စာရင်းသွင်းရန်',
  },
  'events.webinar': {
    en: 'Webinar',
    id: 'Webinar',
    ms: 'Webinar',
    th: 'สัมมนาผ่านเว็บ',
    vi: 'Hội thảo trên web',
    fil: 'Webinar',
    km: 'សិក្ខាសាលាតាមអ៊ីនធឺណិត',
    lo: 'ເວັບບິນາ',
    my: 'ဝက်ဘ်ဆွေးနွေးပွဲ',
  },
  'events.workshop': {
    en: 'Workshop',
    id: 'Workshop',
    ms: 'Bengkel',
    th: 'เวิร์กช็อป',
    vi: 'Hội thảo',
    fil: 'Workshop',
    km: 'សិក្ខាសាលា',
    lo: 'ກອງປະຊຸມ',
    my: 'အလုပ်ရုံဆွေးနွေးပွဲ',
  },
  'events.training': {
    en: 'Training',
    id: 'Pelatihan',
    ms: 'Latihan',
    th: 'การฝึกอบรม',
    vi: 'Đào tạo',
    fil: 'Pagsasanay',
    km: 'ការបណ្តុះបណ្តាល',
    lo: 'ການຝຶກອົບຮົມ',
    my: 'သင်တန်း',
  },
  'events.all': {
    en: 'All',
    id: 'Semua',
    ms: 'Semua',
    th: 'ทั้งหมด',
    vi: 'Tất cả',
    fil: 'Lahat',
    km: 'ទាំងអស់',
    lo: 'ທັງໝົດ',
    my: 'အားလုံး',
  },

  // --- WARNING & ACTIONS ---
  'warning.global': {
    en: 'Global Alert: High volume of job scams reported in Southeast Asia. Verify all offers.',
    id: 'Peringatan Global: Volume tinggi penipuan pekerjaan dilaporkan di Asia Tenggara. Verifikasi semua tawaran.',
    ms: 'Amaran Global: Jumlah penipuan pekerjaan yang tinggi dilaporkan di Asia Tenggara. Sahkan semua tawaran.',
    th: 'การแจ้งเตือนทั่วโลก: มีการรายงานการหลอกลวงงานจำนวนมากในเอเชียตะวันออกเฉียงใต้ ตรวจสอบข้อเสนอทั้งหมด',
    vi: 'Cảnh báo toàn cầu: Khối lượng lớn các vụ lừa đảo việc làm được báo cáo ở Đông Nam Á. Xác minh tất cả các đề nghị.',
    fil: 'Global Alert: Mataas na volume ng mga job scam na iniulat sa Southeast Asia. I-verify ang lahat ng alok.',
    km: 'ការដាស់តឿនសកល៖ បរិមាណខ្ពស់នៃការបោកប្រាស់ការងារត្រូវបានរាយការណ៍នៅអាស៊ីអាគ្នេយ៍។ ផ្ទៀងផ្ទាត់ការផ្តល់ជូនទាំងអស់។',
    lo: 'ການເຕືອນໄພທົ່ວໂລກ: ມີການລາຍງານການຫຼອກລວງວຽກງານຈຳນວນຫຼາຍໃນອາຊີຕາເວັນອອກສຽງໃຕ້. ກວດສອບຂໍ້ສະເໜີທັງໝົດ.',
    my: 'ကမ္ဘာလုံးဆိုင်ရာ သတိပေးချက် - အရှေ့တောင်အာရှတွင် အလုပ်လိမ်လည်မှု အများအပြား တိုင်ကြားထားသည်။ ကမ်းလှမ်းချက်အားလုံးကို စစ်ဆေးပါ။',
  },
  'quickAction.check.desc': {
    en: 'Unsure if something is real? Use our interactive tool to analyze potential threats.',
    id: 'Tidak yakin apakah sesuatu itu nyata? Gunakan alat interaktif kami untuk menganalisis potensi ancaman.',
    ms: 'Tidak pasti jika sesuatu itu nyata? Gunakan alat interaktif kami untuk menganalisis potensi ancaman.',
    th: 'ไม่แน่ใจว่าจริงหรือไม่? ใช้เครื่องมือโต้ตอบของเราเพื่อวิเคราะห์ภัยคุกคามที่อาจเกิดขึ้น',
    vi: 'Không chắc chắn liệu điều gì đó có thật không? Sử dụng công cụ tương tác của chúng tôi để phân tích các mối đe dọa tiềm ẩn.',
    fil: 'Hindi sigurado kung totoo ang isang bagay? Gamitin ang aming interactive tool upang suriin ang mga potensyal na banta.',
    km: 'មិនប្រាកដថាអ្វីមួយពិតមែនទេ? ប្រើឧបករណ៍អន្តរកម្មរបស់យើងដើម្បីវិភាគការគំរាមកំហែងដែលអាចកើតមាន។',
    lo: 'ບໍ່ແນ່ໃຈວ່າສິ່ງໃດສິ່ງໜຶ່ງເປັນຄວາມຈິງບໍ່? ໃຊ້ເຄື່ອງມືໂຕ້ຕອບຂອງພວກເຮົາເພື່ອວິເຄາະໄພຂົ່ມຂູ່ທີ່ອາດເກີດຂຶ້ນ.',
    my: 'တစ်ခုခု အစစ်အမှန်ဟုတ်မဟုတ် မသေချာဘူးလား? ဖြစ်နိုင်ခြေရှိသော ခြိမ်းခြောက်မှုများကို ခွဲခြမ်းစိတ်ဖြာရန် ကျွန်ုပ်တို့၏ အပြန်အလှန်တုံ့ပြန်မှု ကိရိယာကို အသုံးပြုပါ။',
  },
  'quickAction.emergency.desc': {
    en: 'Scammed? Follow our step-by-step emergency protocol to secure your accounts immediately.',
    id: 'Tertipu? Ikuti protokol darurat langkah demi langkah kami untuk mengamankan akun Anda segera.',
    ms: 'Ditipu? Ikuti protokol kecemasan langkah demi langkah kami untuk mengamankan akaun anda dengan segera.',
    th: 'ถูกหลอก? ทำตามโปรโตคอลฉุกเฉินทีละขั้นตอนของเราเพื่อรักษาความปลอดภัยบัญชีของคุณทันที',
    vi: 'Bị lừa đảo? Làm theo giao thức khẩn cấp từng bước của chúng tôi để bảo vệ tài khoản của bạn ngay lập tức.',
    fil: 'Na-scam? Sundin ang aming sunud-sunod na protocol sa emergency upang ma-secure kaagad ang iyong mga account.',
    km: 'ត្រូវបានគេបោកប្រាស់? អនុវត្តតាមពិធីសារសង្គ្រោះបន្ទាន់មួយជំហានម្តង ៗ របស់យើងដើម្បីការពារគណនីរបស់អ្នកភ្លាមៗ។',
    lo: 'ຖືກຫຼອກລວງ? ປະຕິບັດຕາມມາດຕະການສຸກເສີນເທື່ອລະຂັ້ນຕອນຂອງພວກເຮົາເພື່ອປົກປ້ອງບັນຊີຂອງທ່ານທັນທີ.',
    my: 'လိမ်လည်ခံရပါသလား? သင့်အကောင့်များကို ချက်ချင်းလုံခြုံစေရန် ကျွန်ုပ်တို့၏ အဆင့်ဆင့် အရေးပေါ် လုပ်ထုံးလုပ်နည်းကို လိုက်နာပါ။',
  },
  'quickAction.report.desc': {
    en: 'Find official reporting channels for police and banks across all 10 ASEAN countries.',
    id: 'Temukan saluran pelaporan resmi untuk polisi dan bank di seluruh 10 negara ASEAN.',
    ms: 'Cari saluran pelaporan rasmi untuk polis dan bank di semua 10 negara ASEAN.',
    th: 'ค้นหาช่องทางการรายงานอย่างเป็นทางการสำหรับตำรวจและธนาคารทั่วทั้ง 10 ประเทศอาเซียน',
    vi: 'Tìm các kênh báo cáo chính thức cho cảnh sát và ngân hàng trên tất cả 10 quốc gia ASEAN.',
    fil: 'Maghanap ng mga opisyal na channel ng pag-uulat para sa pulisya at mga bangko sa lahat ng 10 bansa sa ASEAN.',
    km: 'ស្វែងរកឆានែលរាយការណ៍ផ្លូវការសម្រាប់ប៉ូលីស និងធនាគារនៅទូទាំងប្រទេសអាស៊ានទាំង ១០។',
    lo: 'ຊອກຫາຊ່ອງທາງການລາຍງານຢ່າງເປັນທາງການສຳລັບຕຳຫຼວດ ແລະ ທະນາຄານທົ່ວ 10 ປະເທດອາຊຽນ.',
    my: 'အာဆီယံ ၁၀ နိုင်ငံလုံးရှိ ရဲတပ်ဖွဲ့နှင့် ဘဏ်များအတွက် တရားဝင်တိုင်ကြားရန် လမ်းကြောင်းများကို ရှာဖွေပါ။',
  },
  'action.startAssessment': {
    en: 'Start Assessment',
    id: 'Mulai Penilaian',
    ms: 'Mula Penilaian',
    th: 'เริ่มการประเมิน',
    vi: 'Bắt đầu đánh giá',
    fil: 'Simulan ang Pagsusuri',
    km: 'ចាប់ផ្តើមការវាយតម្លៃ',
    lo: 'ເລີ່ມການປະເມີນ',
    my: 'ဆန်းစစ်ခြင်း စတင်ရန်',
  },
  'action.startProtocol': {
    en: 'Start Protocol',
    id: 'Mulai Protokol',
    ms: 'Mula Protokol',
    th: 'เริ่มโปรโตคอล',
    vi: 'Bắt đầu giao thức',
    fil: 'Simulan ang Protokol',
    km: 'ចាប់ផ្តើមពិធីសារ',
    lo: 'ເລີ່ມມາດຕະການ',
    my: 'လုပ်ထုံးလုပ်နည်း စတင်ရန်',
  },
  'action.findAgency': {
    en: 'Find Agency',
    id: 'Cari Agensi',
    ms: 'Cari Agensi',
    th: 'ค้นหาหน่วยงาน',
    vi: 'Tìm cơ quan',
    fil: 'Maghanap ng Ahensya',
    km: 'ស្វែងរកទីភ្នាក់ងារ',
    lo: 'ຊອກຫາອົງການ',
    my: 'အေဂျင်စီ ရှာရန်',
  },
  'action.previous': {
    en: 'Previous',
    id: 'Sebelumnya',
    ms: 'Sebelumnya',
    th: 'ก่อนหน้า',
    vi: 'Trước',
    fil: 'Nakaraan',
    km: 'មុន',
    lo: 'ກ່ອນໜ້າ',
    my: 'ယခင်',
  },
  'action.next': {
    en: 'Next',
    id: 'Selanjutnya',
    ms: 'Seterusnya',
    th: 'ถัดไป',
    vi: 'Tiếp theo',
    fil: 'Susunod',
    km: 'បន្ទាប់',
    lo: 'ຕໍ່ໄປ',
    my: 'နောက်',
  },
  'action.learnMore': {
    en: 'Learn More',
    id: 'Pelajari Lebih Lanjut',
    ms: 'Ketahui Lebih Lanjut',
    th: 'เรียนรู้เพิ่มเติม',
    vi: 'Tìm hiểu thêm',
    fil: 'Matuto Pa',
    km: 'ស្វែងយល់បន្ថែម',
    lo: 'ຮຽນຮູ້ເພີ່ມເຕີມ',
    my: 'ပိုမိုလေ့လာရန်',
  },

  // --- PROTOCOL PAGE ---
  'protocol.backToHome': {
    en: 'Back to Home',
    id: 'Kembali ke Beranda',
    ms: 'Kembali ke Laman Utama',
    th: 'กลับสู่หน้าแรก',
    vi: 'Trở về trang chủ',
    fil: 'Bumalik sa Tahanan',
    km: 'ត្រឡប់ទៅទំព័រដើម',
    lo: 'ກັບຄືນສູ່ໜ້າຫຼັກ',
    my: 'ပင်မစာမျက်နှာသို့ ပြန်သွားရန်',
  },
  'protocol.unsureIfScam': {
    en: 'Unsure if this is a scam?',
    id: 'Tidak yakin apakah ini penipuan?',
    ms: 'Tidak pasti jika ini penipuan?',
    th: 'ไม่แน่ใจว่านี่คือการหลอกลวงหรือไม่?',
    vi: 'Không chắc đây có phải là lừa đảo không?',
    fil: 'Hindi sigurado kung ito ay scam?',
    km: 'មិនប្រាកដថាវាជាការបោកប្រាស់មែនទេ?',
    lo: 'ບໍ່ແນ່ໃຈວ່ານີ້ແມ່ນການຫຼອກລວງບໍ່?',
    my: 'ဒါ လိမ်လည်မှု ဟုတ်မဟုတ် မသေချာဘူးလား?',
  },
  'protocol.assessmentDesc': {
    en: 'Use our tools to verify.',
    id: 'Gunakan alat kami untuk memverifikasi.',
    ms: 'Gunakan alat kami untuk mengesahkan.',
    th: 'ใช้เครื่องมือของเราเพื่อตรวจสอบ',
    vi: 'Sử dụng các công cụ của chúng tôi để xác minh.',
    fil: 'Gamitin ang aming mga tool upang i-verify.',
    km: 'ប្រើឧបករណ៍របស់យើងដើម្បីផ្ទៀងផ្ទាត់។',
    lo: 'ໃຊ້ເຄື່ອງມືຂອງພວກເຮົາເພື່ອຢັ້ງຢືນ.',
    my: 'စစ်ဆေးရန် ကျွန်ုပ်တို့၏ ကိရိယာများကို အသုံးပြုပါ။',
  },
  'protocol.chatAssessment': {
    en: 'Chat Assessment',
    id: 'Penilaian Chat',
    ms: 'Penilaian Chat',
    th: 'การประเมินผ่านแชท',
    vi: 'Đánh giá qua trò chuyện',
    fil: 'Pagsusuri sa Chat',
    km: 'ការវាយតម្លៃការជជែក',
    lo: 'ການປະເມີນຜ່ານແຊັດ',
    my: 'ချက်တင် ဆန်းစစ်ခြင်း',
  },
  'protocol.quickChecklist': {
    en: 'Quick Checklist',
    id: 'Daftar Periksa Cepat',
    ms: 'Senarai Semak Pantas',
    th: 'รายการตรวจสอบด่วน',
    vi: 'Danh sách kiểm tra nhanh',
    fil: 'Mabilis na Checklist',
    km: 'បញ្ជីត្រួតពិនិត្យរហ័ស',
    lo: 'ລາຍການກວດສອບດ່ວນ',
    my: 'အမြန် စစ်ဆေးရန်စာရင်း',
  },
  'protocol.warningSigns': {
    en: 'Warning Signs',
    id: 'Tanda Peringatan',
    ms: 'Tanda Amaran',
    th: 'สัญญาณเตือน',
    vi: 'Dấu hiệu cảnh báo',
    fil: 'Mga Tanda ng Babala',
    km: 'សញ្ញាព្រមាន',
    lo: 'ສັນຍານເຕືອນ',
    my: 'သတိပေး လက္ခဏာများ',
  },
  'protocol.needTemplate': {
    en: 'Need a Report Template?',
    id: 'Butuh Templat Laporan?',
    ms: 'Perlukan Templat Laporan?',
    th: 'ต้องการเทมเพลตรายงานหรือไม่?',
    vi: 'Cần mẫu báo cáo?',
    fil: 'Kailangan ng Template ng Ulat?',
    km: 'ត្រូវការគំរូរបាយការណ៍ទេ?',
    lo: 'ຕ້ອງການແບບຟອມລາຍງານບໍ່?',
    my: 'တိုင်ကြားစာ ပုံစံ လိုအပ်ပါသလား?',
  },
  'protocol.templateDesc': {
    en: 'Generate a professional report for authorities.',
    id: 'Buat laporan profesional untuk pihak berwenang.',
    ms: 'Hasilkan laporan profesional untuk pihak berkuasa.',
    th: 'สร้างรายงานอย่างมืออาชีพสำหรับเจ้าหน้าที่',
    vi: 'Tạo báo cáo chuyên nghiệp cho cơ quan chức năng.',
    fil: 'Gumawa ng propesyonal na ulat para sa mga awtoridad.',
    km: 'បង្កើតរបាយការណ៍អាជីពសម្រាប់អាជ្ញាធរ។',
    lo: 'ສ້າງລາຍງານແບບມືອາຊີບສຳລັບເຈົ້າໜ້າທີ່.',
    my: 'အာဏာပိုင်များအတွက် ပရော်ဖက်ရှင်နယ် တိုင်ကြားစာ ထုတ်လုပ်ပါ။',
  },
  'protocol.goToGenerator': {
    en: 'Go to Generator',
    id: 'Pergi ke Generator',
    ms: 'Pergi ke Penjana',
    th: 'ไปที่เครื่องมือสร้าง',
    vi: 'Đi đến trình tạo',
    fil: 'Pumunta sa Generator',
    km: 'ទៅកាន់ម៉ាស៊ីនបង្កើត',
    lo: 'ໄປທີ່ເຄື່ອງມືສ້າງ',
    my: 'ထုတ်လုပ်စက်သို့ သွားရန်',
  },
  'protocol.immediateSteps': {
    en: 'Immediate Steps',
    id: 'Langkah Segera',
    ms: 'Langkah Segera',
    th: 'ขั้นตอนทันที',
    vi: 'Các bước ngay lập tức',
    fil: 'Mga Agarang Hakbang',
    km: 'ជំហានភ្លាមៗ',
    lo: 'ຂັ້ນຕອນທັນທີ',
    my: 'ချက်ချင်း လုပ်ဆောင်ရမည့် အဆင့်များ',
  },
  'protocol.evidenceToCollect': {
    en: 'Evidence to Collect',
    id: 'Bukti untuk Dikumpulkan',
    ms: 'Bukti untuk Dikumpul',
    th: 'หลักฐานที่ต้องรวบรวม',
    vi: 'Bằng chứng cần thu thập',
    fil: 'Ebidensyang Dapat Kolektahin',
    km: 'ភស្តុតាងដែលត្រូវប្រមូល',
    lo: 'ຫຼັກຖານທີ່ຕ້ອງເກັບກຳ',
    my: 'စုဆောင်းရမည့် သက်သေအထောက်အထား',
  },
  'protocol.evidenceDesc': {
    en: 'Gather these items before reporting to increase chances of recovery.',
    id: 'Kumpulkan item ini sebelum melapor untuk meningkatkan peluang pemulihan.',
    ms: 'Kumpulkan item ini sebelum melapor untuk meningkatkan peluang pemulihan.',
    th: 'รวบรวมรายการเหล่านี้ก่อนรายงานเพื่อเพิ่มโอกาสในการกู้คืน',
    vi: 'Thu thập các mục này trước khi báo cáo để tăng cơ hội phục hồi.',
    fil: 'Ipunin ang mga item na ito bago mag-report upang madagdagan ang tsansa ng pagbawi.',
    km: 'ប្រមូលធាតុទាំងនេះមុនពេលរាយការណ៍ដើម្បីបង្កើនឱកាសនៃការងើបឡើងវិញ។',
    lo: 'ເກັບກຳລາຍການເຫຼົ່ານີ້ກ່ອນລາຍງານເພື່ອເພີ່ມໂອກາດໃນການກູ້ຄືນ.',
    my: 'ပြန်လည်ရရှိနိုင်ခြေ တိုးမြင့်စေရန် တိုင်ကြားခြင်းမပြုမီ ဤအရာများကို စုဆောင်းပါ။',
  },
  'protocol.readyToReport': {
    en: 'Ready to Report?',
    id: 'Siap Melapor?',
    ms: 'Sedia untuk Melapor?',
    th: 'พร้อมที่จะรายงาน?',
    vi: 'Sẵn sàng báo cáo?',
    fil: 'Handa nang Mag-report?',
    km: 'ត្រៀមខ្លួនរាយការណ៍?',
    lo: 'ພ້ອມທີ່ຈະລາຍງານ?',
    my: 'တိုင်ကြားရန် အဆင်သင့်ဖြစ်ပြီလား?',
  },
  'protocol.readyToReportDesc': {
    en: 'Find the right agency for your country and scam type.',
    id: 'Temukan agensi yang tepat untuk negara dan jenis penipuan Anda.',
    ms: 'Cari agensi yang sesuai untuk negara dan jenis penipuan anda.',
    th: 'ค้นหาหน่วยงานที่เหมาะสมสำหรับประเทศและประเภทการหลอกลวงของคุณ',
    vi: 'Tìm cơ quan phù hợp cho quốc gia và loại lừa đảo của bạn.',
    fil: 'Hanapin ang tamang ahensya para sa iyong bansa at uri ng scam.',
    km: 'ស្វែងរកទីភ្នាក់ងារត្រឹមត្រូវសម្រាប់ប្រទេស និងប្រភេទការបោកប្រាស់របស់អ្នក។',
    lo: 'ຊອກຫາອົງການທີ່ເໝາະສົມສຳລັບປະເທດ ແລະ ປະເພດການຫຼອກລວງຂອງທ່ານ.',
    my: 'သင့်နိုင်ငံနှင့် လိမ်လည်မှုအမျိုးအစားအတွက် မှန်ကန်သော အေဂျင်စီကို ရှာဖွေပါ။',
  },
  'protocol.findReportingChannels': {
    en: 'Find Reporting Channels',
    id: 'Temukan Saluran Pelaporan',
    ms: 'Cari Saluran Pelaporan',
    th: 'ค้นหาช่องทางการรายงาน',
    vi: 'Tìm kênh báo cáo',
    fil: 'Maghanap ng mga Channel ng Pag-uulat',
    km: 'ស្វែងរកឆានែលរាយការណ៍',
    lo: 'ຊອກຫາຊ່ອງທາງການລາຍງານ',
    my: 'တိုင်ကြားရန် လမ်းကြောင်းများကို ရှာဖွေပါ',
  },
  'protocol.checkRiskLevel': {
    en: 'Check Risk Level',
    id: 'Cek Tingkat Risiko',
    ms: 'Semak Tahap Risiko',
    th: 'ตรวจสอบระดับความเสี่ยง',
    vi: 'Kiểm tra mức độ rủi ro',
    fil: 'Suriin ang Antas ng Panganib',
    km: 'ពិនិត្យកម្រិតហានិភ័យ',
    lo: 'ກວດສອບລະດັບຄວາມສ່ຽງ',
    my: 'အန္တရာယ်အဆင့်ကို စစ်ဆေးပါ',
  },

  // --- EMERGENCY PAGE ---
  'emergency.title': {
    en: 'Emergency Response Protocol',
    id: 'Protokol Respons Darurat',
    ms: 'Protokol Tindak Balas Kecemasan',
    th: 'โปรโตคอลการตอบสนองฉุกเฉิน',
    vi: 'Giao thức Phản ứng Khẩn cấp',
    fil: 'Protocol ng Pagtugon sa Emergency',
    km: 'ពិធីសារឆ្លើយតបសង្គ្រោះបន្ទាន់',
    lo: 'ມາດຕະການຕອບສະໜອງສຸກເສີນ',
    my: 'အရေးပေါ် တုံ့ပြန်မှု လုပ်ထုံးလုပ်နည်း',
  },
  'emergency.subtitle': {
    en: 'Follow these steps immediately if you suspect you have been scammed.',
    id: 'Ikuti langkah-langkah ini segera jika Anda curiga telah ditipu.',
    ms: 'Ikuti langkah-langkah ini dengan segera jika anda mengesyaki anda telah ditipu.',
    th: 'ทำตามขั้นตอนเหล่านี้ทันทีหากคุณสงสัยว่าถูกหลอกลวง',
    vi: 'Làm theo các bước này ngay lập tức nếu bạn nghi ngờ mình đã bị lừa đảo.',
    fil: 'Sundin ang mga hakbang na ito kaagad kung pinaghihinalaan mong na-scam ka.',
    km: 'អនុវត្តតាមជំហានទាំងនេះភ្លាមៗ ប្រសិនបើអ្នកសង្ស័យថាអ្នកត្រូវបានគេបោកប្រាស់។',
    lo: 'ປະຕິບັດຕາມຂັ້ນຕອນເຫຼົ່ານີ້ທັນທີຖ້າທ່ານສົງໃສວ່າທ່ານຖືກຫຼອກລວງ.',
    my: 'သင် လိမ်လည်ခံရသည်ဟု သံသယရှိပါက ဤအဆင့်များကို ချက်ချင်းလိုက်နာပါ။',
  },
  'emergency.step1.title': {
    en: 'Stop Financial Loss',
    id: 'Hentikan Kerugian Finansial',
    ms: 'Hentikan Kerugian Kewangan',
    th: 'หยุดการสูญเสียทางการเงิน',
    vi: 'Ngăn chặn tổn thất tài chính',
    fil: 'Itigil ang Pagkawala ng Pera',
    km: 'បញ្ឈប់ការខាតបង់ហិរញ្ញវត្ថុ',
    lo: 'ຢຸດການສູນເສຍທາງການເງິນ',
    my: 'ငွေကြေးဆုံးရှုံးမှုကို ရပ်တန့်ပါ',
  },
  'emergency.step2.title': {
    en: 'Secure Accounts',
    id: 'Amankan Akun',
    ms: 'Amankan Akaun',
    th: 'รักษาความปลอดภัยบัญชี',
    vi: 'Bảo vệ tài khoản',
    fil: 'I-secure ang mga Account',
    km: 'ការពារគណនី',
    lo: 'ປົກປ້ອງບັນຊີ',
    my: 'အကောင့်များကို လုံခြုံအောင်ထားပါ',
  },
  'emergency.step3.title': {
    en: 'Collect Evidence',
    id: 'Kumpulkan Bukti',
    ms: 'Kumpul Bukti',
    th: 'รวบรวมหลักฐาน',
    vi: 'Thu thập bằng chứng',
    fil: 'Mangolekta ng Ebidensya',
    km: 'ប្រមូលភស្តុតាង',
    lo: 'ເກັບກຳຫຼັກຖານ',
    my: 'သက်သေအထောက်အထား စုဆောင်းပါ',
  },
  'emergency.step4.title': {
    en: 'Block Communication',
    id: 'Blokir Komunikasi',
    ms: 'Sekat Komunikasi',
    th: 'บล็อกการสื่อสาร',
    vi: 'Chặn liên lạc',
    fil: 'I-block ang Komunikasyon',
    km: 'បិទការទំនាក់ទំនង',
    lo: 'ບລັອກການສື່ສານ',
    my: 'ဆက်သွယ်မှုကို ပိတ်ပင်ပါ',
  },
  'emergency.step5.title': {
    en: 'Report Incident',
    id: 'Laporkan Insiden',
    ms: 'Lapor Insiden',
    th: 'รายงานเหตุการณ์',
    vi: 'Báo cáo sự cố',
    fil: 'I-report ang Insidente',
    km: 'រាយការណ៍ហេតុការណ៍',
    lo: 'ລາຍງານເຫດການ',
    my: 'ဖြစ်စဉ်ကို တိုင်ကြားပါ',
  },
  'emergency.step6.title': {
    en: 'Recovery & Support',
    id: 'Pemulihan & Dukungan',
    ms: 'Pemulihan & Sokongan',
    th: 'การกู้คืนและการสนับสนุน',
    vi: 'Phục hồi & Hỗ trợ',
    fil: 'Pagbawi at Suporta',
    km: 'ការងើបឡើងវិញ & ការគាំទ្រ',
    lo: 'ການຟື້ນຟູ & ການສະໜັບສະໜູນ',
    my: 'ပြန်လည်ထူထောင်ရေးနှင့် ပံ့ပိုးမှု',
  },
  'emergency.step1.item1': {
    en: 'Contact your bank immediately to freeze accounts',
    id: 'Hubungi bank Anda segera untuk membekukan akun',
    ms: 'Hubungi bank anda dengan segera untuk membekukan akaun',
    th: 'ติดต่อธนาคารของคุณทันทีเพื่ออายัดบัญชี',
    vi: 'Liên hệ với ngân hàng của bạn ngay lập tức để đóng băng tài khoản',
    fil: 'Makipag-ugnayan kaagad sa iyong bangko upang i-freeze ang mga account',
    km: 'ទាក់ទងធនាគាររបស់អ្នកភ្លាមៗដើម្បីបង្កកគណនី',
    lo: 'ຕິດຕໍ່ທະນາຄານຂອງທ່ານທັນທີເພື່ອລະງັບບັນຊີ',
    my: 'အကောင့်များကို ယာယီပိတ်ရန် သင့်ဘဏ်ကို ချက်ချင်းဆက်သွယ်ပါ',
  },
  'emergency.step1.item2': {
    en: 'Do NOT pay any more money (fees, taxes, etc.)',
    id: 'JANGAN bayar uang lagi (biaya, pajak, dll.)',
    ms: 'JANGAN bayar sebarang wang lagi (yuran, cukai, dll.)',
    th: 'อย่าจ่ายเงินเพิ่ม (ค่าธรรมเนียม ภาษี ฯลฯ)',
    vi: 'KHÔNG trả thêm bất kỳ khoản tiền nào (phí, thuế, v.v.)',
    fil: 'HUWAG magbayad ng anumang karagdagang pera (mga bayarin, buwis, atbp.)',
    km: 'កុំបង់ប្រាក់បន្ថែមទៀត (ថ្លៃសេវា ពន្ធ ។ល។)',
    lo: 'ຢ່າຈ່າຍເງິນເພີ່ມເຕີມ (ຄ່າທຳນຽມ, ພາສີ, ແລະອື່ນໆ)',
    my: 'နောက်ထပ် ငွေထပ်မပေးပါနှင့် (ကြေးများ၊ အခွန်များ စသည်)',
  },
  'emergency.step1.item3': {
    en: 'Cancel any pending transactions or cards',
    id: 'Batalkan transaksi atau kartu yang tertunda',
    ms: 'Batalkan sebarang transaksi atau kad yang tertunda',
    th: 'ยกเลิกธุรกรรมหรือบัตรที่รอดำเนินการ',
    vi: 'Hủy mọi giao dịch hoặc thẻ đang chờ xử lý',
    fil: 'Kanselahin ang anumang nakabinbing transaksyon o card',
    km: 'បោះបង់ប្រតិបត្តិការ ឬកាតដែលកំពុងរង់ចាំ',
    lo: 'ຍົກເລີກການເຮັດທຸລະກຳ ຫຼື ບັດທີ່ຍັງຄ້າງຢູ່',
    my: 'ဆိုင်းငံ့ထားသော ငွေလွှဲမှုများ သို့မဟုတ် ကတ်များကို ပယ်ဖျက်ပါ',
  },
  'emergency.step2.item1': {
    en: 'Change passwords for email and banking',
    id: 'Ubah kata sandi untuk email dan perbankan',
    ms: 'Tukar kata laluan untuk e-mel dan perbankan',
    th: 'เปลี่ยนรหัสผ่านสำหรับอีเมลและธนาคาร',
    vi: 'Thay đổi mật khẩu cho email và ngân hàng',
    fil: 'Palitan ang mga password para sa email at pagbabangko',
    km: 'ផ្លាស់ប្តូរពាក្យសម្ងាត់សម្រាប់អ៊ីមែល និងធនាគារ',
    lo: 'ປ່ຽນລະຫັດຜ່ານສຳລັບອີເມວ ແລະ ທະນາຄານ',
    my: 'အီးမေးလ်နှင့် ဘဏ်လုပ်ငန်းအတွက် စကားဝှက်များကို ပြောင်းလဲပါ',
  },
  'emergency.step2.item2': {
    en: 'Enable Two-Factor Authentication (2FA)',
    id: 'Aktifkan Autentikasi Dua Faktor (2FA)',
    ms: 'Aktifkan Pengesahan Dua Faktor (2FA)',
    th: 'เปิดใช้งานการยืนยันตัวตนสองปัจจัย (2FA)',
    vi: 'Bật xác thực hai yếu tố (2FA)',
    fil: 'I-enable ang Two-Factor Authentication (2FA)',
    km: 'បើកការផ្ទៀងផ្ទាត់ពីរជំហាន (2FA)',
    lo: 'ເປີດໃຊ້ການຢັ້ງຢືນສອງຂັ້ນຕອນ (2FA)',
    my: 'အချက်နှစ်ချက်ဖြင့် အတည်ပြုခြင်း (2FA) ကို ဖွင့်ပါ',
  },
  'emergency.step2.item3': {
    en: 'Log out of all devices',
    id: 'Keluar dari semua perangkat',
    ms: 'Log keluar dari semua peranti',
    th: 'ออกจากระบบทุกอุปกรณ์',
    vi: 'Đăng xuất khỏi tất cả các thiết bị',
    fil: 'Mag-log out sa lahat ng device',
    km: 'ចាកចេញពីឧបករណ៍ទាំងអស់',
    lo: 'ອອກຈາກລະບົບທຸກອຸປະກອນ',
    my: 'စက်ပစ္စည်းအားလုံးမှ ထွက်ပါ',
  },
  'emergency.step3.item1': {
    en: 'Take screenshots of chats and profiles',
    id: 'Ambil tangkapan layar obrolan dan profil',
    ms: 'Ambil tangkapan skrin sembang dan profil',
    th: 'แคปหน้าจอแชทและโปรไฟล์',
    vi: 'Chụp ảnh màn hình các cuộc trò chuyện và hồ sơ',
    fil: 'Kumuha ng mga screenshot ng mga chat at profile',
    km: 'ថតអេក្រង់នៃការជជែក និងប្រវត្តិរូប',
    lo: 'ຖ່າຍຮູບໜ້າຈໍການສົນທະນາ ແລະ ໂປຣໄຟລ໌',
    my: 'ချက်တင်များနှင့် ပရိုဖိုင်များကို စခရင်ရှော့ရိုက်ပါ',
  },
  'emergency.step3.item2': {
    en: 'Save transaction IDs and receipts',
    id: 'Simpan ID transaksi dan tanda terima',
    ms: 'Simpan ID transaksi dan resit',
    th: 'บันทึกรหัสธุรกรรมและใบเสร็จรับเงิน',
    vi: 'Lưu ID giao dịch và biên lai',
    fil: 'I-save ang mga transaction ID at resibo',
    km: 'រក្សាទុកលេខសម្គាល់ប្រតិបត្តិការ និងបង្កាន់ដៃ',
    lo: 'ບັນທຶກ ID ທຸລະກຳ ແລະ ໃບຮັບເງິນ',
    my: 'ငွေလွှဲ ID များနှင့် ပြေစာများကို သိမ်းဆည်းပါ',
  },
  'emergency.step3.item3': {
    en: 'Copy URLs of websites or profiles',
    id: 'Salin URL situs web atau profil',
    ms: 'Salin URL laman web atau profil',
    th: 'คัดลอก URL ของเว็บไซต์หรือโปรไฟล์',
    vi: 'Sao chép URL của trang web hoặc hồ sơ',
    fil: 'Kopyahin ang mga URL ng mga website o profile',
    km: 'ចម្លង URL នៃគេហទំព័រ ឬប្រវត្តិរូប',
    lo: 'ຄັດລອກ URL ຂອງເວັບໄຊທ໌ ຫຼື ໂປຣໄຟລ໌',
    my: 'ဝက်ဘ်ဆိုက်များ သို့မဟုတ် ပရိုဖိုင်များ၏ URL များကို ကူးယူပါ',
  },
  'emergency.step3.item4': {
    en: 'Do not delete any messages',
    id: 'Jangan hapus pesan apa pun',
    ms: 'Jangan padam sebarang mesej',
    th: 'อย่าลบข้อความใดๆ',
    vi: 'Không xóa bất kỳ tin nhắn nào',
    fil: 'Huwag magbura ng anumang mensahe',
    km: 'កុំលុបសារណាមួយ',
    lo: 'ຢ່າລຶບຂໍ້ຄວາມໃດໆ',
    my: 'မက်ဆေ့ခ်ျများကို မဖျက်ပါနှင့်',
  },
  'emergency.step4.item1': {
    en: 'Block the scammer on all platforms',
    id: 'Blokir penipu di semua platform',
    ms: 'Sekat penipu di semua platform',
    th: 'บล็อกมิจฉาชีพในทุกแพลตฟอร์ม',
    vi: 'Chặn kẻ lừa đảo trên tất cả các nền tảng',
    fil: 'I-block ang scammer sa lahat ng platform',
    km: 'បិទអ្នកបោកប្រាស់នៅលើគ្រប់វេទិកា',
    lo: 'ບລັອກຜູ້ຫຼອກລວງໃນທຸກແພລດຟອມ',
    my: 'ပလက်ဖောင်းအားလုံးတွင် လိမ်လည်သူကို ပိတ်ပင်ပါ',
  },
  'emergency.step4.item2': {
    en: 'Do not reply to new messages from strangers',
    id: 'Jangan balas pesan baru dari orang asing',
    ms: 'Jangan balas mesej baru daripada orang yang tidak dikenali',
    th: 'อย่าตอบกลับข้อความใหม่จากคนแปลกหน้า',
    vi: 'Không trả lời tin nhắn mới từ người lạ',
    fil: 'Huwag sumagot sa mga bagong mensahe mula sa mga estranghero',
    km: 'កុំឆ្លើយតបសារថ្មីពីមនុស្សចម្លែក',
    lo: 'ຢ່າຕອບກັບຂໍ້ຄວາມໃໝ່ຈາກຄົນແປກໜ້າ',
    my: 'သူစိမ်းများထံမှ မက်ဆေ့ခ်ျအသစ်များကို ပြန်မဖြေပါနှင့်',
  },
  'emergency.step1.desc': {
    en: 'Time is critical. Contacting your bank within the first 24 hours increases the chance of recovering funds.',
    id: 'Waktu sangat penting. Menghubungi bank Anda dalam 24 jam pertama meningkatkan peluang pemulihan dana.',
    ms: 'Masa adalah kritikal. Menghubungi bank anda dalam masa 24 jam pertama meningkatkan peluang untuk mendapatkan semula dana.',
    th: 'เวลาเป็นสิ่งสำคัญ การติดต่อธนาคารของคุณภายใน 24 ชั่วโมงแรกจะเพิ่มโอกาสในการกู้คืนเงิน',
    vi: 'Thời gian là rất quan trọng. Liên hệ với ngân hàng của bạn trong vòng 24 giờ đầu tiên làm tăng cơ hội thu hồi tiền.',
    fil: 'Mahalaga ang oras. Ang pakikipag-ugnayan sa iyong bangko sa loob ng unang 24 na oras ay nagpapataas ng tsansa na mabawi ang pondo.',
    km: 'ពេលវេលាគឺសំខាន់ណាស់។ ការទាក់ទងធនាគាររបស់អ្នកក្នុងរយៈពេល 24 ម៉ោងដំបូងបង្កើនឱកាសនៃការទទួលបានប្រាក់មកវិញ។',
    lo: 'ເວລາເປັນສິ່ງສຳຄັນ. ການຕິດຕໍ່ທະນາຄານຂອງທ່ານພາຍໃນ 24 ຊົ່ວໂມງທຳອິດເພີ່ມໂອກາດໃນການກູ້ຄືນເງິນ.',
    my: 'အချိန်သည် အရေးကြီးသည်။ ပထမ ၂၄ နာရီအတွင်း သင့်ဘဏ်ကို ဆက်သွယ်ခြင်းသည် ငွေပြန်ရနိုင်ခြေကို တိုးစေသည်။',
  },
  'emergency.step2.desc': {
    en: 'Scammers may have access to your accounts. Lock them out immediately.',
    id: 'Penipu mungkin memiliki akses ke akun Anda. Kunci mereka segera.',
    ms: 'Penipu mungkin mempunyai akses ke akaun anda. Kunci mereka keluar dengan segera.',
    th: 'มิจฉาชีพอาจเข้าถึงบัญชีของคุณ ล็อคพวกเขาออกทันที',
    vi: 'Kẻ lừa đảo có thể có quyền truy cập vào tài khoản của bạn. Khóa chúng ngay lập tức.',
    fil: 'Maaaring may access ang mga scammer sa iyong mga account. I-lock sila kaagad.',
    km: 'អ្នកបោកប្រាស់អាចមានសិទ្ធិចូលប្រើគណនីរបស់អ្នក។ ចាក់សោពួកវាភ្លាមៗ។',
    lo: 'ຜູ້ຫຼອກລວງອາດຈະເຂົ້າເຖິງບັນຊີຂອງທ່ານ. ລັອກພວກເຂົາອອກທັນທີ.',
    my: 'လိမ်လည်သူများသည် သင့်အကောင့်များကို ဝင်ရောက်နိုင်ကောင်း ဝင်ရောက်နိုင်ပါလိမ့်မည်။ ၎င်းတို့ကို ချက်ချင်း ပိတ်ပင်ပါ။',
  },
  'emergency.step3.warning': {
    en: 'Do not edit screenshots. Metadata is important for police investigations.',
    id: 'Jangan edit tangkapan layar. Metadata penting untuk penyelidikan polisi.',
    ms: 'Jangan sunting tangkapan skrin. Metadata penting untuk siasatan polis.',
    th: 'อย่าแก้ไขภาพหน้าจอ ข้อมูลเมตาสำคัญต่อการสอบสวนของตำรวจ',
    vi: 'Không chỉnh sửa ảnh chụp màn hình. Siêu dữ liệu rất quan trọng cho các cuộc điều tra của cảnh sát.',
    fil: 'Huwag i-edit ang mga screenshot. Mahalaga ang metadata para sa mga imbestigasyon ng pulisya.',
    km: 'កុំកែសម្រួលរូបថតអេក្រង់។ ទិន្នន័យមេតាមានសារៈសំខាន់សម្រាប់ការស៊ើបអង្កេតរបស់ប៉ូលីស។',
    lo: 'ຢ່າແກ້ໄຂຮູບພາບໜ້າຈໍ. ຂໍ້ມູນເມຕາສຳຄັນສຳລັບການສືບສວນຂອງຕຳຫຼວດ.',
    my: 'စခရင်ရှော့များကို မပြုပြင်ပါနှင့်။ မေတာဒေတာသည် ရဲတပ်ဖွဲ့ စုံစမ်းစစ်ဆေးမှုများအတွက် အရေးကြီးသည်။',
  },
  'emergency.step4.desc': {
    en: 'Engaging further usually leads to more loss. Cut all ties.',
    id: 'Terlibat lebih jauh biasanya menyebabkan lebih banyak kerugian. Putuskan semua hubungan.',
    ms: 'Terlibat lebih lanjut biasanya membawa kepada lebih banyak kerugian. Putuskan semua hubungan.',
    th: 'การมีส่วนร่วมเพิ่มเติมมักนำไปสู่การสูญเสียมากขึ้น ตัดความสัมพันธ์ทั้งหมด',
    vi: 'Tham gia thêm thường dẫn đến mất mát nhiều hơn. Cắt đứt mọi liên hệ.',
    fil: 'Ang pakikipag-ugnayan pa ay karaniwang humahantong sa higit pang pagkawala. Putulin ang lahat ng ugnayan.',
    km: 'ការចូលរួមបន្ថែមទៀតជាធម្មតានាំឱ្យមានការខាតបង់កាន់តែច្រើន។ កាត់ផ្តាច់ទំនាក់ទំនងទាំងអស់។',
    lo: 'ການມີສ່ວນຮ່ວມຕື່ມອີກມັກຈະນຳໄປສູ່ການສູນເສຍຫຼາຍຂຶ້ນ. ຕັດຄວາມສຳພັນທັງໝົດ.',
    my: 'ဆက်လက်ပတ်သက်ခြင်းသည် များသောအားဖြင့် ဆုံးရှုံးမှု ပိုများစေသည်။ အဆက်အသွယ်အားလုံးကို ဖြတ်တောက်ပါ။',
  },
  'emergency.step5.desc': {
    en: 'Use our directory to find the right authority for your specific situation.',
    id: 'Gunakan direktori kami untuk menemukan otoritas yang tepat untuk situasi spesifik Anda.',
    ms: 'Gunakan direktori kami untuk mencari pihak berkuasa yang sesuai untuk situasi khusus anda.',
    th: 'ใช้สารบบของเราเพื่อค้นหาหน่วยงานที่เหมาะสมสำหรับสถานการณ์เฉพาะของคุณ',
    vi: 'Sử dụng danh bạ của chúng tôi để tìm cơ quan phù hợp cho tình huống cụ thể của bạn.',
    fil: 'Gamitin ang aming direktoryo upang mahanap ang tamang awtoridad para sa iyong partikular na sitwasyon.',
    km: 'ប្រើបញ្ជីឈ្មោះរបស់យើងដើម្បីស្វែងរកអាជ្ញាធរត្រឹមត្រូវសម្រាប់ស្ថានភាពជាក់លាក់របស់អ្នក។',
    lo: 'ໃຊ້ປຶ້ມລາຍຊື່ຂອງພວກເຮົາເພື່ອຊອກຫາເຈົ້າໜ້າທີ່ທີ່ເໝາະສົມສຳລັບສະຖານະການສະເພາະຂອງທ່ານ.',
    my: 'သင့်အခြေအနေအတွက် မှန်ကန်သော အာဏာပိုင်ကို ရှာဖွေရန် ကျွန်ုပ်တို့၏ လမ်းညွှန်ကို အသုံးပြုပါ။',
  },
  'emergency.critical': {
    en: 'CRITICAL',
    id: 'KRITIS',
    ms: 'KRITIKAL',
    th: 'วิกฤต',
    vi: 'QUAN TRỌNG',
    fil: 'KRITIKAL',
    km: 'សំខាន់',
    lo: 'ສຳຄັນ',
    my: 'အရေးကြီး',
  },
  'emergency.immediateAction': {
    en: 'Immediate Action Required',
    id: 'Tindakan Segera Diperlukan',
    ms: 'Tindakan Segera Diperlukan',
    th: 'ต้องดำเนินการทันที',
    vi: 'Yêu cầu hành động ngay lập tức',
    fil: 'Kinakailangan ang Agarang Aksyon',
    km: 'ត្រូវការសកម្មភាពភ្លាមៗ',
    lo: 'ຕ້ອງການການດຳເນີນການທັນທີ',
    my: 'ချက်ချင်း အရေးယူရန် လိုအပ်သည်',
  },
  'emergency.step1.note': {
    en: 'Note: Banks may require a police report number to proceed with investigations.',
    id: 'Catatan: Bank mungkin memerlukan nomor laporan polisi untuk melanjutkan penyelidikan.',
    ms: 'Nota: Bank mungkin memerlukan nombor laporan polis untuk meneruskan siasatan.',
    th: 'หมายเหตุ: ธนาคารอาจต้องการเลขที่ใบแจ้งความเพื่อดำเนินการสอบสวนต่อ',
    vi: 'Lưu ý: Ngân hàng có thể yêu cầu số báo cáo cảnh sát để tiến hành điều tra.',
    fil: 'Tandaan: Maaaring mangailangan ang mga bangko ng numero ng ulat ng pulisya upang magpatuloy sa mga imbestigasyon.',
    km: 'ចំណាំ៖ ធនាគារអាចទាមទារលេខរបាយការណ៍ប៉ូលីសដើម្បីបន្តការស៊ើបអង្កេត។',
    lo: 'ໝາຍເຫດ: ທະນາຄານອາດຈະຕ້ອງການເລກລາຍງານຕຳຫຼວດເພື່ອດຳເນີນການສືບສວນຕໍ່.',
    my: 'မှတ်ချက် - စုံစမ်းစစ်ဆေးမှုများ ဆက်လက်လုပ်ဆောင်ရန် ဘဏ်များက ရဲတိုင်ကြားစာ နံပါတ် လိုအပ်နိုင်သည်။',
  },
  'emergency.overallProgress': {
    en: 'Overall Progress',
    id: 'Kemajuan Keseluruhan',
    ms: 'Kemajuan Keseluruhan',
    th: 'ความคืบหน้าโดยรวม',
    vi: 'Tiến độ tổng thể',
    fil: 'Pangkalahatang Pag-unlad',
    km: 'វឌ្ឍនភាពសរុប',
    lo: 'ຄວາມຄືບໜ້າໂດຍລວມ',
    my: 'အလုံးစုံ တိုးတက်မှု',
  },
  'emergency.actionsCompleted': {
    en: 'actions completed',
    id: 'tindakan selesai',
    ms: 'tindakan selesai',
    th: 'การดำเนินการเสร็จสิ้น',
    vi: 'hành động đã hoàn thành',
    fil: 'mga aksyong natapos',
    km: 'សកម្មភាពបានបញ្ចប់',
    lo: 'ການດຳເນີນການສຳເລັດ',
    my: 'ပြီးစီးသော လုပ်ဆောင်ချက်များ',
  },
  'emergency.stepProgress': {
    en: 'Step Progress',
    id: 'Kemajuan Langkah',
    ms: 'Kemajuan Langkah',
    th: 'ความคืบหน้าของขั้นตอน',
    vi: 'Tiến độ bước',
    fil: 'Pag-unlad ng Hakbang',
    km: 'វឌ្ឍនភាពជំហាន',
    lo: 'ຄວາມຄືບໜ້າຂອງຂັ້ນຕອນ',
    my: 'အဆင့် တိုးတက်မှု',
  },
  'emergency.protocolCompletion': {
    en: 'Protocol Completion',
    id: 'Penyelesaian Protokol',
    ms: 'Penyelesaian Protokol',
    th: 'การเสร็จสิ้นโปรโตคอล',
    vi: 'Hoàn thành giao thức',
    fil: 'Pagkumpleto ng Protokol',
    km: 'ការបញ្ចប់ពិធីសារ',
    lo: 'ການສຳເລັດມາດຕະການ',
    my: 'လုပ်ထုံးလုပ်နည်း ပြီးစီးမှု',
  },
  'emergency.stepsCompleted': {
    en: 'steps completed',
    id: 'langkah selesai',
    ms: 'langkah selesai',
    th: 'ขั้นตอนเสร็จสิ้น',
    vi: 'bước đã hoàn thành',
    fil: 'mga hakbang na natapos',
    km: 'ជំហានបានបញ្ចប់',
    lo: 'ຂັ້ນຕອນສຳເລັດ',
    my: 'ပြီးစီးသော အဆင့်များ',
  },
  'emergency.excellentProgress': {
    en: 'Excellent Progress',
    id: 'Kemajuan Luar Biasa',
    ms: 'Kemajuan Cemerlang',
    th: 'ความคืบหน้ายอดเยี่ยม',
    vi: 'Tiến độ xuất sắc',
    fil: 'Napakahusay na Pag-unlad',
    km: 'វឌ្ឍនភាពល្អប្រសើរ',
    lo: 'ຄວາມຄືບໜ້າດີເລີດ',
    my: 'ထူးချွန်သော တိုးတက်မှု',
  },
  'emergency.goodStart': {
    en: 'Good Start',
    id: 'Awal yang Baik',
    ms: 'Permulaan yang Baik',
    th: 'การเริ่มต้นที่ดี',
    vi: 'Khởi đầu tốt',
    fil: 'Magandang Simula',
    km: 'ការចាប់ផ្តើមល្អ',
    lo: 'ການເລີ່ມຕົ້ນທີ່ດີ',
    my: 'ကောင်းမွန်သော အစ',
  },
  'emergency.actionRequired': {
    en: 'Action Required',
    id: 'Tindakan Diperlukan',
    ms: 'Tindakan Diperlukan',
    th: 'ต้องดำเนินการ',
    vi: 'Yêu cầu hành động',
    fil: 'Kinakailangan ng Aksyon',
    km: 'ត្រូវការសកម្មភាព',
    lo: 'ຕ້ອງການການດຳເນີນການ',
    my: 'အရေးယူရန် လိုအပ်သည်',
  },
  'emergency.completion.high': {
    en: "You've taken comprehensive steps to secure yourself. Proceed to reporting.",
    id: 'Anda telah mengambil langkah komprehensif untuk mengamankan diri. Lanjutkan ke pelaporan.',
    ms: 'Anda telah mengambil langkah komprehensif untuk mengamankan diri. Teruskan ke pelaporan.',
    th: 'คุณได้ดำเนินการตามขั้นตอนที่ครอบคลุมเพื่อรักษาความปลอดภัยของตัวเอง ดำเนินการรายงานต่อ',
    vi: 'Bạn đã thực hiện các bước toàn diện để bảo vệ bản thân. Tiến hành báo cáo.',
    fil: 'Gumawa ka ng mga komprehensibong hakbang upang ma-secure ang iyong sarili. Magpatuloy sa pag-uulat.',
    km: 'អ្នកបានចាត់វិធានការយ៉ាងទូលំទូលាយដើម្បីការពារខ្លួនអ្នក។ បន្តទៅរាយការណ៍។',
    lo: 'ທ່ານໄດ້ປະຕິບັດຂັ້ນຕອນທີ່ສົມບູນແບບເພື່ອປົກປ້ອງຕົວເອງ. ດຳເນີນການລາຍງານ.',
    my: 'သင့်ကိုယ်သင် လုံခြုံစေရန် ပြီးပြည့်စုံသော အဆင့်များကို လုပ်ဆောင်ပြီးဖြစ်သည်။ တိုင်ကြားရန် ဆက်လက်ဆောင်ရွက်ပါ။',
  },
  'emergency.completion.medium': {
    en: 'You have secured the basics, but some critical steps remain. Review the checklist.',
    id: 'Anda telah mengamankan dasar-dasarnya, tetapi beberapa langkah penting masih ada. Tinjau daftar periksa.',
    ms: 'Anda telah mengamankan asasnya, tetapi beberapa langkah kritikal masih ada. Semak senarai semak.',
    th: 'คุณได้รักษาความปลอดภัยขั้นพื้นฐานแล้ว แต่ยังมีขั้นตอนสำคัญเหลืออยู่ ตรวจสอบรายการตรวจสอบ',
    vi: 'Bạn đã bảo vệ những điều cơ bản, nhưng một số bước quan trọng vẫn còn. Xem lại danh sách kiểm tra.',
    fil: 'Na-secure mo na ang mga pangunahing kaalaman, ngunit may ilang kritikal na hakbang na natitira. Suriin ang checklist.',
    km: 'អ្នកបានការពារមូលដ្ឋាន ប៉ុន្តែជំហានសំខាន់ៗមួយចំនួននៅតែមាន។ ពិនិត្យបញ្ជីត្រួតពិនិត្យ។',
    lo: 'ທ່ານໄດ້ປົກປ້ອງພື້ນຖານແລ້ວ, ແຕ່ຍັງມີຂັ້ນຕອນສຳຄັນບາງຢ່າງ. ກວດເບິ່ງລາຍການກວດສອບ.',
    my: 'အခြေခံများကို လုံခြုံစေပြီးဖြစ်သော်လည်း အရေးကြီးသော အဆင့်အချို့ ကျန်ရှိနေသေးသည်။ စစ်ဆေးရန်စာရင်းကို ပြန်လည်သုံးသပ်ပါ။',
  },
  'emergency.completion.low': {
    en: 'Your accounts may still be vulnerable. Please complete the critical steps immediately.',
    id: 'Akun Anda mungkin masih rentan. Harap selesaikan langkah-langkah penting segera.',
    ms: 'Akaun anda mungkin masih terdedah. Sila lengkapkan langkah-langkah kritikal dengan segera.',
    th: 'บัญชีของคุณอาจยังมีความเสี่ยง โปรดทำตามขั้นตอนสำคัญทันที',
    vi: 'Tài khoản của bạn có thể vẫn dễ bị tổn thương. Vui lòng hoàn thành các bước quan trọng ngay lập tức.',
    fil: 'Maaaring vulnerable pa rin ang iyong mga account. Pakikumpleto kaagad ang mga kritikal na hakbang.',
    km: 'គណនីរបស់អ្នកនៅតែអាចងាយរងគ្រោះ។ សូមបំពេញជំហានសំខាន់ៗភ្លាមៗ។',
    lo: 'ບັນຊີຂອງທ່ານອາດຈະຍັງມີຄວາມສ່ຽງ. ກະລຸນາເຮັດສຳເລັດຂັ້ນຕອນສຳຄັນທັນທີ.',
    my: 'သင့်အကောင့်များသည် အန္တရာယ်ရှိနေနိုင်သေးသည်။ အရေးကြီးသော အဆင့်များကို ချက်ချင်း ပြီးမြောက်အောင် လုပ်ပါ။',
  },
  'emergency.incompleteSteps': {
    en: 'Incomplete Steps:',
    id: 'Langkah Belum Selesai:',
    ms: 'Langkah Belum Selesai:',
    th: 'ขั้นตอนที่ยังไม่เสร็จสิ้น:',
    vi: 'Các bước chưa hoàn thành:',
    fil: 'Hindi Kumpletong mga Hakbang:',
    km: 'ជំហានមិនពេញលេញ:',
    lo: 'ຂັ້ນຕອນທີ່ຍັງບໍ່ສຳເລັດ:',
    my: 'မပြီးစီးသေးသော အဆင့်များ -',
  },
  'emergency.itemsRemaining': {
    en: 'items remaining',
    id: 'item tersisa',
    ms: 'item tinggal',
    th: 'รายการที่เหลือ',
    vi: 'mục còn lại',
    fil: 'mga item na natitira',
    km: 'ធាតុដែលនៅសល់',
    lo: 'ລາຍການທີ່ຍັງເຫຼືອ',
    my: 'ကျန်ရှိသော အရာများ',
  },
  'emergency.reportToAuthorities': {
    en: 'Report to Authorities',
    id: 'Lapor ke Pihak Berwenang',
    ms: 'Lapor kepada Pihak Berkuasa',
    th: 'รายงานต่อเจ้าหน้าที่',
    vi: 'Báo cáo cho cơ quan chức năng',
    fil: 'Mag-report sa mga Awtoridad',
    km: 'រាយការណ៍ទៅអាជ្ញាធរ',
    lo: 'ລາຍງານຕໍ່ເຈົ້າໜ້າທີ່',
    my: 'အာဏာပိုင်များထံ တိုင်ကြားရန်',
  },
  'emergency.reviewProtocol': {
    en: 'Review Protocol',
    id: 'Tinjau Protokol',
    ms: 'Semak Protokol',
    th: 'ตรวจสอบโปรโตคอล',
    vi: 'Xem lại giao thức',
    fil: 'Suriin ang Protokol',
    km: 'ពិនិត្យពិធីសារ',
    lo: 'ກວດເບິ່ງມາດຕະການ',
    my: 'လုပ်ထုံးလုပ်နည်းကို ပြန်လည်သုံးသပ်ရန်',
  },
  'emergency.viewCompletion': {
    en: 'View Completion',
    id: 'Lihat Penyelesaian',
    ms: 'Lihat Penyelesaian',
    th: 'ดูการเสร็จสิ้น',
    vi: 'Xem hoàn thành',
    fil: 'Tingnan ang Pagkumpleto',
    km: 'មើលការបញ្ចប់',
    lo: 'ເບິ່ງການສຳເລັດ',
    my: 'ပြီးစီးမှုကို ကြည့်ရန်',
  },

  // --- CHECK SCAM PAGE ---
  'checkScam.progress': {
    en: 'Progress',
    id: 'Kemajuan',
    ms: 'Kemajuan',
    th: 'ความคืบหน้า',
    vi: 'Tiến độ',
    fil: 'Pag-unlad',
    km: 'វឌ្ឍនភាព',
    lo: 'ຄວາມຄືບໜ້າ',
    my: 'တိုးတက်မှု',
  },
  'checkScam.of': {
    en: 'of',
    id: 'dari',
    ms: 'daripada',
    th: 'จาก',
    vi: 'của',
    fil: 'ng',
    km: 'នៃ',
    lo: 'ຂອງ',
    my: '၏',
  },
  'checkScam.answered': {
    en: 'answered',
    id: 'dijawab',
    ms: 'dijawab',
    th: 'ตอบแล้ว',
    vi: 'đã trả lời',
    fil: 'nasagot',
    km: 'បានឆ្លើយ',
    lo: 'ຕອບແລ້ວ',
    my: 'ဖြေဆိုပြီး',
  },
  'checkScam.specificIndicators': {
    en: 'Specific Indicators',
    id: 'Indikator Spesifik',
    ms: 'Penunjuk Khusus',
    th: 'ตัวบ่งชี้เฉพาะ',
    vi: 'Chỉ số cụ thể',
    fil: 'Mga Partikular na Tagapagpahiwatig',
    km: 'សូចនាករជាក់លាក់',
    lo: 'ຕົວຊີ້ບອກສະເພາະ',
    my: 'သီးခြား အညွှန်းကိန်းများ',
  },
  'checkScam.redFlagChecklist': {
    en: 'Red Flag Checklist',
    id: 'Daftar Periksa Tanda Bahaya',
    ms: 'Senarai Semak Tanda Amaran',
    th: 'รายการตรวจสอบสัญญาณเตือน',
    vi: 'Danh sách kiểm tra cờ đỏ',
    fil: 'Checklist ng Red Flag',
    km: 'បញ្ជីត្រួតពិនិត្យទង់ក្រហម',
    lo: 'ລາຍການກວດສອບທຸງແດງ',
    my: 'အနီရောင်အလံ စစ်ဆေးရန်စာရင်း',
  },
  'checkScam.yes': {
    en: 'Yes',
    id: 'Ya',
    ms: 'Ya',
    th: 'ใช่',
    vi: 'Có',
    fil: 'Oo',
    km: 'បាទ/ចាស',
    lo: 'ແມ່ນ',
    my: 'ဟုတ်ကဲ့',
  },
  'checkScam.no': {
    en: 'No',
    id: 'Tidak',
    ms: 'Tidak',
    th: 'ไม่',
    vi: 'Không',
    fil: 'Hindi',
    km: 'ទេ',
    lo: 'ບໍ່',
    my: 'မဟုတ်ပါ',
  },
  'checkScam.questionsRemaining': {
    en: 'questions remaining',
    id: 'pertanyaan tersisa',
    ms: 'soalan tinggal',
    th: 'คำถามที่เหลือ',
    vi: 'câu hỏi còn lại',
    fil: 'mga tanong na natitira',
    km: 'សំណួរដែលនៅសល់',
    lo: 'ຄຳຖາມທີ່ຍັງເຫຼືອ',
    my: 'ကျန်ရှိသော မေးခွန်းများ',
  },
  'checkScam.assessmentComplete': {
    en: 'Assessment Complete',
    id: 'Penilaian Selesai',
    ms: 'Penilaian Selesai',
    th: 'การประเมินเสร็จสิ้น',
    vi: 'Đánh giá hoàn tất',
    fil: 'Tapos na ang Pagsusuri',
    km: 'ការវាយតម្លៃបានបញ្ចប់',
    lo: 'ການປະເມີນສຳເລັດ',
    my: 'ဆန်းစစ်ခြင်း ပြီးစီး',
  },
  'checkScam.riskMeter': {
    en: 'Risk Meter',
    id: 'Meter Risiko',
    ms: 'Meter Risiko',
    th: 'มิเตอร์ความเสี่ยง',
    vi: 'Đồng hồ rủi ro',
    fil: 'Metro ng Panganib',
    km: 'ម៉ែត្រហានិភ័យ',
    lo: 'ມິເຕີຄວາມສ່ຽງ',
    my: 'အန္တရာယ်တိုင်းကိရိယာ',
  },
  'checkScam.redFlags': {
    en: 'Red Flags',
    id: 'Tanda Bahaya',
    ms: 'Tanda Amaran',
    th: 'สัญญาณเตือน',
    vi: 'Cờ đỏ',
    fil: 'Mga Red Flag',
    km: 'ទង់ក្រហម',
    lo: 'ທຸງແດງ',
    my: 'အနီရောင်အလံများ',
  },
  'checkScam.lowRisk': {
    en: 'Low Risk',
    id: 'Risiko Rendah',
    ms: 'Risiko Rendah',
    th: 'ความเสี่ยงต่ำ',
    vi: 'Rủi ro thấp',
    fil: 'Mababang Panganib',
    km: 'ហានិភ័យទាប',
    lo: 'ຄວາມສ່ຽງຕໍ່າ',
    my: 'အန္တရာယ်နည်း',
  },
  'checkScam.mediumRisk': {
    en: 'Medium Risk',
    id: 'Risiko Sedang',
    ms: 'Risiko Sederhana',
    th: 'ความเสี่ยงปานกลาง',
    vi: 'Rủi ro trung bình',
    fil: 'Katamtamang Panganib',
    km: 'ហានិភ័យមធ្យម',
    lo: 'ຄວາມສ່ຽງປານກາງ',
    my: 'အန္တရာယ်အလယ်အလတ်',
  },
  'checkScam.highRisk': {
    en: 'High Risk',
    id: 'Risiko Tinggi',
    ms: 'Risiko Tinggi',
    th: 'ความเสี่ยงสูง',
    vi: 'Rủi ro cao',
    fil: 'Mataas na Panganib',
    km: 'ហានិភ័យខ្ពស់',
    lo: 'ຄວາມສ່ຽງສູງ',
    my: 'အန္တရာယ်များ',
  },
  'checkScam.highProbability': {
    en: 'High Probability of Scam',
    id: 'Probabilitas Tinggi Penipuan',
    ms: 'Kebarangkalian Tinggi Penipuan',
    th: 'ความน่าจะเป็นสูงที่จะเป็นการหลอกลวง',
    vi: 'Khả năng cao là lừa đảo',
    fil: 'Mataas na Posibilidad ng Scam',
    km: 'ប្រូបាប៊ីលីតេខ្ពស់នៃការបោកប្រាស់',
    lo: 'ຄວາມເປັນໄປໄດ້ສູງທີ່ຈະເປັນການຫຼອກລວງ',
    my: 'လိမ်လည်မှု ဖြစ်နိုင်ခြေ မြင့်မားသည်',
  },
  'checkScam.highProbabilityDesc': {
    en: 'Multiple red flags detected. Do not proceed with any transactions. Stop communication immediately.',
    id: 'Beberapa tanda bahaya terdeteksi. Jangan lanjutkan transaksi apa pun. Hentikan komunikasi segera.',
    ms: 'Pelbagai tanda amaran dikesan. Jangan teruskan sebarang transaksi. Hentikan komunikasi dengan segera.',
    th: 'ตรวจพบสัญญาณเตือนหลายอย่าง อย่าดำเนินการทำธุรกรรมใดๆ หยุดการสื่อสารทันที',
    vi: 'Phát hiện nhiều cờ đỏ. Không tiến hành bất kỳ giao dịch nào. Ngừng liên lạc ngay lập tức.',
    fil: 'Maraming red flag ang natukoy. Huwag ituloy ang anumang transaksyon. Itigil ang komunikasyon kaagad.',
    km: 'បានរកឃើញទង់ក្រហមជាច្រើន។ កុំបន្តប្រតិបត្តិការណាមួយ។ បញ្ឈប់ការទំនាក់ទំនងភ្លាមៗ។',
    lo: 'ກວດພົບທຸງແດງຫຼາຍຢ່າງ. ຢ່າດຳເນີນການທຸລະກຳໃດໆ. ຢຸດການສື່ສານທັນທີ.',
    my: 'အနီရောင်အလံ အများအပြား တွေ့ရှိရသည်။ မည်သည့် ငွေလွှဲမှုမျှ မလုပ်ပါနှင့်။ ဆက်သွယ်မှုကို ချက်ချင်း ရပ်တန့်ပါ။',
  },
  'checkScam.proceedCaution': {
    en: 'Proceed with Extreme Caution',
    id: 'Lanjutkan dengan Sangat Hati-hati',
    ms: 'Teruskan dengan Berhati-hati',
    th: 'ดำเนินการด้วยความระมัดระวังอย่างยิ่ง',
    vi: 'Tiến hành hết sức thận trọng',
    fil: 'Magpatuloy nang may Matinding Pag-iingat',
    km: 'បន្តដោយប្រុងប្រយ័ត្នបំផុត',
    lo: 'ດຳເນີນການດ້ວຍຄວາມລະມັດລະວັງຢ່າງຍິ່ງ',
    my: 'အထူးသတိထား ဆက်လက်ဆောင်ရွက်ပါ',
  },
  'checkScam.proceedCautionDesc': {
    en: 'Some suspicious signs detected. Verify everything independently before taking action.',
    id: 'Beberapa tanda mencurigakan terdeteksi. Verifikasi semuanya secara mandiri sebelum mengambil tindakan.',
    ms: 'Beberapa tanda mencurigakan dikesan. Sahkan semuanya secara bebas sebelum mengambil tindakan.',
    th: 'ตรวจพบสัญญาณที่น่าสงสัยบางอย่าง ตรวจสอบทุกอย่างด้วยตนเองก่อนดำเนินการ',
    vi: 'Phát hiện một số dấu hiệu đáng ngờ. Xác minh mọi thứ một cách độc lập trước khi hành động.',
    fil: 'May ilang kahina-hinalang palatandaan na natukoy. I-verify ang lahat nang independyente bago kumilos.',
    km: 'បានរកឃើញសញ្ញាគួរឱ្យសង្ស័យមួយចំនួន។ ផ្ទៀងផ្ទាត់អ្វីៗគ្រប់យ៉ាងដោយឯករាជ្យមុនពេលចាត់វិធានការ។',
    lo: 'ກວດພົບສັນຍານທີ່ໜ້າສົງໄສບາງຢ່າງ. ກວດສອບທຸກຢ່າງດ້ວຍຕົນເອງກ່ອນດຳເນີນການ.',
    my: 'သံသယဖြစ်ဖွယ် လက္ခဏာအချို့ တွေ့ရှိရသည်။ အရေးမယူမီ အရာအားလုံးကို သီးခြားစီ စစ်ဆေးပါ။',
  },
  'checkScam.lowRiskDetected': {
    en: 'Low Risk Detected',
    id: 'Risiko Rendah Terdeteksi',
    ms: 'Risiko Rendah Dikesan',
    th: 'ตรวจพบความเสี่ยงต่ำ',
    vi: 'Phát hiện rủi ro thấp',
    fil: 'Natukoy ang Mababang Panganib',
    km: 'បានរកឃើញហានិភ័យទាប',
    lo: 'ກວດພົບຄວາມສ່ຽງຕໍ່າ',
    my: 'အန္တရာယ်နည်းပါးကြောင်း တွေ့ရှိရသည်',
  },
  'checkScam.lowRiskDetectedDesc': {
    en: 'No major red flags found, but always stay vigilant. Scammers are constantly evolving.',
    id: 'Tidak ada tanda bahaya utama yang ditemukan, tetapi tetap waspada. Penipu terus berkembang.',
    ms: 'Tiada tanda amaran utama ditemui, tetapi sentiasa berwaspada. Penipu sentiasa berkembang.',
    th: 'ไม่พบสัญญาณเตือนสำคัญ แต่ควรระวังตัวเสมอ มิจฉาชีพมีการพัฒนาตลอดเวลา',
    vi: 'Không tìm thấy cờ đỏ lớn nào, nhưng hãy luôn cảnh giác. Kẻ lừa đảo liên tục thay đổi.',
    fil: 'Walang nakitang malalaking red flag, ngunit laging maging mapagmatyag. Ang mga scammer ay patuloy na nagbabago.',
    km: 'មិនមានទង់ក្រហមសំខាន់ៗត្រូវបានរកឃើញទេ ប៉ុន្តែត្រូវប្រុងប្រយ័ត្នជានិច្ច។ អ្នកបោកប្រាស់កំពុងវិវត្តឥតឈប់ឈរ។',
    lo: 'ບໍ່ພົບທຸງແດງທີ່ສຳຄັນ, ແຕ່ຄວນລະວັງຕົວສະເໝີ. ຜູ້ຫຼອກລວງມີການພັດທະນາຕະຫຼອດເວລາ.',
    my: 'အဓိက အနီရောင်အလံများ မတွေ့ရသော်လည်း အမြဲသတိရှိပါ။ လိမ်လည်သူများသည် အမြဲပြောင်းလဲနေသည်။',
  },
  'checkScam.recommendedActions': {
    en: 'Recommended Actions',
    id: 'Tindakan yang Disarankan',
    ms: 'Tindakan yang Disyorkan',
    th: 'การดำเนินการที่แนะนำ',
    vi: 'Hành động được đề xuất',
    fil: 'Inirerekomendang mga Aksyon',
    km: 'សកម្មភាពដែលបានណែនាំ',
    lo: 'ການດຳເນີນການທີ່ແນະນຳ',
    my: 'အကြံပြုထားသော လုပ်ဆောင်ချက်များ',
  },
  'checkScam.verifyIdentity': {
    en: 'Verify identity through official channels',
    id: 'Verifikasi identitas melalui saluran resmi',
    ms: 'Sahkan identiti melalui saluran rasmi',
    th: 'ตรวจสอบตัวตนผ่านช่องทางอย่างเป็นทางการ',
    vi: 'Xác minh danh tính qua các kênh chính thức',
    fil: 'I-verify ang pagkakakilanlan sa pamamagitan ng mga opisyal na channel',
    km: 'ផ្ទៀងផ្ទាត់អត្តសញ្ញាណតាមរយៈឆានែលផ្លូវការ',
    lo: 'ຢັ້ງຢືນຕົວຕົນຜ່ານຊ່ອງທາງທາງການ',
    my: 'တရားဝင်လမ်းကြောင်းများမှတစ်ဆင့် အထောက်အထားစစ်ဆေးပါ',
  },
  'checkScam.dontShareInfo': {
    en: 'Do not share sensitive information',
    id: 'Jangan bagikan informasi sensitif',
    ms: 'Jangan kongsi maklumat sensitif',
    th: 'อย่าแชร์ข้อมูลที่ละเอียดอ่อน',
    vi: 'Không chia sẻ thông tin nhạy cảm',
    fil: 'Huwag magbahagi ng sensitibong impormasyon',
    km: 'កុំចែករំលែកព័ត៌មានរសើប',
    lo: 'ຢ່າແບ່ງປັນຂໍ້ມູນທີ່ລະອຽດອ່ອນ',
    my: 'အရေးကြီးသော အချက်အလက်များကို မမျှဝေပါနှင့်',
  },
  'checkScam.researchOffer': {
    en: 'Research the offer online',
    id: 'Teliti tawaran secara online',
    ms: 'Kaji tawaran dalam talian',
    th: 'ค้นคว้าข้อเสนอออนไลน์',
    vi: 'Nghiên cứu đề nghị trực tuyến',
    fil: 'Magsaliksik tungkol sa alok online',
    km: 'ស្រាវជ្រាវការផ្តល់ជូនតាមអ៊ីនធឺណិត',
    lo: 'ຄົ້ນຄວ້າຂໍ້ສະເໜີອອນລາຍ',
    my: 'ကမ်းလှမ်းချက်ကို အွန်လိုင်းတွင် လေ့လာပါ',
  },
  'checkScam.consultOthers': {
    en: 'Consult with trusted friends or family',
    id: 'Konsultasikan dengan teman atau keluarga tepercaya',
    ms: 'Rujuk dengan rakan atau keluarga yang dipercayai',
    th: 'ปรึกษากับเพื่อนหรือครอบครัวที่เชื่อถือได้',
    vi: 'Tham khảo ý kiến bạn bè hoặc gia đình đáng tin cậy',
    fil: 'Kumunsulta sa mga pinagkakatiwalaang kaibigan o pamilya',
    km: 'ពិគ្រោះជាមួយមិត្តភក្តិ ឬគ្រួសារដែលគួរឱ្យទុកចិត្ត',
    lo: 'ປຶກສາກັບໝູ່ເພື່ອນ ຫຼື ຄອບຄົວທີ່ເຊື່ອຖືໄດ້',
    my: 'ယုံကြည်ရသော မိတ်ဆွေများ သို့မဟုတ် မိသားစုနှင့် တိုင်ပင်ပါ',
  },
  'checkScam.monitorChanges': {
    en: 'Monitor for any changes in behavior',
    id: 'Pantau perubahan perilaku apa pun',
    ms: 'Pantau sebarang perubahan tingkah laku',
    th: 'ติดตามการเปลี่ยนแปลงพฤติกรรมใดๆ',
    vi: 'Theo dõi mọi thay đổi trong hành vi',
    fil: 'Subaybayan ang anumang pagbabago sa pag-uugali',
    km: 'តាមដានការផ្លាស់ប្តូរអាកប្បកិរិយាណាមួយ',
    lo: 'ຕິດຕາມການປ່ຽນແປງພຶດຕິກຳໃດໆ',
    my: 'အပြုအမူ ပြောင်းလဲမှုများကို စောင့်ကြည့်ပါ',
  },
  'checkScam.keepRecords': {
    en: 'Keep records of all communications',
    id: 'Simpan catatan semua komunikasi',
    ms: 'Simpan rekod semua komunikasi',
    th: 'เก็บรักษาบันทึกการสื่อสารทั้งหมด',
    vi: 'Lưu giữ hồ sơ của tất cả các thông tin liên lạc',
    fil: 'Magtago ng mga rekord ng lahat ng komunikasyon',
    km: 'រក្សាកំណត់ត្រានៃការទំនាក់ទំនងទាំងអស់',
    lo: 'ບັນທຶກການສື່ສານທັງໝົດ',
    my: 'ဆက်သွယ်မှုအားလုံး၏ မှတ်တမ်းများကို သိမ်းဆည်းပါ',
  },
  'checkScam.startOver': {
    en: 'Start Over',
    id: 'Mulai Ulang',
    ms: 'Mula Semula',
    th: 'เริ่มต้นใหม่',
    vi: 'Bắt đầu lại',
    fil: 'Magsimula Muli',
    km: 'ចាប់ផ្តើមម្តងទៀត',
    lo: 'ເລີ່ມຕົ້ນໃໝ່',
    my: 'အစမှ ပြန်စပါ',
  },
  'checkScam.askingMoney': {
    en: 'Are they asking for money or financial information?',
    id: 'Apakah mereka meminta uang atau informasi keuangan?',
    ms: 'Adakah mereka meminta wang atau maklumat kewangan?',
    th: 'พวกเขากำลังขอเงินหรือข้อมูลทางการเงินหรือไม่?',
    vi: 'Họ có yêu cầu tiền hoặc thông tin tài chính không?',
    fil: 'Humihingi ba sila ng pera o impormasyon sa pananalapi?',
    km: 'តើពួកគេកំពុងសុំលុយ ឬព័ត៌មានហិរញ្ញវត្ថុទេ?',
    lo: 'ພວກເຂົາກຳລັງຂໍເງິນ ຫຼື ຂໍ້ມູນທາງການເງິນບໍ່?',
    my: 'သူတို့က ငွေ သို့မဟုတ် ငွေကြေးဆိုင်ရာ အချက်အလက်များကို တောင်းခံနေပါသလား?',
  },
  'checkScam.chatAssessment': {
    en: 'Chat Assessment',
    id: 'Penilaian Chat',
    ms: 'Penilaian Chat',
    th: 'การประเมินผ่านแชท',
    vi: 'Đánh giá qua trò chuyện',
    fil: 'Pagsusuri sa Chat',
    km: 'ការវាយតម្លៃការជជែក',
    lo: 'ການປະເມີນຜ່ານແຊັດ',
    my: 'ချက်တင် ဆန်းစစ်ခြင်း',
  },
  'checkScam.answerAllQuestions': {
    en: 'Please answer all questions to see your result.',
    id: 'Harap jawab semua pertanyaan untuk melihat hasil Anda.',
    ms: 'Sila jawab semua soalan untuk melihat keputusan anda.',
    th: 'โปรดตอบคำถามทั้งหมดเพื่อดูผลลัพธ์ของคุณ',
    vi: 'Vui lòng trả lời tất cả các câu hỏi để xem kết quả của bạn.',
    fil: 'Pakisagot ang lahat ng tanong upang makita ang iyong resulta.',
    km: 'សូមឆ្លើយសំណួរទាំងអស់ដើម្បីមើលលទ្ធផលរបស់អ្នក។',
    lo: 'ກະລຸນາຕອບຄຳຖາມທັງໝົດເພື່ອເບິ່ງຜົນຂອງທ່ານ.',
    my: 'သင့်ရလဒ်ကို ကြည့်ရန် မေးခွန်းအားလုံးကို ဖြေဆိုပါ။',
  },

  // --- RED FLAGS ---
  'redFlag.immediateAction': {
    en: 'Immediate action required / Urgency',
    id: 'Tindakan segera diperlukan / Mendesak',
    ms: 'Tindakan segera diperlukan / Segera',
    th: 'ต้องดำเนินการทันที / เร่งด่วน',
    vi: 'Yêu cầu hành động ngay lập tức / Khẩn cấp',
    fil: 'Kinakailangan ang agarang aksyon / Pagka-apurahan',
    km: 'ត្រូវការសកម្មភាពភ្លាមៗ / បន្ទាន់',
    lo: 'ຕ້ອງການການດຳເນີນການທັນທີ / ເລັ່ງດ່ວນ',
    my: 'ချက်ချင်း အရေးယူရန် လိုအပ်သည် / အရေးကြီးသည်',
  },
  'redFlag.tooGood': {
    en: 'Offer seems too good to be true',
    id: 'Tawaran tampaknya terlalu bagus untuk menjadi kenyataan',
    ms: 'Tawaran nampak terlalu bagus untuk menjadi kenyataan',
    th: 'ข้อเสนอดูดีเกินจริง',
    vi: 'Đề nghị có vẻ quá tốt để là sự thật',
    fil: 'Ang alok ay tila napakaganda para maging totoo',
    km: 'ការផ្តល់ជូនហាក់ដូចជាល្អពេកដែលមិនអាចក្លាយជាការពិត',
    lo: 'ຂໍ້ສະເໜີເບິ່ງຄືວ່າດີເກີນໄປທີ່ຈະເປັນຄວາມຈິງ',
    my: 'ကမ်းလှမ်းချက်သည် ယုံနိုင်စရာမရှိလောက်အောင် ကောင်းလွန်းနေသည်',
  },
  'redFlag.personalInfo': {
    en: 'Request for personal/sensitive info',
    id: 'Permintaan info pribadi/sensitif',
    ms: 'Permintaan maklumat peribadi/sensitif',
    th: 'ขอข้อมูลส่วนตัว/ละเอียดอ่อน',
    vi: 'Yêu cầu thông tin cá nhân/nhạy cảm',
    fil: 'Kahilingan para sa personal/sensitibong impormasyon',
    km: 'សំណើព័ត៌មានផ្ទាល់ខ្លួន/រសើប',
    lo: 'ການຮ້ອງຂໍຂໍ້ມູນສ່ວນຕົວ/ລະອຽດອ່ອນ',
    my: 'ကိုယ်ရေးကိုယ်တာ/အရေးကြီးသော အချက်အလက်များကို တောင်းခံခြင်း',
  },
  'redFlag.secrecy': {
    en: 'Request for secrecy / "Don\'t tell anyone"',
    id: 'Permintaan untuk merahasiakan / "Jangan beritahu siapa pun"',
    ms: 'Permintaan untuk kerahsiaan / "Jangan beritahu sesiapa"',
    th: 'ขอให้เก็บเป็นความลับ / "อย่าบอกใคร"',
    vi: 'Yêu cầu giữ bí mật / "Đừng nói với ai"',
    fil: 'Kahilingan para sa paglilihim / "Huwag sabihin sa sinuman"',
    km: 'សំណើសម្រាប់ការសម្ងាត់ / "កុំប្រាប់នរណាម្នាក់"',
    lo: 'ການຮ້ອງຂໍຄວາມລັບ / "ຢ່າບອກໃຜ"',
    my: 'လျှို့ဝှက်ထားရန် တောင်းဆိုခြင်း / "ဘယ်သူ့ကိုမှ မပြောပါနဲ့"',
  },
  'redFlag.unusualPayment': {
    en: 'Unusual payment method (Gift cards, Crypto)',
    id: 'Metode pembayaran tidak biasa (Kartu hadiah, Kripto)',
    ms: 'Kaedah pembayaran luar biasa (Kad hadiah, Kripto)',
    th: 'วิธีการชำระเงินที่ไม่ปกติ (บัตรของขวัญ, คริปโต)',
    vi: 'Phương thức thanh toán bất thường (Thẻ quà tặng, Tiền mã hóa)',
    fil: 'Hindi karaniwang paraan ng pagbabayad (Gift cards, Crypto)',
    km: 'វិធីសាស្រ្តទូទាត់មិនធម្មតា (កាតអំណោយ, គ្រីបតូ)',
    lo: 'ວິທີການຊຳລະເງິນທີ່ຜິດປົກກະຕິ (ບັດຂອງຂວັນ, ຄຣິບໂຕ)',
    my: 'ပုံမှန်မဟုတ်သော ငွေပေးချေမှုနည်းလမ်း (လက်ဆောင်ကတ်များ၊ ကရစ်ပတို)',
  },
  'redFlag.poorGrammar': {
    en: 'Poor grammar or spelling errors',
    id: 'Tata bahasa buruk atau kesalahan ejaan',
    ms: 'Tatabahasa lemah atau kesalahan ejaan',
    th: 'ไวยากรณ์ไม่ดีหรือสะกดผิด',
    vi: 'Ngữ pháp kém hoặc lỗi chính tả',
    fil: 'Maling grammar o mga error sa spelling',
    km: 'វេយ្យាករណ៍មិនល្អ ឬកំហុសអក្ខរាវិរុទ្ធ',
    lo: 'ໄວຍາກອນບໍ່ດີ ຫຼື ຜິດພາດການສະກົດຄຳ',
    my: 'သဒ္ဒါညံ့ဖျင်းခြင်း သို့မဟုတ် စာလုံးပေါင်း အမှားများ',
  },
  'redFlag.unsolicited': {
    en: "Unsolicited contact (You didn't ask for it)",
    id: 'Kontak yang tidak diminta (Anda tidak memintanya)',
    ms: 'Hubungan yang tidak diminta (Anda tidak memintanya)',
    th: 'การติดต่อที่ไม่ได้รับเชิญ (คุณไม่ได้ขอ)',
    vi: 'Liên hệ không mong muốn (Bạn không yêu cầu)',
    fil: 'Hindi hinihinging contact (Hindi mo ito hiniling)',
    km: 'ទំនាក់ទំនងដែលមិនបានស្នើសុំ (អ្នកមិនបានសួររកវាទេ)',
    lo: 'ການຕິດຕໍ່ທີ່ບໍ່ໄດ້ຮ້ອງຂໍ (ທ່ານບໍ່ໄດ້ຮ້ອງຂໍ)',
    my: 'မတောင်းဆိုဘဲ ဆက်သွယ်ခြင်း (သင် မတောင်းဆိုခဲ့ပါ)',
  },
  'redFlag.threats': {
    en: 'Threats or intimidation',
    id: 'Ancaman atau intimidasi',
    ms: 'Ancaman atau intimidasi',
    th: 'การขู่เข็ญหรือข่มขู่',
    vi: 'Đe dọa hoặc đe dọa',
    fil: 'Mga banta o pananakot',
    km: 'ការគំរាមកំហែង ឬការបំភិតបំភ័យ',
    lo: 'ການຂົ່ມຂູ່ ຫຼື ການຂົ່ມຂູ່',
    my: 'ခြိမ်းခြောက်မှုများ သို့မဟုတ် ခြိမ်းခြောက်ခြင်း',
  },

  // --- SCAM TYPES ---
  'scam.socialEngineering': {
    en: 'Social Engineering',
    id: 'Rekayasa Sosial',
    ms: 'Kejuruteraan Sosial',
    th: 'วิศวกรรมสังคม',
    vi: 'Kỹ thuật xã hội',
    fil: 'Social Engineering',
    km: 'វិស្វកម្មសង្គម',
    lo: 'ວິສະວະກຳສັງຄົມ',
    my: 'လူမှုအင်ဂျင်နီယာ',
  },
  'scam.investmentFraud': {
    en: 'Investment Fraud',
    id: 'Penipuan Investasi',
    ms: 'Penipuan Pelaburan',
    th: 'การฉ้อโกงการลงทุน',
    vi: 'Gian lận đầu tư',
    fil: 'Investment Fraud',
    km: 'ការបោកប្រាស់ការវិនិយោគ',
    lo: 'ການໂກງການລົງທຶນ',
    my: 'ရင်းနှီးမြှုပ်နှံမှု လိမ်လည်ခြင်း',
  },
  'scam.romanceScam': {
    en: 'Romance Scam',
    id: 'Penipuan Asmara',
    ms: 'Penipuan Percintaan',
    th: 'การหลอกลวงด้านความรัก',
    vi: 'Lừa đảo tình cảm',
    fil: 'Romance Scam',
    km: 'ការបោកប្រាស់ស្នេហា',
    lo: 'ການຫຼອກລວງດ້ານຄວາມຮັກ',
    my: 'အချစ်ရေးလိမ်လည်မှု',
  },
  'scam.phishing': {
    en: 'Phishing',
    id: 'Phishing',
    ms: 'Phishing',
    th: 'ฟิชชิ่ง',
    vi: 'Lừa đảo qua mạng',
    fil: 'Phishing',
    km: 'ហ្វីស៊ីង',
    lo: 'ຟິຊຊິງ',
    my: 'ဖစ်ရှင်း',
  },
  'scam.ecommerce': {
    en: 'E-commerce Scam',
    id: 'Penipuan E-commerce',
    ms: 'Penipuan E-dagang',
    th: 'การหลอกลวงอีคอมเมิร์ซ',
    vi: 'Lừa đảo thương mại điện tử',
    fil: 'E-commerce Scam',
    km: 'ការបោកប្រាស់ពាណិជ្ជកម្មអេឡិចត្រូនិក',
    lo: 'ການຫຼອກລວງອີຄອມເມີຊ',
    my: 'အီး-ကောမတ်စ် လိမ်လည်မှု',
  },
  'scam.jobScam': {
    en: 'Job Scam',
    id: 'Penipuan Lowongan Kerja',
    ms: 'Penipuan Pekerjaan',
    th: 'การหลอกลวงงาน',
    vi: 'Lừa đảo việc làm',
    fil: 'Job Scam',
    km: 'ការបោកប្រាស់ការងារ',
    lo: 'ການຫຼອກລວງວຽກງານ',
    my: 'အလုပ်လိမ်လည်မှု',
  },

  // --- EDUCATION PAGE ---
  'education.title': {
    en: 'Scam Education Center',
    id: 'Pusat Edukasi Penipuan',
    ms: 'Pusat Pendidikan Penipuan',
    th: 'ศูนย์การศึกษาเรื่องการหลอกลวง',
    vi: 'Trung tâm Giáo dục Lừa đảo',
    fil: 'Sentro ng Edukasyon sa Scam',
    km: 'មជ្ឈមណ្ឌលអប់រំអំពីការបោកប្រាស់',
    lo: 'ສູນການສຶກສາເລື່ອງການຫຼອກລວງ',
    my: 'လိမ်လည်မှု ပညာပေး စင်တာ',
  },
  'education.subtitle': {
    en: 'Learn about common scam tactics and how to protect yourself.',
    id: 'Pelajari taktik penipuan umum dan cara melindungi diri Anda.',
    ms: 'Ketahui taktik penipuan biasa dan cara melindungi diri anda.',
    th: 'เรียนรู้เกี่ยวกับกลยุทธ์การหลอกลวงทั่วไปและวิธีปกป้องตัวคุณเอง',
    vi: 'Tìm hiểu về các chiến thuật lừa đảo phổ biến và cách bảo vệ bản thân.',
    fil: 'Alamin ang tungkol sa mga karaniwang taktika ng scam at kung paano protektahan ang iyong sarili.',
    km: 'ស្វែងយល់អំពីយុទ្ធសាស្ត្របោកប្រាស់ទូទៅ និងរបៀបការពារខ្លួនអ្នក។',
    lo: 'ຮຽນຮູ້ກ່ຽວກັບກົນລະຍຸດການຫຼອກລວງທົ່ວໄປ ແລະ ວິທີປົກປ້ອງຕົວເອງ.',
    my: 'အဖြစ်များသော လိမ်လည်မှု နည်းဗျူဟာများနှင့် သင့်ကိုယ်သင် ကာကွယ်နည်းကို လေ့လာပါ။',
  },
  'education.commonTactics': {
    en: 'Common Tactics:',
    id: 'Taktik Umum:',
    ms: 'Taktik Biasa:',
    th: 'กลยุทธ์ทั่วไป:',
    vi: 'Chiến thuật phổ biến:',
    fil: 'Karaniwang Taktika:',
    km: 'យុទ្ធសាស្ត្រទូទៅ:',
    lo: 'ກົນລະຍຸດທົ່ວໄປ:',
    my: 'အဖြစ်များသော နည်းဗျူဟာများ -',
  },
  'education.viewProtocol': {
    en: 'View Protocol',
    id: 'Lihat Protokol',
    ms: 'Lihat Protokol',
    th: 'ดูโปรโตคอล',
    vi: 'Xem giao thức',
    fil: 'Tingnan ang Protokol',
    km: 'មើលពិធីសារ',
    lo: 'ເບິ່ງມາດຕະການ',
    my: 'လုပ်ထုံးလုပ်နည်းကို ကြည့်ရန်',
  },
  'education.redFlags': {
    en: 'Universal Red Flags',
    id: 'Tanda Bahaya Universal',
    ms: 'Tanda Amaran Universal',
    th: 'สัญญาณเตือนสากล',
    vi: 'Cờ đỏ phổ biến',
    fil: 'Pangkalahatang Red Flags',
    km: 'ទង់ក្រហមសកល',
    lo: 'ທຸງແດງສາກົນ',
    my: 'ကမ္ဘာလုံးဆိုင်ရာ အနီရောင်အလံများ',
  },
  'education.checkScamBtn': {
    en: 'Check a Specific Scam',
    id: 'Cek Penipuan Spesifik',
    ms: 'Semak Penipuan Khusus',
    th: 'ตรวจสอบการหลอกลวงเฉพาะ',
    vi: 'Kiểm tra lừa đảo cụ thể',
    fil: 'Suriin ang isang Partikular na Scam',
    km: 'ពិនិត្យការបោកប្រាស់ជាក់លាក់',
    lo: 'ກວດສອບການຫຼອກລວງສະເພາະ',
    my: 'သီးခြား လိမ်လည်မှုတစ်ခုကို စစ်ဆေးပါ',
  },
  'education.scam.socialEngineering.desc': {
    en: 'Manipulating people into giving up confidential info.',
    id: 'Memanipulasi orang untuk memberikan info rahasia.',
    ms: 'Memanipulasi orang untuk memberikan maklumat sulit.',
    th: 'หลอกลวงให้ผู้คนเปิดเผยข้อมูลที่เป็นความลับ',
    vi: 'Thao túng mọi người để cung cấp thông tin mật.',
    fil: 'Pagmamanipula sa mga tao upang ibigay ang kumpidensyal na impormasyon.',
    km: 'ការរៀបចំមនុស្សឱ្យបោះបង់ព័ត៌មានសម្ងាត់។',
    lo: 'ຫຼອກລວງຄົນໃຫ້ມອບຂໍ້ມູນລັບ.',
    my: 'လျှို့ဝှက်အချက်အလက်များကို ပေးအပ်ရန် လူများကို လှည့်စားခြင်း။',
  },
  'education.scam.investmentFraud.desc': {
    en: 'Fake opportunities promising high returns with low risk.',
    id: 'Peluang palsu yang menjanjikan keuntungan tinggi dengan risiko rendah.',
    ms: 'Peluang palsu yang menjanjikan pulangan tinggi dengan risiko rendah.',
    th: 'โอกาสปลอมที่สัญญาผลตอบแทนสูงโดยมีความเสี่ยงต่ำ',
    vi: 'Cơ hội giả mạo hứa hẹn lợi nhuận cao với rủi ro thấp.',
    fil: 'Mga pekeng oportunidad na nangangako ng mataas na kita na may mababang panganib.',
    km: 'ឱកាសក្លែងបន្លំសន្យាផលចំណេញខ្ពស់ដោយមានហានិភ័យទាប។',
    lo: 'ໂອກາດປອມທີ່ສັນຍາຜົນຕອບແທນສູງດ້ວຍຄວາມສ່ຽງຕໍ່າ.',
    my: 'အန္တရာယ်နည်းပြီး အမြတ်အစွန်းများမည်ဟု ကတိပေးသော အတုအယောင် အခွင့်အလမ်းများ။',
  },
  'education.scam.romanceScam.desc': {
    en: 'Feigning romantic intentions to gain trust and money.',
    id: 'Berpura-pura memiliki niat romantis untuk mendapatkan kepercayaan dan uang.',
    ms: 'Berpura-pura mempunyai niat romantis untuk mendapatkan kepercayaan dan wang.',
    th: 'แสร้งทำเป็นมีความรักเพื่อได้รับความไว้วางใจและเงิน',
    vi: 'Giả vờ có ý định lãng mạn để chiếm được lòng tin và tiền bạc.',
    fil: 'Pagkukunwaring may romantikong intensyon upang makuha ang tiwala at pera.',
    km: 'ធ្វើពុតជាមានចេតនាស្នេហាដើម្បីទទួលបានទំនុកចិត្ត និងប្រាក់។',
    lo: 'ແກ້ງເຮັດເປັນມີຄວາມຮັກເພື່ອໄດ້ຮັບຄວາມໄວ້ວາງໃຈ ແລະ ເງິນ.',
    my: 'ယုံကြည်မှုနှင့် ငွေကြေးရယူရန် အချစ်ရေး ရည်ရွယ်ချက်ရှိသယောင် ဟန်ဆောင်ခြင်း။',
  },
  'education.scam.phishing.desc': {
    en: 'Fraudulent emails/messages to steal login credentials.',
    id: 'Email/pesan penipuan untuk mencuri kredensial login.',
    ms: 'E-mel/mesej penipuan untuk mencuri kelayakan log masuk.',
    th: 'อีเมล/ข้อความฉ้อโกงเพื่อขโมยข้อมูลการเข้าสู่ระบบ',
    vi: 'Email/tin nhắn gian lận để đánh cắp thông tin đăng nhập.',
    fil: 'Mapanlinlang na mga email/mensahe upang magnakaw ng mga kredensyal sa pag-login.',
    km: 'អ៊ីមែល/សារបោកប្រាស់ដើម្បីលួចព័ត៌មានសម្ងាត់ចូល។',
    lo: 'ອີເມວ/ຂໍ້ຄວາມຫຼອກລວງເພື່ອລັກຂໍ້ມູນການເຂົ້າສູ່ລະບົບ.',
    my: 'ဝင်ရောက်ခွင့် အချက်အလက်များကို ခိုးယူရန် လိမ်လည်သော အီးမေးလ်များ/မက်ဆေ့ခ်ျများ။',
  },
  'education.scam.ecommerce.desc': {
    en: 'Fake online stores or sellers taking money without delivering.',
    id: 'Toko online atau penjual palsu yang mengambil uang tanpa mengirim barang.',
    ms: 'Kedai dalam talian atau penjual palsu yang mengambil wang tanpa menghantar barang.',
    th: 'ร้านค้าออนไลน์หรือผู้ขายปลอมที่รับเงินโดยไม่ส่งของ',
    vi: 'Cửa hàng trực tuyến hoặc người bán giả mạo nhận tiền mà không giao hàng.',
    fil: 'Mga pekeng online store o nagbebenta na kumukuha ng pera nang hindi naghahatid.',
    km: 'ហាងអនឡាញក្លែងបន្លំ ឬអ្នកលក់យកលុយដោយមិនដឹកជញ្ជូន។',
    lo: 'ຮ້ານຄ້າອອນລາຍ ຫຼື ຜູ້ຂາຍປອມທີ່ຮັບເງິນໂດຍບໍ່ສົ່ງສິນຄ້າ.',
    my: 'ပစ္စည်းမပို့ဘဲ ငွေယူသော အတုအယောင် အွန်လိုင်းဆိုင်များ သို့မဟုတ် ရောင်းသူများ။',
  },
  'education.scam.jobScam.desc': {
    en: 'Fake job offers requiring upfront payment or personal data.',
    id: 'Tawaran pekerjaan palsu yang meminta pembayaran di muka atau data pribadi.',
    ms: 'Tawaran pekerjaan palsu yang memerlukan bayaran pendahuluan atau data peribadi.',
    th: 'ข้อเสนองานปลอมที่ต้องจ่ายเงินล่วงหน้าหรือข้อมูลส่วนตัว',
    vi: 'Đề nghị việc làm giả yêu cầu thanh toán trước hoặc dữ liệu cá nhân.',
    fil: 'Mga pekeng alok ng trabaho na nangangailangan ng paunang bayad o personal na data.',
    km: 'ការផ្តល់ការងារក្លែងបន្លំដែលទាមទារការទូទាត់ជាមុន ឬទិន្នន័យផ្ទាល់ខ្លួន។',
    lo: 'ການສະເໜີວຽກງານປອມທີ່ຕ້ອງການການຊຳລະເງິນລ່ວງໜ້າ ຫຼື ຂໍ້ມູນສ່ວນຕົວ.',
    my: 'ကြိုတင်ငွေပေးချေမှု သို့မဟုတ် ကိုယ်ရေးကိုယ်တာ အချက်အလက်များ လိုအပ်သော အတုအယောင် အလုပ်ကမ်းလှမ်းချက်များ။',
  },

  // --- TACTICS ---
  'tactic.impersonation': {
    en: 'Impersonation',
    id: 'Penyamaran',
    ms: 'Penyamaran',
    th: 'การแอบอ้าง',
    vi: 'Mạo danh',
    fil: 'Pagpapanggap',
    km: 'ការក្លែងបន្លំ',
    lo: 'ການປອມຕົວ',
    my: 'အယောင်ဆောင်ခြင်း',
  },
  'tactic.authorityExploitation': {
    en: 'Exploiting Authority',
    id: 'Mengeksploitasi Otoritas',
    ms: 'Mengeksploitasi Kuasa',
    th: 'การใช้ประโยชน์จากอำนาจ',
    vi: 'Lợi dụng quyền lực',
    fil: 'Pagsasamantala sa Awtoridad',
    km: 'ការកេងប្រវ័ញ្ចអាជ្ញាធរ',
    lo: 'ການໃຊ້ປະໂຫຍດຈາກອຳນາດ',
    my: 'အာဏာကို အလွဲသုံးစားလုပ်ခြင်း',
  },
  'tactic.urgencyCreation': {
    en: 'Creating Urgency',
    id: 'Menciptakan Urgensi',
    ms: 'Mewujudkan Kesegeraan',
    th: 'การสร้างความเร่งด่วน',
    vi: 'Tạo sự khẩn cấp',
    fil: 'Paglikha ng Pagka-apurahan',
    km: 'ការបង្កើតភាពបន្ទាន់',
    lo: 'ການສ້າງຄວາມເລັ່ງດ່ວນ',
    my: 'အရေးတကြီး အခြေအနေ ဖန်တီးခြင်း',
  },
  'tactic.fearTactics': {
    en: 'Fear Tactics',
    id: 'Taktik Ketakutan',
    ms: 'Taktik Ketakutan',
    th: 'กลยุทธ์ความกลัว',
    vi: 'Chiến thuật sợ hãi',
    fil: 'Taktika ng Takot',
    km: 'យុទ្ធសាស្ត្រភ័យខ្លាច',
    lo: 'ກົນລະຍຸດຄວາມຢ້ານກົວ',
    my: 'ကြောက်လန့်စေသော နည်းဗျူဟာများ',
  },
  'tactic.guaranteedProfits': {
    en: 'Guaranteed Profits',
    id: 'Keuntungan Terjamin',
    ms: 'Keuntungan Terjamin',
    th: 'รับประกันผลกำไร',
    vi: 'Lợi nhuận đảm bảo',
    fil: 'Garantisadong Kita',
    km: 'ប្រាក់ចំណេញធានា',
    lo: 'ຮັບປະກັນຜົນກຳໄລ',
    my: 'အာမခံ အမြတ်အစွန်းများ',
  },
  'tactic.ponziSchemes': {
    en: 'Ponzi Schemes',
    id: 'Skema Ponzi',
    ms: 'Skim Ponzi',
    th: 'แชร์ลูกโซ่',
    vi: 'Mô hình Ponzi',
    fil: 'Ponzi Schemes',
    km: 'គម្រោង Ponzi',
    lo: 'ແຊລູກໂສ້',
    my: 'ပွန်ဇီ စီမံကိန်းများ',
  },
  'tactic.pumpAndDump': {
    en: 'Pump and Dump',
    id: 'Pump and Dump',
    ms: 'Pump and Dump',
    th: 'ปั่นราคาแล้วเทขาย',
    vi: 'Bơm và xả',
    fil: 'Pump and Dump',
    km: 'បូមនិងចាក់',
    lo: 'ປັ່ນລາຄາແລ້ວເທຂາຍ',
    my: 'ဈေးတင်ပြီး ရောင်းချခြင်း',
  },
  'tactic.fakeTradingPlatforms': {
    en: 'Fake Trading Platforms',
    id: 'Platform Trading Palsu',
    ms: 'Platform Dagangan Palsu',
    th: 'แพลตฟอร์มการซื้อขายปลอม',
    vi: 'Nền tảng giao dịch giả mạo',
    fil: 'Mga Pekeng Trading Platform',
    km: 'វេទិកាពាណិជ្ជកម្មក្លែងក្លាយ',
    lo: 'ແພລດຟອມການຊື້ຂາຍປອມ',
    my: 'အတုအယောင် ကုန်သွယ်ရေး ပလက်ဖောင်းများ',
  },
  'tactic.fakeProfiles': {
    en: 'Fake Profiles',
    id: 'Profil Palsu',
    ms: 'Profil Palsu',
    th: 'โปรไฟล์ปลอม',
    vi: 'Hồ sơ giả mạo',
    fil: 'Mga Pekeng Profile',
    km: 'ប្រវត្តិរូបក្លែងក្លាយ',
    lo: 'ໂປຣໄຟລ໌ປອມ',
    my: 'အတုအယောင် ပရိုဖိုင်များ',
  },
  'tactic.loveBombing': {
    en: 'Love Bombing',
    id: 'Love Bombing',
    ms: 'Love Bombing',
    th: 'ระเบิดความรัก',
    vi: 'Dội bom tình yêu',
    fil: 'Love Bombing',
    km: 'ការទម្លាក់គ្រាប់បែកស្នេហា',
    lo: 'ລະເບີດຄວາມຮັກ',
    my: 'အချစ်ဖြင့် လွှမ်းမိုးခြင်း',
  },
  'tactic.sobStories': {
    en: 'Sob Stories',
    id: 'Cerita Sedih',
    ms: 'Cerita Sedih',
    th: 'เรื่องราวเศร้า',
    vi: 'Câu chuyện thương tâm',
    fil: 'Mga Kwentong Nakakaiyak',
    km: 'រឿងរ៉ាវសោកសៅ',
    lo: 'ເລື່ອງລາວເສົ້າ',
    my: 'သနားစရာ ဇာတ်လမ်းများ',
  },
  'tactic.moneyRequests': {
    en: 'Money Requests',
    id: 'Permintaan Uang',
    ms: 'Permintaan Wang',
    th: 'คำขอเงิน',
    vi: 'Yêu cầu tiền',
    fil: 'Mga Kahilingan sa Pera',
    km: 'សំណើប្រាក់',
    lo: 'ການຂໍເງິນ',
    my: 'ငွေတောင်းခံမှုများ',
  },
  'tactic.fakeEmails': {
    en: 'Fake Emails',
    id: 'Email Palsu',
    ms: 'E-mel Palsu',
    th: 'อีเมลปลอม',
    vi: 'Email giả mạo',
    fil: 'Mga Pekeng Email',
    km: 'អ៊ីមែលក្លែងក្លាយ',
    lo: 'ອີເມວປອມ',
    my: 'အတုအယောင် အီးမေးလ်များ',
  },
  'tactic.spoofedWebsites': {
    en: 'Spoofed Websites',
    id: 'Situs Web Palsu',
    ms: 'Laman Web Palsu',
    th: 'เว็บไซต์เลียนแบบ',
    vi: 'Trang web giả mạo',
    fil: 'Mga Spoofed na Website',
    km: 'គេហទំព័រក្លែងបន្លំ',
    lo: 'ເວັບໄຊທ໌ຮຽນແບບ',
    my: 'အတုအယောင် ဝက်ဘ်ဆိုက်များ',
  },
  'tactic.smsPhishing': {
    en: 'SMS Phishing (Smishing)',
    id: 'SMS Phishing (Smishing)',
    ms: 'SMS Phishing (Smishing)',
    th: 'ฟิชชิ่งทาง SMS (Smishing)',
    vi: 'Lừa đảo qua SMS (Smishing)',
    fil: 'SMS Phishing (Smishing)',
    km: 'ហ្វីស៊ីងតាមសារ SMS',
    lo: 'ຟິຊຊິງທາງ SMS',
    my: 'SMS ဖစ်ရှင်း (Smishing)',
  },
  'tactic.voicePhishing': {
    en: 'Voice Phishing (Vishing)',
    id: 'Voice Phishing (Vishing)',
    ms: 'Voice Phishing (Vishing)',
    th: 'ฟิชชิ่งทางเสียง (Vishing)',
    vi: 'Lừa đảo qua giọng nói (Vishing)',
    fil: 'Voice Phishing (Vishing)',
    km: 'ហ្វីស៊ីងតាមសំឡេង',
    lo: 'ຟິຊຊິງທາງສຽງ',
    my: 'အသံ ဖစ်ရှင်း (Vishing)',
  },
  'tactic.fakeSellers': {
    en: 'Fake Sellers',
    id: 'Penjual Palsu',
    ms: 'Penjual Palsu',
    th: 'ผู้ขายปลอม',
    vi: 'Người bán giả mạo',
    fil: 'Mga Pekeng Nagbebenta',
    km: 'អ្នកលក់ក្លែងក្លាយ',
    lo: 'ຜູ້ຂາຍປອມ',
    my: 'အတုအယောင် ရောင်းသူများ',
  },
  'tactic.nonDelivery': {
    en: 'Non-Delivery',
    id: 'Tidak Dikirim',
    ms: 'Tidak Dihantar',
    th: 'ไม่ส่งของ',
    vi: 'Không giao hàng',
    fil: 'Hindi Paghahatid',
    km: 'មិនដឹកជញ្ជូន',
    lo: 'ບໍ່ສົ່ງສິນຄ້າ',
    my: 'ပစ္စည်းမပို့ခြင်း',
  },
  'tactic.counterfeitGoods': {
    en: 'Counterfeit Goods',
    id: 'Barang Palsu',
    ms: 'Barang Tiruan',
    th: 'สินค้าลอกเลียนแบบ',
    vi: 'Hàng giả',
    fil: 'Mga Pekeng Produkto',
    km: 'ទំនិញក្លែងក្លាយ',
    lo: 'ສິນຄ້າປອມ',
    my: 'အတုအပ ကုန်ပစ္စည်းများ',
  },
  'tactic.paymentFraud': {
    en: 'Payment Fraud',
    id: 'Penipuan Pembayaran',
    ms: 'Penipuan Pembayaran',
    th: 'การฉ้อโกงการชำระเงิน',
    vi: 'Gian lận thanh toán',
    fil: 'Pandarayang Pagbabayad',
    km: 'ការបោកប្រាស់ការទូទាត់',
    lo: 'ການໂກງການຊຳລະເງິນ',
    my: 'ငွေပေးချေမှု လိမ်လည်ခြင်း',
  },
  'tactic.upfrontFees': {
    en: 'Upfront Fees',
    id: 'Biaya di Muka',
    ms: 'Yuran Pendahuluan',
    th: 'ค่าธรรมเนียมล่วงหน้า',
    vi: 'Phí trả trước',
    fil: 'Mga Paunang Bayad',
    km: 'ថ្លៃសេវាជាមុន',
    lo: 'ຄ່າທຳນຽມລ່ວງໜ້າ',
    my: 'ကြိုတင်ပေးငွေများ',
  },
  'tactic.workFromHomeSchemes': {
    en: 'Work From Home Schemes',
    id: 'Skema Kerja Dari Rumah',
    ms: 'Skim Kerja Dari Rumah',
    th: 'แผนการทำงานจากที่บ้าน',
    vi: 'Chương trình làm việc tại nhà',
    fil: 'Mga Scheme ng Work From Home',
    km: 'គម្រោងធ្វើការពីផ្ទះ',
    lo: 'ແຜນການເຮັດວຽກຈາກບ້ານ',
    my: 'အိမ်မှ အလုပ်လုပ်သော အစီအစဉ်များ',
  },
  'tactic.pyramidSchemes': {
    en: 'Pyramid Schemes',
    id: 'Skema Piramida',
    ms: 'Skim Piramid',
    th: 'แชร์ลูกโซ่',
    vi: 'Mô hình kim tự tháp',
    fil: 'Pyramid Schemes',
    km: 'គម្រោងពីរ៉ាមីត',
    lo: 'ແຊລູກໂສ້',
    my: 'ပိရမစ် စီမံကိန်းများ',
  },
  'tactic.fakeRecruiters': {
    en: 'Fake Recruiters',
    id: 'Perekrut Palsu',
    ms: 'Perekrut Palsu',
    th: 'ผู้สรรหาปลอม',
    vi: 'Nhà tuyển dụng giả mạo',
    fil: 'Mga Pekeng Recruiter',
    km: 'អ្នកជ្រើសរើសក្លែងក្លាយ',
    lo: 'ຜູ້ຮັບສະໝັກປອມ',
    my: 'အတုအယောင် အလုပ်ခေါ်သူများ',
  },

  // --- REPORT PAGE ---
  'report.title': {
    en: 'Where to Report Scams',
    id: 'Tempat Melapor Penipuan',
    ms: 'Di Mana Nak Lapor Penipuan',
    th: 'แจ้งเหตุการหลอกลวงที่ไหน',
    vi: 'Nơi báo cáo lừa đảo',
    fil: 'Saan Mag-report ng mga Scam',
    km: 'កន្លែងរាយការណ៍ការបោកប្រាស',
    lo: 'ບ່ອນແຈ້ງຄວາມເລື່ອງການຫຼອກລວງ',
    my: 'လိမ်လည်မှုများကို မည့်နေရာတွင် တိုင်ကြားရမည်နည်း',
  },
  'report.subtitle': {
    en: 'Find official reporting channels for your country. Reporting helps authorities track and stop scammers.',
    id: 'Temukan saluran pelaporan resmi untuk negara Anda. Melapor membantu pihak berwenang melacak dan menghentikan penipu.',
    ms: 'Cari saluran pelaporan rasmi untuk negara anda. Melapor membantu pihak berkuasa menjejak dan menghentikan penipu.',
    th: 'ค้นหาช่องทางการรายงานอย่างเป็นทางการสำหรับประเทศของคุณ การรายงานช่วยให้เจ้าหน้าที่ติดตามและหยุดมิจฉาชีพ',
    vi: 'Tìm các kênh báo cáo chính thức cho quốc gia của bạn. Báo cáo giúp cơ quan chức năng theo dõi và ngăn chặn kẻ lừa đảo.',
    fil: 'Maghanap ng mga opisyal na channel ng pag-uulat para sa iyong bansa. Ang pag-uulat ay nakakatulong sa mga awtoridad na subaybayan at pigilan ang mga scammer.',
    km: 'ស្វែងរកឆានែលរាយការណ៍ផ្លូវការសម្រាប់ប្រទេសរបស់អ្នក។ ការរាយការណ៍ជួយអាជ្ញាធរតាមដាន និងបញ្ឈប់អ្នកបោកប្រាស់។',
    lo: 'ຊອກຫາຊ່ອງທາງການລາຍງານຢ່າງເປັນທາງການສຳລັບປະເທດຂອງທ່ານ. ການລາຍງານຊ່ວຍໃຫ້ເຈົ້າໜ້າທີ່ຕິດຕາມ ແລະ ຢຸດຜູ້ຫຼອກລວງ.',
    my: 'သင့်နိုင်ငံအတွက် တရားဝင်တိုင်ကြားရန် လမ်းကြောင်းများကို ရှာဖွေပါ။ တိုင်ကြားခြင်းသည် အာဏာပိုင်များက လိမ်လည်သူများကို ခြေရာခံပြီး ရပ်တန့်ရန် ကူညီပေးသည်။',
  },
  'report.indonesia': {
    en: 'Indonesia',
    id: 'Indonesia',
    ms: 'Indonesia',
    th: 'อินโดนีเซีย',
    vi: 'Indonesia',
    fil: 'Indonesia',
    km: 'ឥណ្ឌូនេស៊ី',
    lo: 'ອິນໂດເນເຊຍ',
    my: 'အင်ဒိုနီးရှား',
  },
  'report.aseanRegion': {
    en: 'ASEAN Region',
    id: 'Wilayah ASEAN',
    ms: 'Wilayah ASEAN',
    th: 'ภูมิภาคอาเซียน',
    vi: 'Khu vực ASEAN',
    fil: 'Rehiyon ng ASEAN',
    km: 'តំបន់អាស៊ាន',
    lo: 'ພາກພື້ນອາຊຽນ',
    my: 'အာဆီယံ ဒေသ',
  },
  'report.international': {
    en: 'International',
    id: 'Internasional',
    ms: 'Antarabangsa',
    th: 'ระหว่างประเทศ',
    vi: 'Quốc tế',
    fil: 'Internasyonal',
    km: 'អន្តរជាតិ',
    lo: 'ສາກົນ',
    my: 'နိုင်ငံတကာ',
  },
  'report.noAgencies': {
    en: 'No agencies found for this category.',
    id: 'Tidak ada agensi ditemukan untuk kategori ini.',
    ms: 'Tiada agensi ditemui untuk kategori ini.',
    th: 'ไม่พบหน่วยงานสำหรับหมวดหมู่นี้',
    vi: 'Không tìm thấy cơ quan nào cho danh mục này.',
    fil: 'Walang nahanap na ahensya para sa kategoryang ito.',
    km: 'រកមិនឃើញទីភ្នាក់ងារសម្រាប់ប្រភេទនេះទេ។',
    lo: 'ບໍ່ພົບອົງການສຳລັບໝວດໝູ່ນີ້.',
    my: 'ဤအမျိုးအစားအတွက် အေဂျင်စီများ မတွေ့ပါ။',
  },
  'report.crossBorder': {
    en: 'Cross-Border Reporting',
    id: 'Pelaporan Lintas Batas',
    ms: 'Pelaporan Rentas Sempadan',
    th: 'การรายงานข้ามพรมแดน',
    vi: 'Báo cáo xuyên biên giới',
    fil: 'Pag-uulat sa Cross-Border',
    km: 'ការរាយការណ៍ឆ្លងដែន',
    lo: 'ການລາຍງານຂ້າມຊາຍແດນ',
    my: 'နယ်စပ်ဖြတ်ကျော် တိုင်ကြားခြင်း',
  },
  'report.crossBorderDesc': {
    en: 'For scams involving multiple countries, consider reporting to international bodies like INTERPOL or using the ASEAN regional cooperation channels.',
    id: 'Untuk penipuan yang melibatkan beberapa negara, pertimbangkan untuk melapor ke badan internasional seperti INTERPOL atau menggunakan saluran kerja sama regional ASEAN.',
    ms: 'Untuk penipuan yang melibatkan pelbagai negara, pertimbangkan untuk melapor kepada badan antarabangsa seperti INTERPOL atau menggunakan saluran kerjasama serantau ASEAN.',
    th: 'สำหรับการหลอกลวงที่เกี่ยวข้องกับหลายประเทศ พิจารณารายงานต่อองค์กรระหว่างประเทศเช่น INTERPOL หรือใช้ช่องทางความร่วมมือระดับภูมิภาคอาเซียน',
    vi: 'Đối với các vụ lừa đảo liên quan đến nhiều quốc gia, hãy xem xét báo cáo cho các cơ quan quốc tế như INTERPOL hoặc sử dụng các kênh hợp tác khu vực ASEAN.',
    fil: 'Para sa mga scam na kinasasangkutan ng maraming bansa, isaalang-alang ang pag-uulat sa mga internasyonal na katawan tulad ng INTERPOL o paggamit ng mga channel ng kooperasyon sa rehiyon ng ASEAN.',
    km: 'សម្រាប់ការបោកប្រាស់ដែលពាក់ព័ន្ធនឹងប្រទេសជាច្រើន សូមពិចារណារាយការណ៍ទៅស្ថាប័នអន្តរជាតិដូចជា INTERPOL ឬប្រើប្រាស់បណ្តាញសហប្រតិបត្តិការតំបន់អាស៊ាន។',
    lo: 'ສຳລັບການຫຼອກລວງທີ່ກ່ຽວຂ້ອງກັບຫຼາຍປະເທດ, ພິຈາລະນະລາຍງານຕໍ່ອົງການສາກົນເຊັ່ນ INTERPOL ຫຼື ໃຊ້ຊ່ອງທາງການຮ່ວມມືພາກພື້ນອາຊຽນ.',
    my: 'နိုင်ငံများစွာ ပါဝင်ပတ်သက်သော လိမ်လည်မှုများအတွက်၊ INTERPOL ကဲ့သို့သော နိုင်ငံတကာ အဖွဲ့အစည်းများထံ တိုင်ကြားရန် သို့မဟုတ် အာဆီယံ ဒေသတွင်း ပူးပေါင်းဆောင်ရွက်မှု လမ်းကြောင်းများကို အသုံးပြုရန် စဉ်းစားပါ။',
  },

  // --- ABOUT PAGE ---
  'about.title': {
    en: 'About genZAFE',
    id: 'Tentang genZAFE',
    ms: 'Mengenai genZAFE',
    th: 'เกี่ยวกับ genZAFE',
    vi: 'Về genZAFE',
    fil: 'Tungkol sa genZAFE',
    km: 'អំពី genZAFE',
    lo: 'ກ່ຽວກັບ genZAFE',
    my: 'genZAFE အကြောင်း',
  },
  'about.subtitle': {
    en: 'Generation Zero-risk ASEAN Fraud Empowerment',
    id: 'Generation Zero-risk ASEAN Fraud Empowerment',
    ms: 'Generation Zero-risk ASEAN Fraud Empowerment',
    th: 'Generation Zero-risk ASEAN Fraud Empowerment',
    vi: 'Generation Zero-risk ASEAN Fraud Empowerment',
    fil: 'Generation Zero-risk ASEAN Fraud Empowerment',
    km: 'Generation Zero-risk ASEAN Fraud Empowerment',
    lo: 'Generation Zero-risk ASEAN Fraud Empowerment',
    my: 'Generation Zero-risk ASEAN Fraud Empowerment',
  },
  'about.ourMission': {
    en: 'Our Mission',
    id: 'Misi Kami',
    ms: 'Misi Kami',
    th: 'ภารกิจของเรา',
    vi: 'Sứ mệnh của chúng tôi',
    fil: 'Ang Aming Misyon',
    km: 'បេសកកម្មរបស់យើង',
    lo: 'ພາລະກິດຂອງພວກເຮົາ',
    my: 'ကျွန်ုပ်တို့၏ ရည်မှန်းချက်',
  },
  'about.mission.text': {
    en: 'genZAFE aims to create a fraud-free ASEAN region by empowering citizens with knowledge, tools, and direct access to reporting channels. We believe that education and quick action are the best defenses against digital crime.',
    id: 'genZAFE bertujuan untuk menciptakan kawasan ASEAN yang bebas penipuan dengan memberdayakan warga dengan pengetahuan, alat, dan akses langsung ke saluran pelaporan. Kami percaya bahwa pendidikan dan tindakan cepat adalah pertahanan terbaik terhadap kejahatan digital.',
    ms: 'genZAFE bertujuan untuk mewujudkan rantau ASEAN bebas penipuan dengan memperkasakan rakyat dengan pengetahuan, alat, dan akses terus ke saluran pelaporan. Kami percaya bahawa pendidikan dan tindakan pantas adalah pertahanan terbaik terhadap jenayah digital.',
    th: 'genZAFE มุ่งมั่นที่จะสร้างภูมิภาคอาเซียนที่ปลอดการฉ้อโกงโดยการเพิ่มขีดความสามารถให้กับประชาชนด้วยความรู้ เครื่องมือ และการเข้าถึงช่องทางการรายงานโดยตรง เราเชื่อว่าการศึกษาและการดำเนินการที่รวดเร็วคือการป้องกันที่ดีที่สุดต่ออาชญากรรมดิจิทัล',
    vi: 'genZAFE nhằm mục đích tạo ra một khu vực ASEAN không có gian lận bằng cách trao quyền cho công dân kiến thức, công cụ và quyền truy cập trực tiếp vào các kênh báo cáo. Chúng tôi tin rằng giáo dục và hành động nhanh chóng là biện pháp phòng thủ tốt nhất chống lại tội phạm kỹ thuật số.',
    fil: 'Layunin ng genZAFE na lumikha ng isang rehiyong ASEAN na walang pandaraya sa pamamagitan ng pagbibigay kapangyarihan sa mga mamamayan ng kaalaman, mga tool, at direktang access sa mga channel ng pag-uulat. Naniniwala kami na ang edukasyon at mabilis na pagkilos ay ang pinakamahusay na depensa laban sa digital crime.',
    km: 'genZAFE មានគោលបំណងបង្កើតតំបន់អាស៊ានដែលគ្មានការបោកប្រាស់ ដោយផ្តល់អំណាចដល់ប្រជាពលរដ្ឋនូវចំណេះដឹង ឧបករណ៍ និងការចូលប្រើប្រាស់ដោយផ្ទាល់ទៅកាន់បណ្តាញរាយការណ៍។ យើងជឿជាក់ថាការអប់រំ និងសកម្មភាពរហ័សគឺជាការការពារដ៏ល្អបំផុតប្រឆាំងនឹងឧក្រិដ្ឋកម្មឌីជីថល។',
    lo: 'genZAFE ມີຈຸດປະສົງເພື່ອສ້າງພາກພື້ນອາຊຽນທີ່ປອດຈາກການໂກງໂດຍການມອບອຳນາດໃຫ້ປະຊາຊົນດ້ວຍຄວາມຮູ້, ເຄື່ອງມື, ແລະ ການເຂົ້າເຖິງຊ່ອງທາງການລາຍງານໂດຍກົງ. ພວກເຮົາເຊື່ອວ່າການສຶກສາ ແລະ ການດຳເນີນການໄວແມ່ນການປ້ອງກັນທີ່ດີທີ່ສຸດຕໍ່ອາຊະຍາກຳດິຈິຕອນ.',
    my: 'genZAFE သည် ပြည်သူများကို အသိပညာ၊ ကိရိယာများနှင့် တိုင်ကြားရန် လမ်းကြောင်းများသို့ တိုက်ရိုက်ဝင်ရောက်ခွင့် ပေးခြင်းဖြင့် လိမ်လည်မှုကင်းစင်သော အာဆီယံဒေသကို ဖန်တီးရန် ရည်ရွယ်သည်။ ပညာရေးနှင့် လျင်မြန်သော အရေးယူဆောင်ရွက်မှုသည် ဒစ်ဂျစ်တယ်ရာဇဝတ်မှုများကို ကာကွယ်ရန် အကောင်းဆုံးနည်းလမ်းဖြစ်သည်ဟု ကျွန်ုပ်တို့ ယုံကြည်သည်။',
  },
  'about.whatWeProvide': {
    en: 'What We Provide',
    id: 'Apa yang Kami Sediakan',
    ms: 'Apa yang Kami Sediakan',
    th: 'สิ่งที่เรามอบให้',
    vi: 'Những gì chúng tôi cung cấp',
    fil: 'Ano ang Aming Ibinibigay',
    km: 'អ្វីដែលយើងផ្តល់ជូន',
    lo: 'ສິ່ງທີ່ພວກເຮົາສະໜອງ',
    my: 'ကျွန်ုပ်တို့ ပေးဆောင်သောအရာ',
  },
  'about.provide.emergency.title': {
    en: 'Emergency Protocols',
    id: 'Protokol Darurat',
    ms: 'Protokol Kecemasan',
    th: 'โปรโตคอลฉุกเฉิน',
    vi: 'Giao thức khẩn cấp',
    fil: 'Mga Protokol sa Emergency',
    km: 'ពិធីសារសង្គ្រោះបន្ទាន់',
    lo: 'ມາດຕະການສຸກເສີນ',
    my: 'အရေးပေါ် လုပ်ထုံးလုပ်နည်းများ',
  },
  'about.provide.emergency.desc': {
    en: 'Step-by-step guides on what to do immediately after being scammed.',
    id: 'Panduan langkah demi langkah tentang apa yang harus dilakukan segera setelah ditipu.',
    ms: 'Panduan langkah demi langkah mengenai apa yang perlu dilakukan sebaik sahaja ditipu.',
    th: 'คู่มือทีละขั้นตอนเกี่ยวกับสิ่งที่ต้องทำทันทีหลังจากถูกหลอกลวง',
    vi: 'Hướng dẫn từng bước về những việc cần làm ngay sau khi bị lừa đảo.',
    fil: 'Mga sunud-sunod na gabay sa kung ano ang gagawin kaagad pagkatapos ma-scam.',
    km: 'ការណែនាំមួយជំហានម្តង ៗ អំពីអ្វីដែលត្រូវធ្វើភ្លាមៗបន្ទាប់ពីត្រូវបានគេបោកប្រាស់។',
    lo: 'ຄູ່ມືເທື່ອລະຂັ້ນຕອນກ່ຽວກັບສິ່ງທີ່ຕ້ອງເຮັດທັນທີຫຼັງຈາກຖືກຫຼອກລວງ.',
    my: 'လိမ်လည်ခံရပြီးနောက် ချက်ချင်းလုပ်ဆောင်ရမည့် အဆင့်ဆင့် လမ်းညွှန်များ။',
  },
  'about.provide.types.title': {
    en: 'Scam Type Identification',
    id: 'Identifikasi Jenis Penipuan',
    ms: 'Pengenalan Jenis Penipuan',
    th: 'การระบุประเภทการหลอกลวง',
    vi: 'Nhận dạng loại lừa đảo',
    fil: 'Pagkakakilanlan ng Uri ng Scam',
    km: 'ការកំណត់អត្តសញ្ញាណប្រភេទការបោកប្រាស់',
    lo: 'ການລະບຸປະເພດການຫຼອກລວງ',
    my: 'လိမ်လည်မှုအမျိုးအစား ခွဲခြားသတ်မှတ်ခြင်း',
  },
  'about.provide.types.desc': {
    en: 'Tools to help you identify specific types of scams and their warning signs.',
    id: 'Alat untuk membantu Anda mengidentifikasi jenis penipuan tertentu dan tanda bahayanya.',
    ms: 'Alat untuk membantu anda mengenal pasti jenis penipuan tertentu dan tanda amaran mereka.',
    th: 'เครื่องมือที่จะช่วยคุณระบุประเภทของการหลอกลวงและสัญญาณเตือน',
    vi: 'Các công cụ giúp bạn xác định các loại lừa đảo cụ thể và dấu hiệu cảnh báo của chúng.',
    fil: 'Mga tool upang matulungan kang matukoy ang mga partikular na uri ng scam at ang kanilang mga babala.',
    km: 'ឧបករណ៍ដើម្បីជួយអ្នកកំណត់អត្តសញ្ញាណប្រភេទជាក់លាក់នៃការបោកប្រាស់ និងសញ្ញាព្រមានរបស់ពួកគេ។',
    lo: 'ເຄື່ອງມືເພື່ອຊ່ວຍທ່ານລະບຸປະເພດການຫຼອກລວງສະເພາະ ແລະ ສັນຍານເຕືອນຂອງພວກເຂົາ.',
    my: 'သီးခြား လိမ်လည်မှုအမျိုးအစားများနှင့် ၎င်းတို့၏ သတိပေးလက္ခဏာများကို ခွဲခြားသတ်မှတ်ရန် ကူညီပေးသော ကိရိယာများ။',
  },
  'about.provide.reporting.title': {
    en: 'Reporting Directory',
    id: 'Direktori Pelaporan',
    ms: 'Direktori Pelaporan',
    th: 'สารบบการรายงาน',
    vi: 'Danh bạ báo cáo',
    fil: 'Direktoryo ng Pag-uulat',
    km: 'បញ្ជីឈ្មោះរាយការណ៍',
    lo: 'ປຶ້ມລາຍຊື່ການລາຍງານ',
    my: 'တိုင်ကြားမှု လမ်းညွှန်',
  },
  'about.provide.reporting.desc': {
    en: 'Comprehensive list of official contacts for banks and police in 10 ASEAN countries.',
    id: 'Daftar lengkap kontak resmi untuk bank dan polisi di 10 negara ASEAN.',
    ms: 'Senarai lengkap kenalan rasmi untuk bank dan polis di 10 negara ASEAN.',
    th: 'รายชื่อผู้ติดต่ออย่างเป็นทางการที่ครอบคลุมสำหรับธนาคารและตำรวจใน 10 ประเทศอาเซียน',
    vi: 'Danh sách đầy đủ các liên hệ chính thức cho ngân hàng và cảnh sát tại 10 quốc gia ASEAN.',
    fil: 'Komprehensibong listahan ng mga opisyal na contact para sa mga bangko at pulisya sa 10 bansa sa ASEAN.',
    km: 'បញ្ជីទំនាក់ទំនងផ្លូវការដ៏ទូលំទូលាយសម្រាប់ធនាគារ និងប៉ូលីសនៅក្នុងប្រទេសអាស៊ានចំនួន ១០ ។',
    lo: 'ລາຍຊື່ຜູ້ຕິດຕໍ່ທາງການທີ່ສົມບູນແບບສຳລັບທະນາຄານ ແລະ ຕຳຫຼວດໃນ 10 ປະເທດອາຊຽນ.',
    my: 'အာဆီယံ ၁၀ နိုင်ငံရှိ ဘဏ်များနှင့် ရဲတပ်ဖွဲ့အတွက် တရားဝင် ဆက်သွယ်ရန်စာရင်း အပြည့်အစုံ။',
  },
  'about.provide.education.title': {
    en: 'Education & Prevention',
    id: 'Edukasi & Pencegahan',
    ms: 'Pendidikan & Pencegahan',
    th: 'การศึกษาและการป้องกัน',
    vi: 'Giáo dục & Phòng ngừa',
    fil: 'Edukasyon at Pag-iwas',
    km: 'ការអប់រំ & ការបង្ការ',
    lo: 'ການສຶກສາ & ການປ້ອງກັນ',
    my: 'ပညာပေးခြင်းနှင့် ကာကွယ်ခြင်း',
  },
  'about.provide.education.desc': {
    en: 'Quizzes, articles, and guides to improve your digital safety awareness.',
    id: 'Kuis, artikel, dan panduan untuk meningkatkan kesadaran keamanan digital Anda.',
    ms: 'Kuiz, artikel, dan panduan untuk meningkatkan kesedaran keselamatan digital anda.',
    th: 'แบบทดสอบ บทความ และคู่มือเพื่อปรับปรุงความตระหนักด้านความปลอดภัยดิจิทัลของคุณ',
    vi: 'Câu đố, bài viết và hướng dẫn để cải thiện nhận thức về an toàn kỹ thuật số của bạn.',
    fil: 'Mga pagsusulit, artikulo, at gabay upang mapabuti ang iyong kamalayan sa digital security.',
    km: 'កម្រងសំណួរ អត្ថបទ និងការណែនាំដើម្បីកែលម្អការយល់ដឹងអំពីសុវត្ថិភាពឌីជីថលរបស់អ្នក។',
    lo: 'ແບບທົດສອບ, ບົດຄວາມ, ແລະ ຄູ່ມືເພື່ອປັບປຸງຄວາມຮັບຮູ້ດ້ານຄວາມປອດໄພດິຈິຕອນຂອງທ່ານ.',
    my: 'သင့်ဒစ်ဂျစ်တယ် ဘေးကင်းရေး အသိပညာကို တိုးတက်စေရန် ပဟေဠိများ၊ ဆောင်းပါးများနှင့် လမ်းညွှန်များ။',
  },
  'about.whatWeDontDo': {
    en: "What We Don't Do",
    id: 'Apa yang Tidak Kami Lakukan',
    ms: 'Apa yang Kami Tidak Lakukan',
    th: 'สิ่งที่เราไม่ทำ',
    vi: 'Những gì chúng tôi không làm',
    fil: 'Ang Hindi Namin Ginagawa',
    km: 'អ្វីដែលយើងមិនធ្វើ',
    lo: 'ສິ່ງທີ່ພວກເຮົາບໍ່ເຮັດ',
    my: 'ကျွန်ုပ်တို့ မလုပ်ဆောင်သောအရာ',
  },
  'about.dontDo.reports': {
    en: 'We do not process reports directly (we connect you to authorities).',
    id: 'Kami tidak memproses laporan secara langsung (kami menghubungkan Anda dengan pihak berwenang).',
    ms: 'Kami tidak memproses laporan secara langsung (kami menghubungkan anda dengan pihak berkuasa).',
    th: 'เราไม่ดำเนินการรายงานโดยตรง (เราเชื่อมต่อคุณกับเจ้าหน้าที่)',
    vi: 'Chúng tôi không xử lý báo cáo trực tiếp (chúng tôi kết nối bạn với cơ quan chức năng).',
    fil: 'Hindi kami direktang nagpoproseso ng mga ulat (ikinokonekta ka namin sa mga awtoridad).',
    km: 'យើងមិនដំណើរការរបាយការណ៍ដោយផ្ទាល់ទេ (យើងភ្ជាប់អ្នកទៅអាជ្ញាធរ)។',
    lo: 'ພວກເຮົາບໍ່ປະມວນຜົນລາຍງານໂດຍກົງ (ພວກເຮົາເຊື່ອມຕໍ່ທ່ານກັບເຈົ້າໜ້າທີ່).',
    my: 'ကျွန်ုပ်တို့သည် တိုင်ကြားစာများကို တိုက်ရိုက် ဆောင်ရွက်ခြင်း မပြုပါ (သင့်ကို အာဏာပိုင်များနှင့် ချိတ်ဆက်ပေးသည်)။',
  },
  'about.dontDo.store': {
    en: 'We do not store your personal data or evidence.',
    id: 'Kami tidak menyimpan data pribadi atau bukti Anda.',
    ms: 'Kami tidak menyimpan data peribadi atau bukti anda.',
    th: 'เราไม่เก็บข้อมูลส่วนบุคคลหรือหลักฐานของคุณ',
    vi: 'Chúng tôi không lưu trữ dữ liệu cá nhân hoặc bằng chứng của bạn.',
    fil: 'Hindi kami nag-iimbak ng iyong personal na data o ebidensya.',
    km: 'យើងមិនរក្សាទុកទិន្នន័យផ្ទាល់ខ្លួន ឬភស្តុតាងរបស់អ្នកទេ។',
    lo: 'ພວກເຮົາບໍ່ເກັບຮັກສາຂໍ້ມູນສ່ວນຕົວ ຫຼື ຫຼັກຖານຂອງທ່ານ.',
    my: 'ကျွန်ုပ်တို့သည် သင့်ကိုယ်ရေးကိုယ်တာ အချက်အလက်များ သို့မဟုတ် သက်သေအထောက်အထားများကို သိမ်းဆည်းခြင်း မပြုပါ။',
  },
  'about.dontDo.replace': {
    en: 'We do not replace official police reports.',
    id: 'Kami tidak menggantikan laporan polisi resmi.',
    ms: 'Kami tidak menggantikan laporan polis rasmi.',
    th: 'เราไม่แทนที่ใบแจ้งความของตำรวจอย่างเป็นทางการ',
    vi: 'Chúng tôi không thay thế báo cáo cảnh sát chính thức.',
    fil: 'Hindi kami pumapalit sa mga opisyal na ulat ng pulisya.',
    km: 'យើងមិនជំនួសរបាយការណ៍ប៉ូលីសផ្លូវការទេ។',
    lo: 'ພວກເຮົາບໍ່ທົດແທນລາຍງານຕຳຫຼວດທາງການ.',
    my: 'ကျွန်ုပ်တို့သည် တရားဝင် ရဲတိုင်ကြားစာများကို အစားထိုးခြင်း မပြုပါ။',
  },
  'about.dontDo.legal': {
    en: 'We do not provide legal advice.',
    id: 'Kami tidak memberikan nasihat hukum.',
    ms: 'Kami tidak memberikan nasihat undang-undang.',
    th: 'เราไม่ให้คำแนะนำทางกฎหมาย',
    vi: 'Chúng tôi không cung cấp tư vấn pháp lý.',
    fil: 'Hindi kami nagbibigay ng legal na payo.',
    km: 'យើងមិនផ្តល់ដំបូន្មានផ្លូវច្បាប់ទេ។',
    lo: 'ພວກເຮົາບໍ່ໃຫ້ຄຳແນະນຳທາງກົດໝາຍ.',
    my: 'ကျွန်ုပ်တို့သည် ဥပဒေရေးရာ အကြံဉာဏ် မပေးပါ။',
  },
  'about.aseanCoverage': {
    en: 'ASEAN Coverage',
    id: 'Cakupan ASEAN',
    ms: 'Liputan ASEAN',
    th: 'ความคุ้มครองอาเซียน',
    vi: 'Phạm vi ASEAN',
    fil: 'Saklaw ng ASEAN',
    km: 'ការគ្របដណ្តប់អាស៊ាន',
    lo: 'ການຄຸ້ມຄອງອາຊຽນ',
    my: 'အာဆီယံ လွှမ်းခြုံမှု',
  },
  'about.coverageDesc': {
    en: 'We provide resources for all 10 ASEAN member states:',
    id: 'Kami menyediakan sumber daya untuk semua 10 negara anggota ASEAN:',
    ms: 'Kami menyediakan sumber untuk kesemua 10 negara anggota ASEAN:',
    th: 'เราจัดหาทรัพยากรสำหรับ 10 ประเทศสมาชิกอาเซียน:',
    vi: 'Chúng tôi cung cấp tài nguyên cho tất cả 10 quốc gia thành viên ASEAN:',
    fil: 'Nagbibigay kami ng mga mapagkukunan para sa lahat ng 10 miyembrong estado ng ASEAN:',
    km: 'យើងផ្តល់ធនធានសម្រាប់រដ្ឋសមាជិកអាស៊ានទាំង ១០៖',
    lo: 'ພວກເຮົາສະໜອງຊັບພະຍາກອນສຳລັບທັງ 10 ປະເທດສະມາຊິກອາຊຽນ:',
    my: 'ကျွန်ုပ်တို့သည် အာဆီယံ အဖွဲ့ဝင်နိုင်ငံ ၁၀ နိုင်ငံလုံးအတွက် အရင်းအမြစ်များကို ပေးဆောင်သည် -',
  },

  // --- DISCLAIMER PAGE ---
  'disclaimer.title': {
    en: 'Disclaimer',
    id: 'Penafian',
    ms: 'Penafian',
    th: 'ข้อปฏิเสธความรับผิด',
    vi: 'Tuyên bố từ chối trách nhiệm',
    fil: 'Pagtatanggi',
    km: 'ការបដិសេធ',
    lo: 'ການປະຕິເສດຄວາມຮັບຜິດຊອບ',
    my: 'ငြင်းဆိုချက်',
  },
  'disclaimer.subtitle': {
    en: 'Please read this disclaimer carefully before using genZAFE.',
    id: 'Harap baca penafian ini dengan cermat sebelum menggunakan genZAFE.',
    ms: 'Sila baca penafian ini dengan teliti sebelum menggunakan genZAFE.',
    th: 'โปรดอ่านข้อปฏิเสธความรับผิดนี้อย่างละเอียดก่อนใช้ genZAFE',
    vi: 'Vui lòng đọc kỹ tuyên bố từ chối trách nhiệm này trước khi sử dụng genZAFE.',
    fil: 'Pakibasa nang mabuti ang pagtatanggi na ito bago gamitin ang genZAFE.',
    km: 'សូមអានការបដិសេធនេះដោយប្រុងប្រយ័ត្នមុនពេលប្រើ genZAFE ។',
    lo: 'ກະລຸນາອ່ານການປະຕິເສດຄວາມຮັບຜິດຊອບນີ້ຢ່າງລະອຽດກ່ອນໃຊ້ genZAFE.',
    my: 'genZAFE ကို အသုံးမပြုမီ ဤငြင်းဆိုချက်ကို သေချာဖတ်ပါ။',
  },
  'disclaimer.banner': {
    en: 'genZAFE is an educational and informational platform. We are NOT a law enforcement agency.',
    id: 'genZAFE adalah platform pendidikan dan informasi. Kami BUKAN badan penegak hukum.',
    ms: 'genZAFE adalah platform pendidikan dan maklumat. Kami BUKAN agensi penguatkuasaan undang-undang.',
    th: 'genZAFE เป็นแพลตฟอร์มการศึกษาและข้อมูล เราไม่ใช่หน่วยงานบังคับใช้กฎหมาย',
    vi: 'genZAFE là một nền tảng giáo dục và thông tin. Chúng tôi KHÔNG phải là cơ quan thực thi pháp luật.',
    fil: 'Ang genZAFE ay isang platform na pang-edukasyon at impormasyon. HINDI kami isang ahensya ng pagpapatupad ng batas.',
    km: 'genZAFE គឺជាវេទិកាអប់រំ និងព័ត៌មាន។ យើងមិនមែនជាទីភ្នាក់ងារអនុវត្តច្បាប់ទេ។',
    lo: 'genZAFE ເປັນເວທີການສຶກສາ ແລະ ຂໍ້ມູນຂ່າວສານ. ພວກເຮົາບໍ່ແມ່ນອົງການບັງຄັບໃຊ້ກົດໝາຍ.',
    my: 'genZAFE သည် ပညာပေးနှင့် သတင်းအချက်အလက် ပလက်ဖောင်းတစ်ခုဖြစ်သည်။ ကျွန်ုပ်တို့သည် တရားဥပဒေစိုးမိုးရေး အေဂျင်စီ မဟုတ်ပါ။',
  },
  'disclaimer.nature.title': {
    en: '1. Nature of Services',
    id: '1. Sifat Layanan',
    ms: '1. Sifat Perkhidmatan',
    th: '1. ลักษณะของบริการ',
    vi: '1. Bản chất dịch vụ',
    fil: '1. Kalikasan ng mga Serbisyo',
    km: '១. លក្ខណៈនៃសេវាកម្ម',
    lo: '1. ລັກສະນະຂອງການບໍລິການ',
    my: '၁။ ဝန်ဆောင်မှုများ၏ သဘောသဘာဝ',
  },
  'disclaimer.nature.desc': {
    en: 'genZAFE provides information, guides, and tools for scam awareness and prevention. While we strive for accuracy, the information provided is for general informational purposes only and should not be considered as professional legal, financial, or technical advice.',
    id: 'genZAFE menyediakan informasi, panduan, dan alat untuk kesadaran dan pencegahan penipuan. Meskipun kami berusaha untuk akurasi, informasi yang diberikan hanya untuk tujuan informasi umum dan tidak boleh dianggap sebagai nasihat hukum, keuangan, atau teknis profesional.',
    ms: 'genZAFE menyediakan maklumat, panduan, dan alat untuk kesedaran dan pencegahan penipuan. Walaupun kami berusaha untuk ketepatan, maklumat yang diberikan adalah untuk tujuan maklumat umum sahaja dan tidak boleh dianggap sebagai nasihat undang-undang, kewangan, atau teknikal profesional.',
    th: 'genZAFE ให้ข้อมูล คู่มือ และเครื่องมือสำหรับการตระหนักรู้และการป้องกันการหลอกลวง แม้ว่าเราจะพยายามเพื่อความถูกต้อง ข้อมูลที่ให้ไว้มีวัตถุประสงค์เพื่อเป็นข้อมูลทั่วไปเท่านั้นและไม่ควรพิจารณาว่าเป็นคำแนะนำทางกฎหมาย การเงิน หรือทางเทคนิคระดับมืออาชีพ',
    vi: 'genZAFE cung cấp thông tin, hướng dẫn và công cụ để nâng cao nhận thức và phòng chống lừa đảo. Mặc dù chúng tôi cố gắng đảm bảo tính chính xác, thông tin được cung cấp chỉ nhằm mục đích thông tin chung và không nên được coi là tư vấn pháp lý, tài chính hoặc kỹ thuật chuyên nghiệp.',
    fil: 'Nagbibigay ang genZAFE ng impormasyon, mga gabay, at mga tool para sa kamalayan at pag-iwas sa scam. Habang nagsusumikap kami para sa katumpakan, ang impormasyong ibinigay ay para sa pangkalahatang layunin ng impormasyon lamang at hindi dapat ituring bilang propesyonal na legal, pinansyal, o teknikal na payo.',
    km: 'genZAFE ផ្តល់ព័ត៌មាន ការណែនាំ និងឧបករណ៍សម្រាប់ការយល់ដឹង និងការបង្ការការបោកប្រាស់។ ខណៈពេលដែលយើងខិតខំដើម្បីភាពត្រឹមត្រូវ ព័ត៌មានដែលបានផ្តល់គឺសម្រាប់គោលបំណងព័ត៌មានទូទៅតែប៉ុណ្ណោះ ហើយមិនគួរត្រូវបានចាត់ទុកថាជាដំបូន្មានផ្លូវច្បាប់ ហិរញ្ញវត្ថុ ឬបច្ចេកទេសប្រកបដោយវិជ្ជាជីវៈឡើយ។',
    lo: 'genZAFE ສະໜອງຂໍ້ມູນ, ຄູ່ມື, ແລະ ເຄື່ອງມືສຳລັບຄວາມຮັບຮູ້ ແລະ ການປ້ອງກັນການຫຼອກລວງ. ເຖິງແມ່ນວ່າພວກເຮົາພະຍາຍາມເພື່ອຄວາມຖືກຕ້ອງ, ຂໍ້ມູນທີ່ສະໜອງໃຫ້ແມ່ນເພື່ອຈຸດປະສົງຂໍ້ມູນທົ່ວໄປເທົ່ານັ້ນ ແລະ ບໍ່ຄວນຖືວ່າເປັນຄຳແນະນຳທາງກົດໝາຍ, ການເງິນ, ຫຼື ທາງເຕັກນິກແບບມືອາຊີບ.',
    my: 'genZAFE သည် လိမ်လည်မှု အသိပညာနှင့် ကာကွယ်ရေးအတွက် သတင်းအချက်အလက်များ၊ လမ်းညွှန်များနှင့် ကိရိယာများကို ပေးဆောင်သည်။ ကျွန်ုပ်တို့သည် တိကျမှန်ကန်မှုကို ကြိုးပမ်းသော်လည်း၊ ပေးထားသော သတင်းအချက်အလက်များသည် အထွေထွေ ဗဟုသုတအတွက်သာ ဖြစ်ပြီး ပရော်ဖက်ရှင်နယ် ဥပဒေရေးရာ၊ ငွေကြေး သို့မဟုတ် နည်းပညာဆိုင်ရာ အကြံဉာဏ်အဖြစ် မယူဆသင့်ပါ။',
  },
  'disclaimer.data.title': {
    en: '2. Data Privacy & Security',
    id: '2. Privasi & Keamanan Data',
    ms: '2. Privasi & Keselamatan Data',
    th: '2. ความเป็นส่วนตัวและความปลอดภัยของข้อมูล',
    vi: '2. Quyền riêng tư & Bảo mật dữ liệu',
    fil: '2. Privacy at Seguridad ng Data',
    km: '២. ឯកជនភាព និងសុវត្ថិភាពទិន្នន័យ',
    lo: '2. ຄວາມເປັນສ່ວນຕົວ & ຄວາມປອດໄພຂອງຂໍ້ມູນ',
    my: '၂။ ဒေတာ လုံခြုံရေးနှင့် လျှို့ဝှက်ချက်',
  },
  'disclaimer.data.desc': {
    en: 'We prioritize your privacy. genZAFE does not store personal data entered into our forms (such as the Report Template Generator or Check Scam tool) on our servers.',
    id: 'Kami memprioritaskan privasi Anda. genZAFE tidak menyimpan data pribadi yang dimasukkan ke dalam formulir kami (seperti Generator Templat Laporan atau alat Cek Penipuan) di server kami.',
    ms: 'Kami mengutamakan privasi anda. genZAFE tidak menyimpan data peribadi yang dimasukkan ke dalam borang kami (seperti Penjana Templat Laporan atau alat Semak Penipuan) pada pelayan kami.',
    th: 'เราให้ความสำคัญกับความเป็นส่วนตัวของคุณ genZAFE ไม่เก็บข้อมูลส่วนบุคคลที่ป้อนลงในแบบฟอร์มของเรา (เช่น เครื่องมือสร้างเทมเพลตรายงานหรือเครื่องมือตรวจสอบการหลอกลวง) บนเซิร์ฟเวอร์ของเรา',
    vi: 'Chúng tôi ưu tiên quyền riêng tư của bạn. genZAFE không lưu trữ dữ liệu cá nhân được nhập vào các biểu mẫu của chúng tôi (chẳng hạn như Trình tạo mẫu báo cáo hoặc công cụ Kiểm tra lừa đảo) trên máy chủ của chúng tôi.',
    fil: 'Priyoridad namin ang iyong privacy. Ang genZAFE ay hindi nag-iimbak ng personal na data na ipinasok sa aming mga form (tulad ng Report Template Generator o Check Scam tool) sa aming mga server.',
    km: 'យើងផ្តល់អាទិភាពដល់ឯកជនភាពរបស់អ្នក។ genZAFE មិនរក្សាទុកទិន្នន័យផ្ទាល់ខ្លួនដែលបានបញ្ចូលទៅក្នុងទម្រង់របស់យើង (ដូចជាម៉ាស៊ីនបង្កើតគំរូរបាយការណ៍ ឬឧបករណ៍ពិនិត្យការបោកប្រាស់) នៅលើម៉ាស៊ីនមេរបស់យើងទេ។',
    lo: 'ພວກເຮົາໃຫ້ຄວາມສຳຄັນກັບຄວາມເປັນສ່ວນຕົວຂອງທ່ານ. genZAFE ບໍ່ເກັບຮັກສາຂໍ້ມູນສ່ວນຕົວທີ່ປ້ອນເຂົ້າໃນແບບຟອມຂອງພວກເຮົາ (ເຊັ່ນ: ເຄື່ອງມືສ້າງແບບຟອມລາຍງານ ຫຼື ເຄື່ອງມືກວດສອບການຫຼອກລວງ) ໃນເຊີບເວີຂອງພວກເຮົາ.',
    my: 'ကျွန်ုပ်တို့သည် သင့်လျှို့ဝှက်ချက်ကို ဦးစားပေးသည်။ genZAFE သည် ကျွန်ုပ်တို့၏ ဖောင်များ (တိုင်ကြားစာ ပုံစံခွက် ထုတ်လုပ်စက် သို့မဟုတ် လိမ်လည်မှု စစ်ဆေးရေး ကိရိယာ ကဲ့သို့သော) တွင် ထည့်သွင်းထားသော ကိုယ်ရေးကိုယ်တာ အချက်အလက်များကို ကျွန်ုပ်တို့၏ ဆာဗာများတွင် သိမ်းဆည်းခြင်း မပြုပါ။',
  },
  'disclaimer.data.localStorage': {
    en: 'All processing happens locally in your browser. However, we recommend clearing your browser cache after using our tools on a public device.',
    id: 'Semua pemrosesan terjadi secara lokal di browser Anda. Namun, kami menyarankan untuk menghapus cache browser Anda setelah menggunakan alat kami di perangkat publik.',
    ms: 'Semua pemprosesan berlaku secara tempatan dalam penyemak imbas anda. Walau bagaimanapun, kami mengesyorkan agar anda mengosongkan cache penyemak imbas anda selepas menggunakan alat kami pada peranti awam.',
    th: 'การประมวลผลทั้งหมดเกิดขึ้นภายในเบราว์เซอร์ของคุณ อย่างไรก็ตาม เราแนะนำให้ล้างแคชเบราว์เซอร์ของคุณหลังจากใช้เครื่องมือของเราบนอุปกรณ์สาธารณะ',
    vi: 'Tất cả quá trình xử lý diễn ra cục bộ trong trình duyệt của bạn. Tuy nhiên, chúng tôi khuyên bạn nên xóa bộ nhớ cache trình duyệt sau khi sử dụng các công cụ của chúng tôi trên thiết bị công cộng.',
    fil: 'Ang lahat ng pagproseso ay nangyayari nang lokal sa iyong browser. Gayunpaman, inirerekomenda namin na i-clear ang cache ng iyong browser pagkatapos gamitin ang aming mga tool sa isang pampublikong device.',
    km: 'ដំណើរការទាំងអស់កើតឡើងនៅក្នុងកម្មវិធីរុករករបស់អ្នក។ ទោះយ៉ាងណាក៏ដោយ យើងសូមណែនាំឱ្យសម្អាតឃ្លាំងសម្ងាត់កម្មវិធីរុករករបស់អ្នក បន្ទាប់ពីប្រើឧបករណ៍របស់យើងនៅលើឧបករណ៍សាធារណៈ។',
    lo: 'ການປະມວນຜົນທັງໝົດເກີດຂຶ້ນໃນບຣາວເຊີຂອງທ່ານ. ຢ່າງໃດກໍຕາມ, ພວກເຮົາແນະນຳໃຫ້ລຶບແຄຊ໌ບຣາວເຊີຂອງທ່ານຫຼັງຈາກໃຊ້ເຄື່ອງມືຂອງພວກເຮົາໃນອຸປະກອນສາທາລະນະ.',
    my: 'လုပ်ဆောင်မှုအားလုံးသည် သင့်ဘရောက်ဆာတွင်သာ ဖြစ်ပေါ်သည်။ သို့သော်၊ အများသုံး စက်ပစ္စည်းတစ်ခုတွင် ကျွန်ုပ်တို့၏ ကိရိယာများကို အသုံးပြုပြီးနောက် သင့်ဘရောက်ဆာ cache ကို ရှင်းလင်းရန် အကြံပြုပါသည်။',
  },
  'disclaimer.reporting.title': {
    en: '3. Reporting & Third Parties',
    id: '3. Pelaporan & Pihak Ketiga',
    ms: '3. Pelaporan & Pihak Ketiga',
    th: '3. การรายงานและบุคคลที่สาม',
    vi: '3. Báo cáo & Bên thứ ba',
    fil: '3. Pag-uulat at Mga Ikatlong Partido',
    km: '៣. ការរាយការណ៍ និងភាគីទីបី',
    lo: '3. ການລາຍງານ & ບຸກຄົນທີສາມ',
    my: '၃။ တိုင်ကြားခြင်းနှင့် တတိယအဖွဲ့အစည်းများ',
  },
  'disclaimer.reporting.desc': {
    en: 'genZAFE acts as a directory to connect you with official reporting channels. We are not responsible for:',
    id: 'genZAFE bertindak sebagai direktori untuk menghubungkan Anda dengan saluran pelaporan resmi. Kami tidak bertanggung jawab atas:',
    ms: 'genZAFE bertindak sebagai direktori untuk menghubungkan anda dengan saluran pelaporan rasmi. Kami tidak bertanggungjawab untuk:',
    th: 'genZAFE ทำหน้าที่เป็นสารบบเพื่อเชื่อมต่อคุณกับช่องทางการรายงานอย่างเป็นทางการ เราไม่รับผิดชอบต่อ:',
    vi: 'genZAFE đóng vai trò là danh bạ để kết nối bạn với các kênh báo cáo chính thức. Chúng tôi không chịu trách nhiệm về:',
    fil: 'Ang genZAFE ay nagsisilbing direktoryo upang ikonekta ka sa mga opisyal na channel ng pag-uulat. Hindi kami responsable para sa:',
    km: 'genZAFE ដើរតួជាបញ្ជីឈ្មោះដើម្បីភ្ជាប់អ្នកជាមួយបណ្តាញរាយការណ៍ផ្លូវការ។ យើងមិនទទួលខុសត្រូវចំពោះ៖',
    lo: 'genZAFE ເຮັດໜ້າທີ່ເປັນປຶ້ມລາຍຊື່ເພື່ອເຊື່ອມຕໍ່ທ່ານກັບຊ່ອງທາງການລາຍງານທາງການ. ພວກເຮົາບໍ່ຮັບຜິດຊອບຕໍ່:',
    my: 'genZAFE သည် သင့်အား တရားဝင် တိုင်ကြားရန် လမ်းကြောင်းများနှင့် ချိတ်ဆက်ပေးသော လမ်းညွှန်တစ်ခုအဖြစ် ဆောင်ရွက်သည်။ အောက်ပါတို့အတွက် ကျွန်ုပ်တို့ တာဝန်မယူပါ -',
  },
  'disclaimer.reporting.police': {
    en: 'The outcome of any reports filed.',
    id: 'Hasil dari laporan apa pun yang diajukan.',
    ms: 'Hasil daripada sebarang laporan yang difailkan.',
    th: 'ผลลัพธ์ของรายงานใดๆ ที่ยื่น',
    vi: 'Kết quả của bất kỳ báo cáo nào được nộp.',
    fil: 'Ang kinalabasan ng anumang mga ulat na isinampa.',
    km: 'លទ្ធផលនៃរបាយការណ៍ណាមួយដែលបានដាក់។',
    lo: 'ຜົນຂອງລາຍງານໃດໆທີ່ຍື່ນ.',
    my: 'တင်သွင်းသော တိုင်ကြားစာများ၏ ရလဒ်။',
  },
  'disclaimer.reporting.bank': {
    en: 'The response time of banks or authorities.',
    id: 'Waktu respons bank atau pihak berwenang.',
    ms: 'Masa tindak balas bank atau pihak berkuasa.',
    th: 'เวลาตอบสนองของธนาคารหรือเจ้าหน้าที่',
    vi: 'Thời gian phản hồi của ngân hàng hoặc cơ quan chức năng.',
    fil: 'Ang oras ng pagtugon ng mga bangko o awtoridad.',
    km: 'ពេលវេលាឆ្លើយតបរបស់ធនាគារ ឬអាជ្ញាធរ។',
    lo: 'ເວລາຕອບສະໜອງຂອງທະນາຄານ ຫຼື ເຈົ້າໜ້າທີ່.',
    my: 'ဘဏ်များ သို့မဟုတ် အာဏာပိုင်များ၏ တုံ့ပြန်ချိန်။',
  },
  'disclaimer.reporting.platform': {
    en: 'The availability of third-party websites.',
    id: 'Ketersediaan situs web pihak ketiga.',
    ms: 'Ketersediaan laman web pihak ketiga.',
    th: 'ความพร้อมใช้งานของเว็บไซต์บุคคลที่สาม',
    vi: 'Tính khả dụng của các trang web bên thứ ba.',
    fil: 'Ang availability ng mga third-party na website.',
    km: 'ភាពអាចរកបាននៃគេហទំព័រភាគីទីបី។',
    lo: 'ຄວາມພ້ອມຂອງເວັບໄຊທ໌ບຸກຄົນທີສາມ.',
    my: 'တတိယအဖွဲ့အစည်း ဝက်ဘ်ဆိုက်များ၏ ရရှိနိုင်မှု။',
  },
  'disclaimer.reporting.consumer': {
    en: 'Any actions taken by third parties.',
    id: 'Tindakan apa pun yang diambil oleh pihak ketiga.',
    ms: 'Sebarang tindakan yang diambil oleh pihak ketiga.',
    th: 'การดำเนินการใดๆ ที่ดำเนินการโดยบุคคลที่สาม',
    vi: 'Bất kỳ hành động nào được thực hiện bởi bên thứ ba.',
    fil: 'Anumang aksyon na ginawa ng mga ikatlong partido.',
    km: 'សកម្មភាពណាមួយដែលធ្វើឡើងដោយភាគីទីបី។',
    lo: 'ການດຳເນີນການໃດໆທີ່ເຮັດໂດຍບຸກຄົນທີສາມ.',
    my: 'တတိယအဖွဲ့အစည်းများက လုပ်ဆောင်သော မည်သည့် လုပ်ဆောင်ချက်မဆို။',
  },
  'disclaimer.reporting.note': {
    en: 'Users interact with third-party services at their own risk.',
    id: 'Pengguna berinteraksi dengan layanan pihak ketiga dengan risiko mereka sendiri.',
    ms: 'Pengguna berinteraksi dengan perkhidmatan pihak ketiga atas risiko mereka sendiri.',
    th: 'ผู้ใช้โต้ตอบกับบริการของบุคคลที่สามด้วยความเสี่ยงของตนเอง',
    vi: 'Người dùng tương tác với các dịch vụ của bên thứ ba tự chịu rủi ro.',
    fil: 'Nakikipag-ugnayan ang mga user sa mga serbisyo ng third-party sa kanilang sariling peligro.',
    km: 'អ្នកប្រើប្រាស់ធ្វើអន្តរកម្មជាមួយសេវាកម្មភាគីទីបីដោយហានិភ័យផ្ទាល់ខ្លួនរបស់ពួកគេ។',
    lo: 'ຜູ້ໃຊ້ພົວພັນກັບການບໍລິການຂອງບຸກຄົນທີສາມດ້ວຍຄວາມສ່ຽງຂອງຕົນເອງ.',
    my: 'အသုံးပြုသူများသည် တတိယအဖွဲ့အစည်း ဝန်ဆောင်မှုများနှင့် မိမိတို့၏ ကိုယ်ပိုင် အန္တရာယ်ဖြင့် ဆက်ဆံသည်။',
  },
  'disclaimer.accuracy.title': {
    en: '4. Accuracy of Information',
    id: '4. Keakuratan Informasi',
    ms: '4. Ketepatan Maklumat',
    th: '4. ความถูกต้องของข้อมูล',
    vi: '4. Tính chính xác của thông tin',
    fil: '4. Katumpakan ng Impormasyon',
    km: '៤. ភាពត្រឹមត្រូវនៃព័ត៌មាន',
    lo: '4. ຄວາມຖືກຕ້ອງຂອງຂໍ້ມູນ',
    my: '၄။ သတင်းအချက်အလက် တိကျမှု',
  },
  'disclaimer.accuracy.desc': {
    en: 'Scam tactics evolve rapidly. While we update our content regularly, genZAFE cannot guarantee that all information is completely current or error-free.',
    id: 'Taktik penipuan berkembang pesat. Meskipun kami memperbarui konten kami secara teratur, genZAFE tidak dapat menjamin bahwa semua informasi sepenuhnya terkini atau bebas kesalahan.',
    ms: 'Taktik penipuan berkembang pesat. Walaupun kami mengemas kini kandungan kami dengan kerap, genZAFE tidak dapat menjamin bahawa semua maklumat adalah terkini atau bebas ralat.',
    th: 'กลยุทธ์การหลอกลวงพัฒนาอย่างรวดเร็ว แม้ว่าเราจะอัปเดตเนื้อหาของเราเป็นประจำ genZAFE ไม่สามารถรับประกันได้ว่าข้อมูลทั้งหมดเป็นปัจจุบันหรือปราศจากข้อผิดพลาด',
    vi: 'Các chiến thuật lừa đảo phát triển nhanh chóng. Mặc dù chúng tôi cập nhật nội dung thường xuyên, genZAFE không thể đảm bảo rằng tất cả thông tin đều hoàn toàn cập nhật hoặc không có lỗi.',
    fil: 'Mabilis na nagbabago ang mga taktika ng scam. Habang regular naming ina-update ang aming nilalaman, hindi magagarantiya ng genZAFE na ang lahat ng impormasyon ay ganap na napapanahon o walang error.',
    km: 'យុទ្ធសាស្ត្របោកប្រាស់វិវត្តយ៉ាងឆាប់រហ័ស។ ខណៈពេលដែលយើងធ្វើបច្ចុប្បន្នភាពមាតិការបស់យើងជាទៀងទាត់ genZAFE មិនអាចធានាថាព័ត៌មានទាំងអស់គឺបច្ចុប្បន្នទាំងស្រុង ឬគ្មានកំហុសនោះទេ។',
    lo: 'ກົນລະຍຸດການຫຼອກລວງພັດທະນາຢ່າງໄວວາ. ເຖິງແມ່ນວ່າພວກເຮົາອັບເດດເນື້ອຫາຂອງພວກເຮົາເປັນປະຈຳ, genZAFE ບໍ່ສາມາດຮັບປະກັນວ່າຂໍ້ມູນທັງໝົດເປັນປັດຈຸບັນ ຫຼື ບໍ່ມີຂໍ້ຜິດພາດ.',
    my: 'လိမ်လည်မှု နည်းဗျူဟာများသည် လျင်မြန်စွာ ပြောင်းလဲနေသည်။ ကျွန်ုပ်တို့၏ အကြောင်းအရာများကို ပုံမှန် မွမ်းမံသော်လည်း၊ genZAFE သည် သတင်းအချက်အလက်အားလုံး လုံးဝ ခေတ်မီသည် သို့မဟုတ် အမှားကင်းသည်ဟု အာမမခံနိုင်ပါ။',
  },
  'disclaimer.accuracy.verify': {
    en: 'We encourage users to verify critical information with official government sources.',
    id: 'Kami mendorong pengguna untuk memverifikasi informasi penting dengan sumber pemerintah resmi.',
    ms: 'Kami menggalakkan pengguna untuk mengesahkan maklumat penting dengan sumber kerajaan rasmi.',
    th: 'เราสนับสนุนให้ผู้ใช้ตรวจสอบข้อมูลสำคัญกับแหล่งข้อมูลของรัฐบาลอย่างเป็นทางการ',
    vi: 'Chúng tôi khuyến khích người dùng xác minh thông tin quan trọng với các nguồn chính phủ chính thức.',
    fil: 'Hinihikayat namin ang mga user na i-verify ang kritikal na impormasyon sa mga opisyal na mapagkukunan ng gobyerno.',
    km: 'យើងលើកទឹកចិត្តអ្នកប្រើប្រាស់ឱ្យផ្ទៀងផ្ទាត់ព័ត៌មានសំខាន់ៗជាមួយប្រភពរដ្ឋាភិបាលផ្លូវការ។',
    lo: 'ພວກເຮົາຊຸກຍູ້ໃຫ້ຜູ້ໃຊ້ກວດສອບຂໍ້ມູນສຳຄັນກັບແຫຼ່ງຂໍ້ມູນຂອງລັດຖະບານທາງການ.',
    my: 'အသုံးပြုသူများအား အရေးကြီးသော အချက်အလက်များကို တရားဝင် အစိုးရ အရင်းအမြစ်များနှင့် စစ်ဆေးရန် ကျွန်ုပ်တို့ တိုက်တွန်းပါသည်။',
  },
  'disclaimer.liability.title': {
    en: '5. Limitation of Liability',
    id: '5. Batasan Tanggung Jawab',
    ms: '5. Had Liabiliti',
    th: '5. ข้อจำกัดความรับผิด',
    vi: '5. Giới hạn trách nhiệm',
    fil: '5. Limitasyon ng Pananagutan',
    km: '៥. កម្រិតនៃការទទួលខុសត្រូវ',
    lo: '5. ຂໍ້ຈຳກັດຄວາມຮັບຜິດຊອບ',
    my: '၅။ တာဝန်ယူမှု ကန့်သတ်ချက်',
  },
  'disclaimer.liability.desc': {
    en: 'By using this website, you agree that genZAFE and its contributors are not liable for any damages, losses, or issues arising from:',
    id: 'Dengan menggunakan situs web ini, Anda setuju bahwa genZAFE dan kontributornya tidak bertanggung jawab atas kerusakan, kerugian, atau masalah apa pun yang timbul dari:',
    ms: 'Dengan menggunakan laman web ini, anda bersetuju bahawa genZAFE dan penyumbangnya tidak bertanggungjawab ke atas sebarang kerosakan, kerugian, atau isu yang timbul daripada:',
    th: 'โดยการใช้เว็บไซต์นี้ คุณตกลงว่า genZAFE และผู้มีส่วนร่วมจะไม่รับผิดชอบต่อความเสียหาย การสูญเสีย หรือปัญหาใดๆ ที่เกิดขึ้นจาก:',
    vi: 'Bằng cách sử dụng trang web này, bạn đồng ý rằng genZAFE và những người đóng góp không chịu trách nhiệm về bất kỳ thiệt hại, mất mát hoặc vấn đề nào phát sinh từ:',
    fil: 'Sa pamamagitan ng paggamit ng website na ito, sumasang-ayon ka na ang genZAFE at ang mga contributor nito ay hindi mananagot para sa anumang pinsala, pagkalugi, o isyu na nagmumula sa:',
    km: 'ដោយប្រើគេហទំព័រនេះ អ្នកយល់ព្រមថា genZAFE និងអ្នកចូលរួមមិនទទួលខុសត្រូវចំពោះការខូចខាត ការខាតបង់ ឬបញ្ហាណាមួយដែលកើតឡើងពី៖',
    lo: 'ໂດຍການນຳໃຊ້ເວັບໄຊທ໌ນີ້, ທ່ານຕົກລົງວ່າ genZAFE ແລະ ຜູ້ປະກອບສ່ວນບໍ່ຮັບຜິດຊອບຕໍ່ຄວາມເສຍຫາຍ, ການສູນເສຍ, ຫຼື ບັນຫາໃດໆທີ່ເກີດຂຶ້ນຈາກ:',
    my: 'ဤဝက်ဘ်ဆိုက်ကို အသုံးပြုခြင်းဖြင့်၊ genZAFE နှင့် ၎င်း၏ ပါဝင်ကူညီသူများသည် အောက်ပါတို့မှ ဖြစ်ပေါ်လာသော ပျက်စီးမှုများ၊ ဆုံးရှုံးမှုများ သို့မဟုတ် ပြဿနာများအတွက် တာဝန်မရှိကြောင်း သင် သဘောတူသည် -',
  },
  'disclaimer.liability.use': {
    en: 'The use or inability to use our services.',
    id: 'Penggunaan atau ketidakmampuan untuk menggunakan layanan kami.',
    ms: 'Penggunaan atau ketidakupayaan untuk menggunakan perkhidmatan kami.',
    th: 'การใช้หรือการไม่สามารถใช้บริการของเรา',
    vi: 'Việc sử dụng hoặc không thể sử dụng dịch vụ của chúng tôi.',
    fil: 'Ang paggamit o kawalan ng kakayahang gamitin ang aming mga serbisyo.',
    km: 'ការប្រើប្រាស់ ឬអសមត្ថភាពក្នុងការប្រើប្រាស់សេវាកម្មរបស់យើង។',
    lo: 'ການນຳໃຊ້ ຫຼື ຄວາມບໍ່ສາມາດໃນການນຳໃຊ້ບໍລິການຂອງພວກເຮົາ.',
    my: 'ကျွန်ုပ်တို့၏ ဝန်ဆောင်မှုများကို အသုံးပြုခြင်း သို့မဟုတ် အသုံးမပြုနိုင်ခြင်း။',
  },
  'disclaimer.liability.delays': {
    en: 'Delays in reporting or recovering funds.',
    id: 'Keterlambatan dalam pelaporan atau pemulihan dana.',
    ms: 'Kelewatan dalam melaporkan atau mendapatkan semula dana.',
    th: 'ความล่าช้าในการรายงานหรือการกู้คืนเงิน',
    vi: 'Sự chậm trễ trong việc báo cáo hoặc thu hồi tiền.',
    fil: 'Mga pagkaantala sa pag-uulat o pagbawi ng pondo.',
    km: 'ការពន្យារពេលក្នុងការរាយការណ៍ ឬការយកប្រាក់មកវិញ។',
    lo: 'ຄວາມລ່າຊ້າໃນການລາຍງານ ຫຼື ການກູ້ຄືນເງິນ.',
    my: 'တိုင်ကြားခြင်း သို့မဟုတ် ငွေပြန်လည်ရယူခြင်းတွင် နှောင့်နှေးမှုများ။',
  },
  'disclaimer.liability.actions': {
    en: 'Actions taken based on information found on this site.',
    id: 'Tindakan yang diambil berdasarkan informasi yang ditemukan di situs ini.',
    ms: 'Tindakan yang diambil berdasarkan maklumat yang terdapat di laman web ini.',
    th: 'การดำเนินการตามข้อมูลที่พบบนเว็บไซต์นี้',
    vi: 'Các hành động được thực hiện dựa trên thông tin tìm thấy trên trang web này.',
    fil: 'Mga aksyong ginawa batay sa impormasyong matatagpuan sa site na ito.',
    km: 'សកម្មភាពដែលបានធ្វើឡើងដោយផ្អែកលើព័ត៌មានដែលមាននៅលើគេហទំព័រនេះ។',
    lo: 'ການດຳເນີນການທີ່ເຮັດໂດຍອີງໃສ່ຂໍ້ມູນທີ່ພົບໃນເວັບໄຊທ໌ນີ້.',
    my: 'ဤဆိုက်တွင် တွေ့ရှိရသော သတင်းအချက်အလက်များအပေါ် အခြေခံ၍ လုပ်ဆောင်သော လုပ်ဆောင်ချက်များ။',
  },
  'disclaimer.liability.inaccuracies': {
    en: 'Errors or inaccuracies in the content.',
    id: 'Kesalahan atau ketidakakuratan dalam konten.',
    ms: 'Ralat atau ketidaktepatan dalam kandungan.',
    th: 'ข้อผิดพลาดหรือความไม่ถูกต้องในเนื้อหา',
    vi: 'Lỗi hoặc sự không chính xác trong nội dung.',
    fil: 'Mga error o kamalian sa nilalaman.',
    km: 'កំហុស ឬភាពមិនត្រឹមត្រូវនៅក្នុងខ្លឹមសារ។',
    lo: 'ຂໍ້ຜິດພາດ ຫຼື ຄວາມບໍ່ຖືກຕ້ອງໃນເນື້ອຫາ.',
    my: 'အကြောင်းအရာတွင် အမှားများ သို့မဟုတ် မတိကျမှုများ။',
  },
  'disclaimer.liability.thirdParty': {
    en: 'Third-party links or services.',
    id: 'Tautan atau layanan pihak ketiga.',
    ms: 'Pautan atau perkhidmatan pihak ketiga.',
    th: 'ลิงก์หรือบริการของบุคคลที่สาม',
    vi: 'Các liên kết hoặc dịch vụ của bên thứ ba.',
    fil: 'Mga link o serbisyo ng third-party.',
    km: 'តំណភ្ជាប់ ឬសេវាកម្មភាគីទីបី។',
    lo: 'ລິ້ງ ຫຼື ບໍລິການຂອງບຸກຄົນທີສາມ.',
    my: 'တတိယအဖွဲ့အစည်း လင့်ခ်များ သို့မဟုတ် ဝန်ဆောင်မှုများ။',
  },
  'disclaimer.questions.title': {
    en: 'Questions?',
    id: 'Pertanyaan?',
    ms: 'Soalan?',
    th: 'คำถาม?',
    vi: 'Câu hỏi?',
    fil: 'Mga Tanong?',
    km: 'សំណួរ?',
    lo: 'ຄຳຖາມ?',
    my: 'မေးခွန်းများ?',
  },
  'disclaimer.questions.desc': {
    en: 'If you have questions about this disclaimer, please contact us through our official channels.',
    id: 'Jika Anda memiliki pertanyaan tentang penafian ini, silakan hubungi kami melalui saluran resmi kami.',
    ms: 'Jika anda mempunyai soalan mengenai penafian ini, sila hubungi kami melalui saluran rasmi kami.',
    th: 'หากคุณมีคำถามเกี่ยวกับข้อปฏิเสธความรับผิดนี้ โปรดติดต่อเราผ่านช่องทางอย่างเป็นทางการของเรา',
    vi: 'Nếu bạn có câu hỏi về tuyên bố từ chối trách nhiệm này, vui lòng liên hệ với chúng tôi qua các kênh chính thức.',
    fil: 'Kung mayroon kang mga katanungan tungkol sa pagtatanggi na ito, mangyaring makipag-ugnayan sa amin sa pamamagitan ng aming mga opisyal na channel.',
    km: 'ប្រសិនបើអ្នកមានសំណួរអំពីការបដិសេធនេះ សូមទាក់ទងមកយើងខ្ញុំតាមរយៈបណ្តាញផ្លូវការរបស់យើង។',
    lo: 'ຖ້າທ່ານມີຄຳຖາມກ່ຽວກັບການປະຕິເສດຄວາມຮັບຜິດຊອບນີ້, ກະລຸນາຕິດຕໍ່ພວກເຮົາຜ່ານຊ່ອງທາງທາງການຂອງພວກເຮົາ.',
    my: 'ဤငြင်းဆိုချက်နှင့် ပတ်သက်၍ မေးခွန်းများ ရှိပါက၊ ကျွန်ုပ်တို့၏ တရားဝင် လမ်းကြောင်းများမှတစ်ဆင့် ဆက်သွယ်ပါ။',
  },
  'disclaimer.lastUpdated': {
    en: 'Last Updated: January 2025',
    id: 'Terakhir Diperbarui: Januari 2025',
    ms: 'Terakhir Dikemaskini: Januari 2025',
    th: 'อัปเดตล่าสุด: มกราคม 2025',
    vi: 'Cập nhật lần cuối: Tháng 1 2025',
    fil: 'Huling Na-update: Enero 2025',
    km: 'ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ៖ ខែមករា ឆ្នាំ ២០២៥',
    lo: 'ອັບເດດຫຼ້າສຸດ: ມັງກອນ 2025',
    my: 'နောက်ဆုံး မွမ်းမံမှု - ဇန်နဝါရီ ၂၀၂၅',
  },

  // --- EVIDENCE PAGE ---
  'evidence.title': {
    en: 'Digital Evidence & Safety',
    id: 'Bukti Digital & Keamanan',
    ms: 'Bukti Digital & Keselamatan',
    th: 'หลักฐานดิจิทัลและความปลอดภัย',
    vi: 'Bằng chứng kỹ thuật số & An toàn',
    fil: 'Digital na Ebidensya at Kaligtasan',
    km: 'ភស្តុតាងឌីជីថល & សុវត្ថិភាព',
    lo: 'ຫຼັກຖານດິຈິຕອນ & ຄວາມປອດໄພ',
    my: 'ဒစ်ဂျစ်တယ် သက်သေအထောက်အထားနှင့် ဘေးကင်းရေး',
  },
  'evidence.subtitle': {
    en: 'How to collect and preserve evidence for reporting scams.',
    id: 'Cara mengumpulkan dan menyimpan bukti untuk melaporkan penipuan.',
    ms: 'Cara mengumpul dan memelihara bukti untuk melaporkan penipuan.',
    th: 'วิธีรวบรวมและรักษาหลักฐานเพื่อรายงานการหลอกลวง',
    vi: 'Cách thu thập và bảo quản bằng chứng để báo cáo lừa đảo.',
    fil: 'Paano mangolekta at mag-ingat ng ebidensya para sa pag-uulat ng mga scam.',
    km: 'របៀបប្រមូលនិងរក្សាទុកភស្តុតាងសម្រាប់ការរាយការណ៍ការបោកប្រាស់។',
    lo: 'ວິທີເກັບກຳ ແລະ ຮັກສາຫຼັກຖານເພື່ອລາຍງານການຫຼອກລວງ.',
    my: 'လိမ်လည်မှုများကို တိုင်ကြားရန် သက်သေအထောက်အထား စုဆောင်းပြီး ထိန်းသိမ်းနည်း။',
  },
  'evidence.warning': {
    en: 'Do not edit or modify screenshots. Metadata is crucial for investigations.',
    id: 'Jangan edit atau ubah tangkapan layar. Metadata sangat penting untuk penyelidikan.',
    ms: 'Jangan sunting atau ubah suai tangkapan skrin. Metadata adalah penting untuk siasatan.',
    th: 'อย่าแก้ไขหรือดัดแปลงภาพหน้าจอ ข้อมูลเมตามีความสำคัญต่อการสอบสวน',
    vi: 'Không chỉnh sửa hoặc sửa đổi ảnh chụp màn hình. Siêu dữ liệu rất quan trọng cho các cuộc điều tra.',
    fil: 'Huwag i-edit o baguhin ang mga screenshot. Mahalaga ang metadata para sa mga imbestigasyon.',
    km: 'កុំកែសម្រួល ឬកែប្រែរូបថតអេក្រង់។ ទិន្នន័យមេតាមានសារៈសំខាន់សម្រាប់ការស៊ើបអង្កេត។',
    lo: 'ຢ່າແກ້ໄຂ ຫຼື ດັດແປງຮູບພາບໜ້າຈໍ. ຂໍ້ມູນເມຕາສຳຄັນສຳລັບການສືບສວນ.',
    my: 'စခရင်ရှော့များကို မပြုပြင်ပါနှင့်။ မေတာဒေတာသည် စုံစမ်းစစ်ဆေးမှုများအတွက် အရေးကြီးသည်။',
  },
  'evidence.screenshots.title': {
    en: 'Screenshots',
    id: 'Tangkapan Layar',
    ms: 'Tangkapan Skrin',
    th: 'ภาพหน้าจอ',
    vi: 'Ảnh chụp màn hình',
    fil: 'Mga Screenshot',
    km: 'រូបថតអេក្រង់',
    lo: 'ຮູບພາບໜ້າຈໍ',
    my: 'စခရင်ရှော့များ',
  },
  'evidence.screenshots.step1': {
    en: 'Capture the entire conversation, not just parts.',
    id: 'Tangkap seluruh percakapan, bukan hanya sebagian.',
    ms: 'Tangkap keseluruhan perbualan, bukan hanya sebahagian.',
    th: 'จับภาพการสนทนาทั้งหมด ไม่ใช่แค่บางส่วน',
    vi: 'Chụp toàn bộ cuộc trò chuyện, không chỉ một phần.',
    fil: 'Kunin ang buong pag-uusap, hindi lang mga bahagi.',
    km: 'ចាប់យកការសន្ទនាទាំងមូល មិនមែនគ្រាន់តែផ្នែកខ្លះទេ។',
    lo: 'ຖ່າຍຮູບການສົນທະນາທັງໝົດ, ບໍ່ແມ່ນພຽງແຕ່ບາງສ່ວນ.',
    my: 'စကားပြောဆိုမှု တစ်ခုလုံးကို ရိုက်ယူပါ၊ အစိတ်အပိုင်းများကိုသာ မဟုတ်ပါ။',
  },
  'evidence.screenshots.step2': {
    en: "Include the sender's profile and contact details.",
    id: 'Sertakan profil pengirim dan detail kontak.',
    ms: 'Sertakan profil penghantar dan butiran hubungan.',
    th: 'รวมโปรไฟล์ผู้ส่งและรายละเอียดการติดต่อ',
    vi: 'Bao gồm hồ sơ người gửi và chi tiết liên lạc.',
    fil: 'Isama ang profile ng nagpadala at mga detalye ng contact.',
    km: 'រួមបញ្ចូលប្រវត្តិរូបរបស់អ្នកផ្ញើ និងព័ត៌មានលម្អិតទំនាក់ទំនង។',
    lo: 'ລວມເອົາໂປຣໄຟລ໌ຜູ້ສົ່ງ ແລະ ລາຍລະອຽດການຕິດຕໍ່.',
    my: 'ပေးပို့သူ၏ ပရိုဖိုင်နှင့် ဆက်သွယ်ရန် အသေးစိတ်များကို ထည့်သွင်းပါ။',
  },
  'evidence.screenshots.step3': {
    en: 'Ensure dates and times are visible.',
    id: 'Pastikan tanggal dan waktu terlihat.',
    ms: 'Pastikan tarikh dan masa kelihatan.',
    th: 'ตรวจสอบให้แน่ใจว่าวันที่และเวลามองเห็นได้',
    vi: 'Đảm bảo ngày và giờ hiển thị rõ ràng.',
    fil: 'Tiyaking nakikita ang mga petsa at oras.',
    km: 'ធានាថាកាលបរិច្ឆេទ និងពេលវេលាអាចមើលឃើញ។',
    lo: 'ຮັບປະກັນວັນທີ ແລະ ເວລາເຫັນໄດ້ຊັດເຈນ.',
    my: 'ရက်စွဲများနှင့် အချိန်များကို မြင်ရကြောင်း သေချာပါစေ။',
  },
  'evidence.screenshots.step4': {
    en: 'Do not crop or edit the images.',
    id: 'Jangan potong atau edit gambar.',
    ms: 'Jangan potong atau sunting imej.',
    th: 'อย่าตัดหรือแก้ไขรูปภาพ',
    vi: 'Không cắt hoặc chỉnh sửa hình ảnh.',
    fil: 'Huwag i-crop o i-edit ang mga larawan.',
    km: 'កុំកាត់ ឬកែសម្រួលរូបភាព។',
    lo: 'ຢ່າຕັດ ຫຼື ແກ້ໄຂຮູບພາບ.',
    my: 'ပုံများကို ဖြတ်တောက်ခြင်း သို့မဟုတ် ပြုပြင်ခြင်း မပြုပါနှင့်။',
  },
  'evidence.email.title': {
    en: 'Emails',
    id: 'Email',
    ms: 'E-mel',
    th: 'อีเมล',
    vi: 'Email',
    fil: 'Mga Email',
    km: 'អ៊ីមែល',
    lo: 'ອີເມວ',
    my: 'အီးမေးလ်များ',
  },
  'evidence.email.step1': {
    en: 'Save the email as a file (e.g., .eml or .msg).',
    id: 'Simpan email sebagai file (mis., .eml atau .msg).',
    ms: 'Simpan e-mel sebagai fail (cth., .eml atau .msg).',
    th: 'บันทึกอีเมลเป็นไฟล์ (เช่น .eml หรือ .msg)',
    vi: 'Lưu email dưới dạng tệp (ví dụ: .eml hoặc .msg).',
    fil: 'I-save ang email bilang isang file (hal., .eml o .msg).',
    km: 'រក្សាទុកអ៊ីមែលជាឯកសារ (ឧទាហរណ៍ .eml ឬ .msg)។',
    lo: 'ບັນທຶກອີເມວເປັນໄຟລ໌ (ເຊັ່ນ: .eml ຫຼື .msg).',
    my: 'အီးမေးလ်ကို ဖိုင်အဖြစ် သိမ်းဆည်းပါ (ဥပမာ .eml သို့မဟုတ် .msg)။',
  },
  'evidence.email.step2': {
    en: 'Include full email headers.',
    id: 'Sertakan header email lengkap.',
    ms: 'Sertakan header e-mel penuh.',
    th: 'รวมส่วนหัวของอีเมลทั้งหมด',
    vi: 'Bao gồm tiêu đề email đầy đủ.',
    fil: 'Isama ang buong mga header ng email.',
    km: 'រួមបញ្ចូលបឋមកថាអ៊ីមែលពេញលេញ។',
    lo: 'ລວມເອົາຫົວຂໍ້ອີເມວເຕັມ.',
    my: 'အီးမေးလ် ခေါင်းစီး အပြည့်အစုံကို ထည့်သွင်းပါ။',
  },
  'evidence.email.step3': {
    en: 'Take screenshots of the email content.',
    id: 'Ambil tangkapan layar konten email.',
    ms: 'Ambil tangkapan skrin kandungan e-mel.',
    th: 'แคปหน้าจอเนื้อหาอีเมล',
    vi: 'Chụp ảnh màn hình nội dung email.',
    fil: 'Kumuha ng mga screenshot ng nilalaman ng email.',
    km: 'ថតអេក្រង់នៃខ្លឹមសារអ៊ីមែល។',
    lo: 'ຖ່າຍຮູບໜ້າຈໍເນື້ອຫາອີເມວ.',
    my: 'အီးမေးလ် အကြောင်းအရာကို စခရင်ရှော့ရိုက်ပါ။',
  },
  'evidence.email.step4': {
    en: 'Do not reply or click links.',
    id: 'Jangan balas atau klik tautan.',
    ms: 'Jangan balas atau klik pautan.',
    th: 'อย่าตอบกลับหรือคลิกลิงก์',
    vi: 'Không trả lời hoặc nhấp vào liên kết.',
    fil: 'Huwag sumagot o mag-click ng mga link.',
    km: 'កុំឆ្លើយតប ឬចុចតំណភ្ជាប់។',
    lo: 'ຢ່າຕອບກັບ ຫຼື ຄິກລິ້ງ.',
    my: 'ပြန်မဖြေပါနှင့် သို့မဟုတ် လင့်ခ်များကို မနှိပ်ပါနှင့်။',
  },
  'evidence.transaction.title': {
    en: 'Transactions',
    id: 'Transaksi',
    ms: 'Transaksi',
    th: 'ธุรกรรม',
    vi: 'Giao dịch',
    fil: 'Mga Transaksyon',
    km: 'ប្រតិបត្តិការ',
    lo: 'ທຸລະກຳ',
    my: 'ငွေလွှဲမှုများ',
  },
  'evidence.transaction.step1': {
    en: 'Save transaction receipts or confirmations.',
    id: 'Simpan tanda terima atau konfirmasi transaksi.',
    ms: 'Simpan resit atau pengesahan transaksi.',
    th: 'บันทึกใบเสร็จรับเงินหรือการยืนยันธุรกรรม',
    vi: 'Lưu biên lai hoặc xác nhận giao dịch.',
    fil: 'I-save ang mga resibo o kumpirmasyon ng transaksyon.',
    km: 'រក្សាទុកបង្កាន់ដៃប្រតិបត្តិការ ឬការបញ្ជាក់។',
    lo: 'ບັນທຶກໃບຮັບເງິນ ຫຼື ການຢັ້ງຢືນທຸລະກຳ.',
    my: 'ငွေလွှဲပြေစာများ သို့မဟုတ် အတည်ပြုချက်များကို သိမ်းဆည်းပါ။',
  },
  'evidence.transaction.step2': {
    en: 'Note down transaction IDs.',
    id: 'Catat ID transaksi.',
    ms: 'Catat ID transaksi.',
    th: 'จดบันทึกรหัสธุรกรรม',
    vi: 'Ghi lại ID giao dịch.',
    fil: 'Isulat ang mga transaction ID.',
    km: 'កត់ត្រាលេខសម្គាល់ប្រតិបត្តិការ។',
    lo: 'ບັນທຶກ ID ທຸລະກຳ.',
    my: 'ငွေလွှဲ ID များကို မှတ်သားထားပါ။',
  },
  'evidence.transaction.step3': {
    en: 'Take screenshots of banking apps or crypto wallets.',
    id: 'Ambil tangkapan layar aplikasi perbankan atau dompet kripto.',
    ms: 'Ambil tangkapan skrin aplikasi perbankan atau dompet kripto.',
    th: 'แคปหน้าจอแอปธนาคารหรือกระเป๋าเงินคริปโต',
    vi: 'Chụp ảnh màn hình ứng dụng ngân hàng hoặc ví tiền mã hóa.',
    fil: 'Kumuha ng mga screenshot ng mga banking app o crypto wallet.',
    km: 'ថតអេក្រង់នៃកម្មវិធីធនាគារ ឬកាបូបគ្រីបតូ។',
    lo: 'ຖ່າຍຮູບໜ້າຈໍແອັບທະນາຄານ ຫຼື ກະເປົາເງິນຄຣິບໂຕ.',
    my: 'ဘဏ်အက်ပ်များ သို့မဟုတ် ကရစ်ပတို ပိုက်ဆံအိတ်များကို စခရင်ရှော့ရိုက်ပါ။',
  },
  'evidence.transaction.step4': {
    en: 'Keep bank statements showing the transfer.',
    id: 'Simpan rekening koran yang menunjukkan transfer.',
    ms: 'Simpan penyata bank yang menunjukkan pemindahan.',
    th: 'เก็บรายการเดินบัญชีธนาคารที่แสดงการโอนเงิน',
    vi: 'Giữ sao kê ngân hàng hiển thị giao dịch chuyển tiền.',
    fil: 'Itago ang mga bank statement na nagpapakita ng paglilipat.',
    km: 'រក្សារបាយការណ៍ធនាគារដែលបង្ហាញពីការផ្ទេរ។',
    lo: 'ເກັບຮັກສາລາຍການເດີນບັນຊີທະນາຄານທີ່ສະແດງການໂອນເງິນ.',
    my: 'ငွေလွှဲပြောင်းမှုကို ပြသသော ဘဏ်ရှင်းတမ်းများကို သိမ်းဆည်းထားပါ။',
  },
  'evidence.conversations.title': {
    en: 'Conversations',
    id: 'Percakapan',
    ms: 'Perbualan',
    th: 'การสนทนา',
    vi: 'Cuộc trò chuyện',
    fil: 'Mga Pag-uusap',
    km: 'ការសន្ទនា',
    lo: 'ການສົນທະນາ',
    my: 'စကားပြောဆိုမှုများ',
  },
  'evidence.conversations.step1': {
    en: 'Export chat logs if possible (e.g., WhatsApp).',
    id: 'Ekspor log obrolan jika memungkinkan (mis., WhatsApp).',
    ms: 'Eksport log sembang jika boleh (cth., WhatsApp).',
    th: 'ส่งออกบันทึกการแชทหากเป็นไปได้ (เช่น WhatsApp)',
    vi: 'Xuất nhật ký trò chuyện nếu có thể (ví dụ: WhatsApp).',
    fil: 'I-export ang mga chat log kung posible (hal., WhatsApp).',
    km: 'នាំចេញកំណត់ហេតុជជែកប្រសិនបើអាច (ឧទាហរណ៍ WhatsApp)។',
    lo: 'ສົ່ງອອກບັນທຶກການສົນທະນາຖ້າເປັນໄປໄດ້ (ເຊັ່ນ: WhatsApp).',
    my: 'ဖြစ်နိုင်လျှင် ချက်တင်မှတ်တမ်းများကို ထုတ်ယူပါ (ဥပမာ WhatsApp)။',
  },
  'evidence.conversations.step2': {
    en: 'Screenshot call logs showing numbers and duration.',
    id: 'Tangkapan layar log panggilan yang menunjukkan nomor dan durasi.',
    ms: 'Tangkapan skrin log panggilan menunjukkan nombor dan tempoh.',
    th: 'แคปหน้าจอบันทึกการโทรที่แสดงหมายเลขและระยะเวลา',
    vi: 'Chụp ảnh màn hình nhật ký cuộc gọi hiển thị số và thời lượng.',
    fil: 'I-screenshot ang mga log ng tawag na nagpapakita ng mga numero at tagal.',
    km: 'ថតអេក្រង់កំណត់ហេតុការហៅដែលបង្ហាញលេខ និងរយៈពេល។',
    lo: 'ຖ່າຍຮູບໜ້າຈໍບັນທຶກການໂທທີ່ສະແດງເບີ ແລະ ໄລຍະເວລາ.',
    my: 'နံပါတ်များနှင့် ကြာချိန်ကို ပြသသော ခေါ်ဆိုမှုမှတ်တမ်းများကို စခရင်ရှော့ရိုက်ပါ။',
  },
  'evidence.conversations.step3': {
    en: 'Save voice notes or recordings.',
    id: 'Simpan pesan suara atau rekaman.',
    ms: 'Simpan nota suara atau rakaman.',
    th: 'บันทึกข้อความเสียงหรือการบันทึก',
    vi: 'Lưu ghi chú giọng nói hoặc bản ghi âm.',
    fil: 'I-save ang mga voice note o recording.',
    km: 'រក្សាទុកកំណត់ចំណាំសំឡេង ឬការថតសំឡេង។',
    lo: 'ບັນທຶກຂໍ້ຄວາມສຽງ ຫຼື ການບັນທຶກ.',
    my: 'အသံမက်ဆေ့ခ်ျများ သို့မဟုတ် အသံဖမ်းယူမှုများကို သိမ်းဆည်းပါ။',
  },
  'evidence.conversations.step4': {
    en: 'Note down dates and times of calls.',
    id: 'Catat tanggal dan waktu panggilan.',
    ms: 'Catat tarikh dan masa panggilan.',
    th: 'จดบันทึกวันที่และเวลาของการโทร',
    vi: 'Ghi lại ngày và giờ của các cuộc gọi.',
    fil: 'Isulat ang mga petsa at oras ng mga tawag.',
    km: 'កត់ត្រាកាលបរិច្ឆេទ និងពេលវេលានៃការហៅទូរសព្ទ។',
    lo: 'ບັນທຶກວັນທີ ແລະ ເວລາຂອງການໂທ.',
    my: 'ခေါ်ဆိုမှု ရက်စွဲများနှင့် အချိန်များကို မှတ်သားထားပါ။',
  },
  'evidence.anonymization.title': {
    en: 'Data Safety Tips',
    id: 'Tips Keamanan Data',
    ms: 'Tips Keselamatan Data',
    th: 'เคล็ดลับความปลอดภัยของข้อมูล',
    vi: 'Mẹo an toàn dữ liệu',
    fil: 'Mga Tip sa Kaligtasan ng Data',
    km: 'គន្លឹះសុវត្ថិភាពទិន្នន័យ',
    lo: 'ເຄັດລັບຄວາມປອດໄພຂອງຂໍ້ມູນ',
    my: 'ဒေတာ ဘေးကင်းရေး အကြံပြုချက်များ',
  },
  'evidence.anonymization.tip1': {
    en: 'Store evidence in a secure, password-protected folder.',
    id: 'Simpan bukti dalam folder aman yang dilindungi kata sandi.',
    ms: 'Simpan bukti dalam folder selamat yang dilindungi kata laluan.',
    th: 'เก็บหลักฐานในโฟลเดอร์ที่ปลอดภัยและมีการป้องกันด้วยรหัสผ่าน',
    vi: 'Lưu trữ bằng chứng trong thư mục an toàn, được bảo vệ bằng mật khẩu.',
    fil: 'Iimbak ang ebidensya sa isang secure, password-protected na folder.',
    km: 'រក្សាទុកភស្តុតាងនៅក្នុងថតដែលមានសុវត្ថិភាព និងការពារដោយពាក្យសម្ងាត់។',
    lo: 'ເກັບຮັກສາຫຼັກຖານໃນໂຟນເດີທີ່ປອດໄພ, ປ້ອງກັນດ້ວຍລະຫັດຜ່ານ.',
    my: 'သက်သေအထောက်အထားများကို လုံခြုံသော၊ စကားဝှက်ဖြင့် ကာကွယ်ထားသော ဖိုင်တွဲတစ်ခုတွင် သိမ်းဆည်းပါ။',
  },
  'evidence.anonymization.tip2': {
    en: 'Make copies of all evidence.',
    id: 'Buat salinan semua bukti.',
    ms: 'Buat salinan semua bukti.',
    th: 'ทำสำเนาหลักฐานทั้งหมด',
    vi: 'Sao chép tất cả bằng chứng.',
    fil: 'Gumawa ng mga kopya ng lahat ng ebidensya.',
    km: 'ថតចម្លងភស្តុតាងទាំងអស់។',
    lo: 'ເຮັດສຳເນົາຫຼັກຖານທັງໝົດ.',
    my: 'သက်သေအထောက်အထားအားလုံးကို မိတ္တူကူးထားပါ။',
  },
  'evidence.anonymization.tip3': {
    en: 'Do not share evidence on social media.',
    id: 'Jangan bagikan bukti di media sosial.',
    ms: 'Jangan kongsi bukti di media sosial.',
    th: 'อย่าแชร์หลักฐานบนโซเชียลมีเดีย',
    vi: 'Không chia sẻ bằng chứng trên mạng xã hội.',
    fil: 'Huwag ibahagi ang ebidensya sa social media.',
    km: 'កុំចែករំលែកភស្តុតាងនៅលើបណ្តាញសង្គម។',
    lo: 'ຢ່າແບ່ງປັນຫຼັກຖານໃນສື່ສັງຄົມ.',
    my: 'သက်သေအထောက်အထားများကို ဆိုရှယ်မီဒီယာတွင် မမျှဝေပါနှင့်။',
  },
  'evidence.anonymization.tip4': {
    en: 'Only share with official authorities.',
    id: 'Hanya bagikan dengan otoritas resmi.',
    ms: 'Hanya kongsi dengan pihak berkuasa rasmi.',
    th: 'แชร์กับเจ้าหน้าที่อย่างเป็นทางการเท่านั้น',
    vi: 'Chỉ chia sẻ với các cơ quan chính thức.',
    fil: 'Ibahagi lamang sa mga opisyal na awtoridad.',
    km: 'ចែករំលែកតែជាមួយអាជ្ញាធរផ្លូវការប៉ុណ្ណោះ។',
    lo: 'ແບ່ງປັນກັບເຈົ້າໜ້າທີ່ທາງການເທົ່ານັ້ນ.',
    my: 'တရားဝင် အာဏာပိုင်များနှင့်သာ မျှဝေပါ။',
  },

  // --- FRAMEWORK PAGE ---
  'framework.title': {
    en: 'International Frameworks',
    id: 'Kerangka Internasional',
    ms: 'Rangka Kerja Antarabangsa',
    th: 'กรอบการทำงานระหว่างประเทศ',
    vi: 'Khung quốc tế',
    fil: 'Mga Internasyonal na Balangkas',
    km: 'ក្របខ័ណ្ឌអន្តរជាតិ',
    lo: 'ກອບການເຮັດວຽກສາກົນ',
    my: 'နိုင်ငံတကာ မူဘောင်များ',
  },
  'framework.subtitle': {
    en: 'Understanding the global and regional cooperation against cybercrime.',
    id: 'Memahami kerja sama global dan regional melawan kejahatan dunia maya.',
    ms: 'Memahami kerjasama global dan serantau menentang jenayah siber.',
    th: 'ทำความเข้าใจความร่วมมือระดับโลกและระดับภูมิภาคในการต่อต้านอาชญากรรมไซเบอร์',
    vi: 'Hiểu về hợp tác toàn cầu và khu vực chống lại tội phạm mạng.',
    fil: 'Pag-unawa sa global at rehiyonal na kooperasyon laban sa cybercrime.',
    km: 'ការយល់ដឹងអំពីកិច្ចសហប្រតិបត្តិការសកល និងតំបន់ប្រឆាំងនឹងឧក្រិដ្ឋកម្មតាមអ៊ីនធឺណិត។',
    lo: 'ເຂົ້າໃຈການຮ່ວມມືທົ່ວໂລກ ແລະ ພາກພື້ນຕໍ່ຕ້ານອາຊະຍາກຳທາງໄຊເບີ.',
    my: 'ဆိုက်ဘာရာဇဝတ်မှု တိုက်ဖျက်ရေးတွင် ကမ္ဘာလုံးဆိုင်ရာနှင့် ဒေသတွင်း ပူးပေါင်းဆောင်ရွက်မှုကို နားလည်ခြင်း။',
  },
  'framework.principles.title': {
    en: 'Core Principles',
    id: 'Prinsip Inti',
    ms: 'Prinsip Teras',
    th: 'หลักการสำคัญ',
    vi: 'Nguyên tắc cốt lõi',
    fil: 'Mga Pangunahing Prinsipyo',
    km: 'គោលការណ៍ស្នូល',
    lo: 'ຫຼັກການຫຼັກ',
    my: 'အဓိက မူဝါဒများ',
  },
  'framework.principle.victim.title': {
    en: 'Victim Protection',
    id: 'Perlindungan Korban',
    ms: 'Perlindungan Mangsa',
    th: 'การคุ้มครองเหยื่อ',
    vi: 'Bảo vệ nạn nhân',
    fil: 'Proteksyon ng Biktima',
    km: 'ការការពារជនរងគ្រោះ',
    lo: 'ການປົກປ້ອງຜູ້ຖືກເຄາະຮ້າຍ',
    my: 'သားကောင် ကာကွယ်ရေး',
  },
  'framework.principle.victim.desc': {
    en: 'Ensuring victims are treated with dignity and supported.',
    id: 'Memastikan korban diperlakukan dengan bermartabat dan didukung.',
    ms: 'Memastikan mangsa dilayan dengan bermaruah dan disokong.',
    th: 'สร้างความมั่นใจว่าเหยื่อได้รับการปฏิบัติอย่างมีศักดิ์ศรีและได้รับการสนับสนุน',
    vi: 'Đảm bảo nạn nhân được đối xử tôn trọng và được hỗ trợ.',
    fil: 'Pagtitiyak na ang mga biktima ay tinatrato nang may dignidad at sinusuportahan.',
    km: 'ធានាថាជនរងគ្រោះត្រូវបានប្រព្រឹត្តដោយសេចក្តីថ្លៃថ្នូរ និងគាំទ្រ។',
    lo: 'ຮັບປະກັນວ່າຜູ້ຖືກເຄາະຮ້າຍໄດ້ຮັບການປະຕິບັດດ້ວຍກຽດສັກສີ ແລະ ໄດ້ຮັບການສະໜັບສະໜູນ.',
    my: 'သားကောင်များကို ဂုဏ်သိက္ခာရှိစွာ ဆက်ဆံပြီး ပံ့ပိုးကူညီမှု ရရှိစေရန် သေချာစေခြင်း။',
  },
  'framework.principle.cooperation.title': {
    en: 'International Cooperation',
    id: 'Kerja Sama Internasional',
    ms: 'Kerjasama Antarabangsa',
    th: 'ความร่วมมือระหว่างประเทศ',
    vi: 'Hợp tác quốc tế',
    fil: 'Internasyonal na Kooperasyon',
    km: 'កិច្ចសហប្រតិបត្តិការអន្តរជាតិ',
    lo: 'ການຮ່ວມມືສາກົນ',
    my: 'နိုင်ငံတကာ ပူးပေါင်းဆောင်ရွက်မှု',
  },
  'framework.principle.cooperation.desc': {
    en: 'Sharing intelligence across borders to catch criminals.',
    id: 'Berbagi intelijen lintas batas untuk menangkap penjahat.',
    ms: 'Berkongsi risikan merentasi sempadan untuk menangkap penjenayah.',
    th: 'การแบ่งปันข้อมูลข่าวกรองข้ามพรมแดนเพื่อจับกุมอาชญากร',
    vi: 'Chia sẻ thông tin tình báo xuyên biên giới để bắt tội phạm.',
    fil: 'Pagbabahagi ng intelligence sa mga hangganan upang mahuli ang mga kriminal.',
    km: 'ការចែករំលែកការស៊ើបអង្កេតឆ្លងដែនដើម្បីចាប់ឧក្រិដ្ឋជន។',
    lo: 'ແບ່ງປັນຂ່າວລັບຂ້າມຊາຍແດນເພື່ອຈັບກຸມອາຊະຍາກອນ.',
    my: 'ရာဇဝတ်ကောင်များကို ဖမ်းဆီးရန် နယ်စပ်ဖြတ်ကျော် သတင်းအချက်အလက် မျှဝေခြင်း။',
  },
  'framework.principle.prevention.title': {
    en: 'Prevention',
    id: 'Pencegahan',
    ms: 'Pencegahan',
    th: 'การป้องกัน',
    vi: 'Phòng ngừa',
    fil: 'Pag-iwas',
    km: 'ការបង្ការ',
    lo: 'ການປ້ອງກັນ',
    my: 'ကာကွယ်ခြင်း',
  },
  'framework.principle.prevention.desc': {
    en: 'Educating the public to reduce victimization.',
    id: 'Mendidik masyarakat untuk mengurangi viktimisasi.',
    ms: 'Mendidik orang ramai untuk mengurangkan pemangsaan.',
    th: 'ให้ความรู้แก่ประชาชนเพื่อลดการตกเป็นเหยื่อ',
    vi: 'Giáo dục công chúng để giảm thiểu nạn nhân.',
    fil: 'Pagtuturo sa publiko upang mabawasan ang pagiging biktima.',
    km: 'អប់រំសាធារណជនដើម្បីកាត់បន្ថយការក្លាយជាជនរងគ្រោះ។',
    lo: 'ໃຫ້ຄວາມຮູ້ແກ່ປະຊາຊົນເພື່ອຫຼຸດຜ່ອນການຕົກເປັນເຫຍື່ອ.',
    my: 'သားကောင်ဖြစ်မှုကို လျှော့ချရန် ပြည်သူများကို ပညာပေးခြင်း။',
  },
  'framework.principle.legal.title': {
    en: 'Legal Harmonization',
    id: 'Harmonisasi Hukum',
    ms: 'Harmonisasi Undang-undang',
    th: 'ความสอดคล้องทางกฎหมาย',
    vi: 'Hài hòa pháp luật',
    fil: 'Legal na Harmonization',
    km: 'ការចុះសម្រុងគ្នាផ្នែកច្បាប់',
    lo: 'ຄວາມສອດຄ່ອງທາງກົດໝາຍ',
    my: 'ဥပဒေရေးရာ ညီညွတ်မှု',
  },
  'framework.principle.legal.desc': {
    en: 'Aligning laws to ensure criminals cannot hide.',
    id: 'Menyelaraskan hukum untuk memastikan penjahat tidak bisa bersembunyi.',
    ms: 'Menyelaraskan undang-undang untuk memastikan penjenayah tidak boleh bersembunyi.',
    th: 'ปรับกฎหมายให้สอดคล้องกันเพื่อให้แน่ใจว่าอาชญากรไม่สามารถซ่อนตัวได้',
    vi: 'Điều chỉnh luật pháp để đảm bảo tội phạm không thể ẩn náu.',
    fil: 'Pag-align ng mga batas upang matiyak na hindi makapagtago ang mga kriminal.',
    km: 'តម្រឹមច្បាប់ដើម្បីធានាថាឧក្រិដ្ឋជនមិនអាចលាក់ខ្លួនបាន។',
    lo: 'ປັບກົດໝາຍໃຫ້ສອດຄ່ອງເພື່ອຮັບປະກັນວ່າອາຊະຍາກອນບໍ່ສາມາດລີ້ຊ່ອນໄດ້.',
    my: 'ရာဇဝတ်ကောင်များ ပုန်းအောင်းမနေနိုင်စေရန် ဥပဒေများကို ညှိနှိုင်းခြင်း။',
  },

  // --- GENERATOR PAGE ---
  'generator.title': {
    en: 'Report Template Generator',
    id: 'Generator Templat Laporan',
    ms: 'Penjana Templat Laporan',
    th: 'เครื่องมือสร้างเทมเพลตรายงาน',
    vi: 'Trình tạo mẫu báo cáo',
    fil: 'Generator ng Template ng Ulat',
    km: 'ម៉ាស៊ីនបង្កើតគំរូរបាយការណ៍',
    lo: 'ເຄື່ອງມືສ້າງແບບຟອມລາຍງານ',
    my: 'တိုင်ကြားစာ ပုံစံခွက် ထုတ်လုပ်စက်',
  },
  'generator.subtitle': {
    en: 'Create a professional report to submit to banks or police.',
    id: 'Buat laporan profesional untuk diserahkan ke bank atau polisi.',
    ms: 'Hasilkan laporan profesional untuk diserahkan kepada bank atau polis.',
    th: 'สร้างรายงานอย่างมืออาชีพเพื่อส่งไปยังธนาคารหรือตำรวจ',
    vi: 'Tạo báo cáo chuyên nghiệp để gửi cho ngân hàng hoặc cảnh sát.',
    fil: 'Gumawa ng propesyonal na ulat upang isumite sa mga bangko o pulisya.',
    km: 'បង្កើតរបាយការណ៍អាជីពដើម្បីផ្ញើទៅធនាគារ ឬប៉ូលីស។',
    lo: 'ສ້າງລາຍງານແບບມືອາຊີບເພື່ອສົ່ງໃຫ້ທະນາຄານ ຫຼື ຕຳຫຼວດ.',
    my: 'ဘဏ်များ သို့မဟုတ် ရဲတပ်ဖွဲ့ထံ တင်သွင်းရန် ပရော်ဖက်ရှင်နယ် တိုင်ကြားစာ ထုတ်လုပ်ပါ။',
  },
  'generator.form.title': {
    en: 'Incident Details',
    id: 'Detail Insiden',
    ms: 'Butiran Insiden',
    th: 'รายละเอียดเหตุการณ์',
    vi: 'Chi tiết sự cố',
    fil: 'Mga Detalye ng Insidente',
    km: 'ព័ត៌មានលម្អិតអំពីហេតុការណ៍',
    lo: 'ລາຍລະອຽດເຫດການ',
    my: 'ဖြစ်စဉ် အသေးစိတ်များ',
  },
  'generator.form.scamType': {
    en: 'Scam Type',
    id: 'Jenis Penipuan',
    ms: 'Jenis Penipuan',
    th: 'ประเภทการหลอกลวง',
    vi: 'Loại lừa đảo',
    fil: 'Uri ng Scam',
    km: 'ប្រភេទការបោកប្រាស់',
    lo: 'ປະເພດການຫຼອກລວງ',
    my: 'လိမ်လည်မှု အမျိုးအစား',
  },
  'generator.form.date': {
    en: 'Date of Incident',
    id: 'Tanggal Kejadian',
    ms: 'Tarikh Kejadian',
    th: 'วันที่เกิดเหตุ',
    vi: 'Ngày xảy ra sự cố',
    fil: 'Petsa ng Insidente',
    km: 'កាលបរិច្ឆេទនៃហេតុការណ៍',
    lo: 'ວັນທີເກີດເຫດ',
    my: 'ဖြစ်စဉ် ရက်စွဲ',
  },
  'generator.form.platform': {
    en: 'Platform / Method',
    id: 'Platform / Metode',
    ms: 'Platform / Kaedah',
    th: 'แพลตฟอร์ม / วิธีการ',
    vi: 'Nền tảng / Phương thức',
    fil: 'Platform / Paraan',
    km: 'វេទិកា / វិធីសាស្ត្រ',
    lo: 'ແພລດຟອມ / ວິທີການ',
    my: 'ပလက်ဖောင်း / နည်းလမ်း',
  },
  'generator.form.amount': {
    en: 'Amount Lost (if any)',
    id: 'Jumlah Kerugian (jika ada)',
    ms: 'Jumlah Kerugian (jika ada)',
    th: 'จำนวนเงินที่สูญเสีย (ถ้ามี)',
    vi: 'Số tiền đã mất (nếu có)',
    fil: 'Halagang Nawala (kung mayroon)',
    km: 'ចំនួនទឹកប្រាក់ដែលបាត់បង់ (ប្រសិនបើមាន)',
    lo: 'ຈຳນວນເງິນທີ່ສູນເສຍ (ຖ້າມີ)',
    my: 'ဆုံးရှုံးငွေ ပမာဏ (ရှိလျှင်)',
  },
  'generator.form.description': {
    en: 'Description',
    id: 'Deskripsi',
    ms: 'Penerangan',
    th: 'คำอธิบาย',
    vi: 'Mô tả',
    fil: 'Paglalarawan',
    km: 'ការពិពណ៌នា',
    lo: 'ຄຳອະທິບາຍ',
    my: 'ဖော်ပြချက်',
  },
  'generator.selectType': {
    en: 'Select scam type...',
    id: 'Pilih jenis penipuan...',
    ms: 'Pilih jenis penipuan...',
    th: 'เลือกประเภทการหลอกลวง...',
    vi: 'Chọn loại lừa đảo...',
    fil: 'Pumili ng uri ng scam...',
    km: 'ជ្រើសរើសប្រភេទការបោកប្រាស់...',
    lo: 'ເລືອກປະເພດການຫຼອກລວງ...',
    my: 'လိမ်လည်မှု အမျိုးအစား ရွေးပါ...',
  },
  'generator.scamType.socialEngineering': {
    en: 'Social Engineering',
    id: 'Rekayasa Sosial',
    ms: 'Kejuruteraan Sosial',
    th: 'วิศวกรรมสังคม',
    vi: 'Kỹ thuật xã hội',
    fil: 'Social Engineering',
    km: 'វិស្វកម្មសង្គម',
    lo: 'ວິສະວະກຳສັງຄົມ',
    my: 'လူမှုအင်ဂျင်နီယာ',
  },
  'generator.scamType.investment': {
    en: 'Investment Scam',
    id: 'Penipuan Investasi',
    ms: 'Penipuan Pelaburan',
    th: 'การหลอกลวงการลงทุน',
    vi: 'Lừa đảo đầu tư',
    fil: 'Investment Scam',
    km: 'ការបោកប្រាស់ការវិនិយោគ',
    lo: 'ການຫຼອກລວງການລົງທຶນ',
    my: 'ရင်းနှီးမြှုပ်နှံမှု လိမ်လည်ခြင်း',
  },
  'generator.scamType.job': {
    en: 'Job Scam',
    id: 'Penipuan Lowongan Kerja',
    ms: 'Penipuan Pekerjaan',
    th: 'การหลอกลวงงาน',
    vi: 'Lừa đảo việc làm',
    fil: 'Job Scam',
    km: 'ការបោកប្រាស់ការងារ',
    lo: 'ການຫຼອກລວງວຽກງານ',
    my: 'အလုပ်လိမ်လည်မှု',
  },
  'generator.scamType.phishing': {
    en: 'Phishing',
    id: 'Phishing',
    ms: 'Phishing',
    th: 'ฟิชชิ่ง',
    vi: 'Lừa đảo qua mạng',
    fil: 'Phishing',
    km: 'ហ្វីស៊ីង',
    lo: 'ຟິຊຊິງ',
    my: 'ဖစ်ရှင်း',
  },
  'generator.scamType.ecommerce': {
    en: 'E-commerce Scam',
    id: 'Penipuan E-commerce',
    ms: 'Penipuan E-dagang',
    th: 'การหลอกลวงอีคอมเมิร์ซ',
    vi: 'Lừa đảo thương mại điện tử',
    fil: 'E-commerce Scam',
    km: 'ការបោកប្រាស់ពាណិជ្ជកម្មអេឡិចត្រូនិក',
    lo: 'ການຫຼອກລວງອີຄອມເມີຊ',
    my: 'အီး-ကောမတ်စ် လိမ်လည်မှု',
  },
  'generator.scamType.identity': {
    en: 'Identity Theft',
    id: 'Pencurian Identitas',
    ms: 'Kecurian Identiti',
    th: 'การขโมยข้อมูลประจำตัว',
    vi: 'Trộm cắp danh tính',
    fil: 'Pagnanakaw ng Pagkakakilanlan',
    km: 'ការលួចអត្តសញ្ញាណ',
    lo: 'ການລັກຕົວຕົນ',
    my: 'အထောက်အထား ခိုးယူမှု',
  },
  'generator.placeholder.platform': {
    en: 'e.g., WhatsApp, Facebook, Email',
    id: 'mis., WhatsApp, Facebook, Email',
    ms: 'cth., WhatsApp, Facebook, E-mel',
    th: 'เช่น WhatsApp, Facebook, อีเมล',
    vi: 'ví dụ: WhatsApp, Facebook, Email',
    fil: 'hal., WhatsApp, Facebook, Email',
    km: 'ឧទាហរណ៍ WhatsApp, Facebook, អ៊ីមែល',
    lo: 'ເຊັ່ນ: WhatsApp, Facebook, ອີເມວ',
    my: 'ဥပမာ - WhatsApp, Facebook, အီးမေးလ်',
  },
  'generator.placeholder.amount': {
    en: 'e.g., $500, Rp 5.000.000',
    id: 'mis., $500, Rp 5.000.000',
    ms: 'cth., $500, RM 2,000',
    th: 'เช่น $500, ฿15,000',
    vi: 'ví dụ: $500, 10.000.000 VNĐ',
    fil: 'hal., $500, ₱25,000',
    km: 'ឧទាហរណ៍ $500, ៛2,000,000',
    lo: 'ເຊັ່ນ: $500, ₭10,000,000',
    my: 'ဥပမာ - $500, 1,000,000 ကျပ်',
  },
  'generator.placeholder.description': {
    en: 'Describe what happened in detail...',
    id: 'Jelaskan apa yang terjadi secara rinci...',
    ms: 'Terangkan apa yang berlaku secara terperinci...',
    th: 'อธิบายสิ่งที่เกิดขึ้นโดยละเอียด...',
    vi: 'Mô tả chi tiết những gì đã xảy ra...',
    fil: 'Ilarawan nang detalyado ang nangyari...',
    km: 'ពណ៌នាអំពីអ្វីដែលបានកើតឡើងយ៉ាងលម្អិត...',
    lo: 'ອະທິບາຍສິ່ງທີ່ເກີດຂຶ້ນຢ່າງລະອຽດ...',
    my: 'ဖြစ်ပျက်ခဲ့သည်ကို အသေးစိတ် ဖော်ပြပါ...',
  },
  'generator.generateBtn': {
    en: 'Generate Template',
    id: 'Buat Templat',
    ms: 'Hasilkan Templat',
    th: 'สร้างเทมเพลต',
    vi: 'Tạo mẫu',
    fil: 'Bumuo ng Template',
    km: 'បង្កើតគំរូ',
    lo: 'ສ້າງແບບຟອມ',
    my: 'ပုံစံခွက် ထုတ်လုပ်ရန်',
  },
  'generator.output.title': {
    en: 'Generated Report',
    id: 'Laporan yang Dibuat',
    ms: 'Laporan Dihasilkan',
    th: 'รายงานที่สร้างขึ้น',
    vi: 'Báo cáo đã tạo',
    fil: 'Nabuong Ulat',
    km: 'របាយការណ៍ដែលបានបង្កើត',
    lo: 'ລາຍງານທີ່ສ້າງຂຶ້ນ',
    my: 'ထုတ်လုပ်လိုက်သော တိုင်ကြားစာ',
  },
  'generator.copyBtn': {
    en: 'Copy to Clipboard',
    id: 'Salin ke Papan Klip',
    ms: 'Salin ke Papan Keratan',
    th: 'คัดลอกไปยังคลิปบอร์ด',
    vi: 'Sao chép vào khay nhớ tạm',
    fil: 'Kopyahin sa Clipboard',
    km: 'ចម្លងទៅក្ដារតម្បៀតខ្ទាស់',
    lo: 'ຄັດລອກໄປທີ່ຄລິບບອດ',
    my: 'Clipboard သို့ ကူးယူရန်',
  },
  'generator.copiedBtn': {
    en: 'Copied!',
    id: 'Disalin!',
    ms: 'Disalin!',
    th: 'คัดลอกแล้ว!',
    vi: 'Đã sao chép!',
    fil: 'Nakopya!',
    km: 'បានចម្លង!',
    lo: 'ຄັດລອກແລ້ວ!',
    my: 'ကူးယူပြီး!',
  },
  'generator.emptyState': {
    en: 'Fill out the form to generate your report template.',
    id: 'Isi formulir untuk membuat templat laporan Anda.',
    ms: 'Isi borang untuk menghasilkan templat laporan anda.',
    th: 'กรอกแบบฟอร์มเพื่อสร้างเทมเพลตรายงานของคุณ',
    vi: 'Điền vào biểu mẫu để tạo mẫu báo cáo của bạn.',
    fil: 'Punan ang form upang mabuo ang iyong template ng ulat.',
    km: 'បំពេញទម្រង់បែបបទដើម្បីបង្កើតគំរូរបាយការណ៍របស់អ្នក។',
    lo: 'ຕື່ມຂໍ້ມູນໃສ່ແບບຟອມເພື່ອສ້າງແບບຟອມລາຍງານຂອງທ່ານ.',
    my: 'သင့်တိုင်ကြားစာ ပုံစံခွက် ထုတ်လုပ်ရန် ဖောင်ဖြည့်ပါ။',
  },
  'generator.templateNote': {
    en: 'This is a template only. Please review and add specific details before submitting to authorities.',
    id: 'Ini hanya templat. Harap tinjau dan tambahkan detail spesifik sebelum menyerahkan ke pihak berwenang.',
    ms: 'Ini hanya templat. Sila semak dan tambah butiran khusus sebelum menyerahkan kepada pihak berkuasa.',
    th: 'นี่เป็นเพียงเทมเพลต โปรดตรวจสอบและเพิ่มรายละเอียดเฉพาะก่อนส่งให้เจ้าหน้าที่',
    vi: 'Đây chỉ là một mẫu. Vui lòng xem lại và thêm chi tiết cụ thể trước khi gửi cho cơ quan chức năng.',
    fil: 'Ito ay isang template lamang. Pakisuri at magdagdag ng mga partikular na detalye bago isumite sa mga awtoridad.',
    km: 'នេះគ្រាន់តែជាគំរូប៉ុណ្ណោះ។ សូមពិនិត្យមើល និងបន្ថែមព័ត៌មានលម្អិតជាក់លាក់ មុនពេលដាក់ជូនអាជ្ញាធរ។',
    lo: 'ນີ້ແມ່ນພຽງແຕ່ແບບຟອມ. ກະລຸນາກວດເບິ່ງ ແລະ ເພີ່ມລາຍລະອຽດສະເພາະກ່ອນສົ່ງໃຫ້ເຈົ້າໜ້າທີ່.',
    my: 'ဒါက ပုံစံခွက်တစ်ခုသာ ဖြစ်ပါတယ်။ အာဏာပိုင်များထံ မတင်ပြမီ ပြန်လည်သုံးသပ်ပြီး အသေးစိတ်အချက်အလက်များကို ထည့်သွင်းပါ။',
  },
}
